//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * @return Success
     */
    getGames(): Promise<GetGamesCommandResponse>;
    /**
     * @return Success
     */
    getActiveGames(): Promise<GetActiveGamesCommandResponse>;
    /**
     * @return Success
     */
    getLastSinglePlayerGame(): Promise<GetLastSinglePlayerGameCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveBoard(body: SaveBoardCommandRequest | undefined): Promise<SaveBoardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveVsTurn(body: SaveTurnCommandRequest | undefined): Promise<SaveTurnCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBoardByGameId(body: GetBoardByGameIdCommandRequest | undefined): Promise<GetBoardByGameIdCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateGameStatus(body: UpdateGameStatusCommandRequest | undefined): Promise<UpdateGameStatusCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getGameSummaryByGameIdCommand(body: GetGameSummaryByGameIdCommandRequest | undefined): Promise<GetGameSummaryByGameIdCommandResponse>;
    /**
     * @return Success
     */
    getAllGameSummariesForPlayerCommand(): Promise<GetAllGameSummariesForPlayerCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    generateBoard(body: GenerateBoardCommandRequest | undefined): Promise<GenerateBoardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAvailablePlays(body: GetAvailablePlaysCommandRequest | undefined): Promise<GetAvailablePlaysCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBoardSolution(body: SolveBoardCommandRequest | undefined): Promise<SolveBoardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    queryShareGameResult(body: QueryShareRewardCommandRequest | undefined): Promise<QueryShareRewardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBotGame(body: GetBotGameCommandRequest | undefined): Promise<GetBotGameCommandResponse>;
    /**
     * @return Success
     */
    getDailyGame(): Promise<GetDailyGameCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitDailyGame(body: SubmitDailyGameCommandRequest | undefined): Promise<SubmitDailyGameCommandResponse>;
    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getMonthlyDailyChallenges(month: number | undefined, year: number | undefined): Promise<GetMonthlyDailyChallengesCommandResponse>;
    /**
     * @param date (optional) 
     * @return Success
     */
    getDailyChallenge(date: string | undefined): Promise<GetDailyChallengeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    ensureDailyGameAccess(body: EnsureDailyGameAccessCommandRequest | undefined): Promise<EnsureDailyGameAccessCommandResponse>;
    /**
     * @param dailyGameId (optional) 
     * @return Success
     */
    getDailyChallengeAccess(dailyGameId: string | undefined): Promise<GetDailyChallengeAccessCommandResponse>;
    /**
     * @return Success
     */
    deleteAccount(): Promise<RequestAccountDeletionCommandResponse>;
    /**
     * @return Success
     */
    getPrivacyPolicyPDF(): Promise<GetFileQueryResponse>;
    /**
     * @return Success
     */
    getPrivacyPolicyText(): Promise<void>;
    /**
     * @return Success
     */
    getPrivacyPolicyText_alt(): Promise<void>;
    /**
     * @return Success
     */
    getTermsAndConditionsPDF(): Promise<GetFileQueryResponse>;
    /**
     * @return Success
     */
    getTermsAndConditionsText(): Promise<void>;
    /**
     * @return Success
     */
    getTermsAndConditionsText_alt(): Promise<void>;
    /**
     * @return Success
     */
    howToPlayText(): Promise<void>;
    /**
     * @return Success
     */
    getEulaPDF(): Promise<GetFileQueryResponse>;
    /**
     * @return Success
     */
    getEulaText(): Promise<void>;
    /**
     * @param boardString (optional) 
     * @return Success
     */
    v2(gameId: string, userId: string, boardString: string | undefined): Promise<void>;
    /**
     * @return Success
     */
    getGame(gameId: string, userId: string): Promise<void>;
    /**
     * @param boardString (optional) 
     * @return Success
     */
    gamehelper(gameId: string, userId: string, boardString: string | undefined): Promise<void>;
    /**
     * @param userId (optional) 
     * @param botToken (optional) 
     * @return Success
     */
    serviceBotGame(gameId: string, userId: string | undefined, botToken: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    query(body: KnowledgeBotQueryCommandRequest | undefined): Promise<KnowledgeBotQueryCommandResponse>;
    /**
     * @return Success
     */
    getAllNotifications(): Promise<GetAllPlayerNotificationCommandResponse>;
    /**
     * @return Success
     */
    getUnreadNotifications(): Promise<GetUnreadNotificationsCommandResponse>;
    /**
     * @return Success
     */
    getAllAchievements(): Promise<GetAllAchievementsCommandResponse>;
    /**
     * @return Success
     */
    getAllAchievementsQuery(): Promise<GetAllAchievementsQueryCommandResponse>;
    /**
     * @return Success
     */
    getAchievementsMilestones(): Promise<GetAchievementsMilestonesResponse>;
    /**
     * @return Success
     */
    getAchievementsStreaks(): Promise<GetAchievementsStreaksResponse>;
    /**
     * @return Success
     */
    getAchievementsSocial(): Promise<GetAchievementsSocialResponse>;
    /**
     * @return Success
     */
    readNotification(notificationId: string): Promise<ReadNotificationCommandResponse>;
    /**
     * @return Success
     */
    readAllNotifications(): Promise<ReadAllNotificationsCommandResponse>;
    /**
     * @return Success
     */
    claimReward(rewardId: string): Promise<ClaimRewardCommandResponse>;
    /**
     * @return Success
     */
    claimAllRewards(): Promise<ClaimAllRewardsCommandResponse>;
    /**
     * @return Success
     */
    getRewardProgress(): Promise<GetRewardProgressCommandResponse>;
    /**
     * @return Success
     */
    getRewardProgressWithAchievement(): Promise<GetRewardProgressWithAchievementCommandResponse>;
    /**
     * @return Success
     */
    getAllSpecialRewards(): Promise<GetAllSpecialRewardsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSpecialRewardByMilestoneKey(body: GetSpecialRewardCommandRequest | undefined): Promise<GetSpecialRewardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguage(body: UpdateLanguageCommandRequest | undefined): Promise<UpdateLanguageCommandResponse>;
    /**
     * @return Success
     */
    getMoreTimeAdStatGET(): Promise<GetAdsMoreTimeStatsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getMoreTimeAdStatPOST(body: GetAdsMoreTimeStatsRequest | undefined): Promise<GetAdsMoreTimeStatsResponse>;
    /**
     * @return Success
     */
    getBoardAdStatGET(): Promise<GetAdsBoardStatsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBoardAdStatPOST(body: GetAdsBoardStatsRequest | undefined): Promise<GetAdsBoardStatsResponse>;
    /**
     * @return Success
     */
    getHintAdStatGET(): Promise<GetAdsHintStatsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getHintAdStatPOST(body: GetAdsHintStatsRequest | undefined): Promise<GetAdsHintStatsResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    incrementMoreTimeAdWatch(body: IncrementAdsWatchMoreTimeCommandRequest | undefined): Promise<IncrementAdsWatchMoreTimeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    incrementBoardAdWatch(body: IncrementAdsWatchBoardCommandRequest | undefined): Promise<IncrementAdsWatchBoardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    incrementHintAdWatch(body: IncrementAdsWatchHintCommandRequest | undefined): Promise<IncrementAdsWatchHintCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resetBoardAdStat(body: ResetAdStatsBoardCommandRequest | undefined): Promise<ResetAdStatsBoardCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resetHintAdStat(body: ResetAdStatsHintCommandRequest | undefined): Promise<ResetAdStatsHintCommandResponse>;
    /**
     * @param platform (optional) 
     * @param appVersion (optional) 
     * @return Success
     */
    checkAppVersion(platform: string | undefined, appVersion: string | undefined): Promise<CheckAppVersionResponse>;
    /**
     * @return Success
     */
    getPlayers(): Promise<GetPlayersCommandResponse>;
    /**
     * @return Success
     */
    getSinglePlayerGameHistories(): Promise<GetSinglePlayerGameHistoryCommandResponse>;
    /**
     * @return Success
     */
    getPlayerPerformance(): Promise<GetPlayerPerformanceCommandResponse>;
    /**
     * @return Success
     */
    getBoards(): Promise<GetPlayerBoardCountQueryResponse>;
    /**
     * @return Success
     */
    getHints(): Promise<GetHintsCommandResponse>;
    /**
     * @return Success
     */
    getMoreTime(): Promise<GetMoreTimeCommandResponse>;
    /**
     * @return Success
     */
    generate(): Promise<FriendInviteCommandResponse>;
    /**
     * @return Success
     */
    getFriends(): Promise<GetPlayerFriendListQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveMoves(body: SaveMovesCommandRequest | undefined): Promise<SaveMovesCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    savePlayerGameStatistics(body: SavePlayerGameStatsCommandRequest | undefined): Promise<SavePlayerGameStatsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayerStatisticsById(body: GetPlayerStatisticsByIdCommandRequest | undefined): Promise<GetPlayerStatisticsByIdCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    searchForPlayer(body: GetPlayerSearchQueryRequest | undefined): Promise<GetPlayerSearchQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addBoards(body: AddPlayerBoardCountCommandRequest | undefined): Promise<AddPlayerBoardCountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeBoards(body: SubtractPlayerBoardCountCommandRequest | undefined): Promise<SubtractPlayerBoardCountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateBoards(body: UpdatePlayerBoardCountCommandRequest | undefined): Promise<UpdatePlayerBoardCountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addHints(body: AddHintsCommandRequest | undefined): Promise<AddHintsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeHints(body: RemoveHintsCommandRequest | undefined): Promise<RemoveHintsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateHints(body: UpdateHintsCommandRequest | undefined): Promise<UpdateHintsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addMoreTime(body: AddMoreTimeCommandRequest | undefined): Promise<AddMoreTimeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeMoreTime(body: RemoveMoreTimeCommandRequest | undefined): Promise<RemoveMoreTimeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateMoreTime(body: UpdateMoreTimeCommandRequest | undefined): Promise<UpdateMoreTimeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getHintForCell(body: GetHintForCellCommandRequest | undefined): Promise<GetHintForCellCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendRequest(body: SendFriendRequestCommandRequest | undefined): Promise<SendFriendRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelRequest(body: CancelFriendRequestCommandRequest | undefined): Promise<CancelFriendRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    acceptRequest(body: AcceptFriendRequestCommandRequest | undefined): Promise<AcceptFriendRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    rejectRequest(body: RejectFriendRequestCommandRequest | undefined): Promise<RejectFriendRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    remove(body: RemoveFriendCommandRequest | undefined): Promise<RemoveFriendCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    gameSummary(body: GetGameSummaryCommandRequest | undefined): Promise<GetGameSummaryCommandResponse>;
    /**
     * @return Success
     */
    enter(): Promise<RequestRandomGameCommandResponse>;
    /**
     * @return Success
     */
    cancelGET(): Promise<CancelPlayerQueueCommandResponse>;
    /**
     * @return Success
     */
    status(): Promise<GetPlayerQueueStatusCommandResponse>;
    /**
     * @return Success
     */
    queue(): Promise<GetCurrentMatchesCommandResponse>;
    /**
     * @return Success
     */
    currentQueue(): Promise<GetCurrentMatchesCommandResponseOld>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestRandomGame(body: RequestRandomGameCommandRequestOld | undefined): Promise<RequestRandomGameCommandResponseOld>;
    /**
     * @param body (optional) 
     * @return Success
     */
    acceptRandomGame(body: AcceptRandomGameRequestCommandRequest | undefined): Promise<AcceptRandomGameRequestCommandResponse>;
    /**
     * @return Success
     */
    getGameRequests(): Promise<GetGameRequestsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    acceptGameRequest(body: AcceptGameRequestCommandRequest | undefined): Promise<AcceptGameRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    rejectGameRequest(body: RejectGameRequestCommandRequest | undefined): Promise<RejectGameRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelGameRequest(body: CancelGameRequestCommandRequest | undefined): Promise<CancelGameRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendGameRequest(body: SendGameRequestCommandRequest | undefined): Promise<SendGameRequestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resignFromGame(body: ResignFromGameCommandRequest | undefined): Promise<ResignFromGameCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    compareFriendStats(body: CompareFriendStatsCommandRequest | undefined): Promise<CompareFriendStatsCommandResponse>;
    /**
     * @return Success
     */
    getVsStats(): Promise<GetVsStatsCommandResponse>;
    /**
     * @return Success
     */
    getLeaderboards(): Promise<GetLeaderboardsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveCountryCode(body: SaveCountryCodeCommandRequest | undefined): Promise<SaveCountryCodeCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    checkIfUsernameAvailable(body: GetAvailableUsernameSearchQueryRequest | undefined): Promise<GetAvailableUsernameSearchQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateUsername(body: UpdateUsernameCommandRequest | undefined): Promise<UpdateUsernameCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayerInfo(body: GetPlayerInfoByIdCommandRequest | undefined): Promise<GetPlayerInfoByIdCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlayerIcon(body: UpdateUserIconCommandRequest | undefined): Promise<UpdateUserIconCommandResponse>;
    /**
     * @param lang (optional) 
     * @return Success
     */
    getActive(lang: string | undefined): Promise<GetPublicPromotionsCommandResponse>;
    /**
     * @return Success
     */
    logout(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    deletePlayerData(body: DeletePlayerDataCommandRequest | undefined): Promise<DeletePlayerDataCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterCommandRequest | undefined): Promise<RegisterResponseModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerApple(body: RegisterAppleCommandRequest | undefined): Promise<RegisterResponseModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerGuest(body: RegisterGuestCommandRequest | undefined): Promise<RegisterGuestResponseModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestDeletePlayerData(body: RequestDeletePlayerDataCommandRequest | undefined): Promise<RequestDeletePlayerDataCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    linkGuestAccount(body: LinkGuestAccountCommandRequest | undefined): Promise<LinkGuestAccountCommandResponse>;
    /**
     * @return Success
     */
    getLinkedAccounts(): Promise<GetLinkedAccountsQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addLinkedAccount(body: AddLinkedAccountCommandRequest | undefined): Promise<AddLinkedAccountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(body: EditUserProfileCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserPassword(body: ChangePasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateMarketingOptIn(body: UpdateMarketingOptInCommandRequest | undefined): Promise<void>;
    /**
     * @return Success
     */
    pingUser(): Promise<void>;
    /**
     * @return Success
     */
    getProducts(): Promise<GetProductsCommandResponse>;
    /**
     * @return Success
     */
    restorePurchases(): Promise<RestorePurchasesCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: AddProductCommandRequest | undefined): Promise<AddProductCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    purchase(body: PurchaseProductCommandRequest | undefined): Promise<PurchaseProductCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPOST(body: CancelSubscriptionCommandRequest | undefined): Promise<CancelSubscriptionCommandResponse>;
    /**
     * @param lang (optional) 
     * @return Success
     */
    getActive2(lang: string | undefined): Promise<GetPublicTutorialsCommandResponse>;
}

export class Client implements IClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getGames( cancelToken?: CancelToken): Promise<GetGamesCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetGames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGames(_response);
        });
    }

    protected processGetGames(response: AxiosResponse): Promise<GetGamesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGamesCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetGamesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGamesCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getActiveGames( cancelToken?: CancelToken): Promise<GetActiveGamesCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetActiveGames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveGames(_response);
        });
    }

    protected processGetActiveGames(response: AxiosResponse): Promise<GetActiveGamesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetActiveGamesCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetActiveGamesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetActiveGamesCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getLastSinglePlayerGame( cancelToken?: CancelToken): Promise<GetLastSinglePlayerGameCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetLastSinglePlayerGame";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastSinglePlayerGame(_response);
        });
    }

    protected processGetLastSinglePlayerGame(response: AxiosResponse): Promise<GetLastSinglePlayerGameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLastSinglePlayerGameCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetLastSinglePlayerGameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLastSinglePlayerGameCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBoard(body: SaveBoardCommandRequest | undefined, cancelToken?: CancelToken): Promise<SaveBoardCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/SaveBoard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBoard(_response);
        });
    }

    protected processSaveBoard(response: AxiosResponse): Promise<SaveBoardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveBoardCommandResponse.fromJS(resultData200);
            return Promise.resolve<SaveBoardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveBoardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveVsTurn(body: SaveTurnCommandRequest | undefined, cancelToken?: CancelToken): Promise<SaveTurnCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/SaveVsTurn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveVsTurn(_response);
        });
    }

    protected processSaveVsTurn(response: AxiosResponse): Promise<SaveTurnCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveTurnCommandResponse.fromJS(resultData200);
            return Promise.resolve<SaveTurnCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveTurnCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBoardByGameId(body: GetBoardByGameIdCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetBoardByGameIdCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetBoardByGameId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardByGameId(_response);
        });
    }

    protected processGetBoardByGameId(response: AxiosResponse): Promise<GetBoardByGameIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBoardByGameIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetBoardByGameIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBoardByGameIdCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGameStatus(body: UpdateGameStatusCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdateGameStatusCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/UpdateGameStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGameStatus(_response);
        });
    }

    protected processUpdateGameStatus(response: AxiosResponse): Promise<UpdateGameStatusCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateGameStatusCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateGameStatusCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateGameStatusCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGameSummaryByGameIdCommand(body: GetGameSummaryByGameIdCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetGameSummaryByGameIdCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetGameSummaryByGameIdCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameSummaryByGameIdCommand(_response);
        });
    }

    protected processGetGameSummaryByGameIdCommand(response: AxiosResponse): Promise<GetGameSummaryByGameIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGameSummaryByGameIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetGameSummaryByGameIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGameSummaryByGameIdCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllGameSummariesForPlayerCommand( cancelToken?: CancelToken): Promise<GetAllGameSummariesForPlayerCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetAllGameSummariesForPlayerCommand";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllGameSummariesForPlayerCommand(_response);
        });
    }

    protected processGetAllGameSummariesForPlayerCommand(response: AxiosResponse): Promise<GetAllGameSummariesForPlayerCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllGameSummariesForPlayerCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllGameSummariesForPlayerCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllGameSummariesForPlayerCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateBoard(body: GenerateBoardCommandRequest | undefined, cancelToken?: CancelToken): Promise<GenerateBoardCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GenerateBoard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateBoard(_response);
        });
    }

    protected processGenerateBoard(response: AxiosResponse): Promise<GenerateBoardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateBoardCommandResponse.fromJS(resultData200);
            return Promise.resolve<GenerateBoardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateBoardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAvailablePlays(body: GetAvailablePlaysCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetAvailablePlaysCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetAvailablePlays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailablePlays(_response);
        });
    }

    protected processGetAvailablePlays(response: AxiosResponse): Promise<GetAvailablePlaysCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAvailablePlaysCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAvailablePlaysCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAvailablePlaysCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBoardSolution(body: SolveBoardCommandRequest | undefined, cancelToken?: CancelToken): Promise<SolveBoardCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/GetBoardSolution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardSolution(_response);
        });
    }

    protected processGetBoardSolution(response: AxiosResponse): Promise<SolveBoardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SolveBoardCommandResponse.fromJS(resultData200);
            return Promise.resolve<SolveBoardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SolveBoardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryShareGameResult(body: QueryShareRewardCommandRequest | undefined, cancelToken?: CancelToken): Promise<QueryShareRewardCommandResponse> {
        let url_ = this.baseUrl + "/api/Board/QueryShareGameResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryShareGameResult(_response);
        });
    }

    protected processQueryShareGameResult(response: AxiosResponse): Promise<QueryShareRewardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryShareRewardCommandResponse.fromJS(resultData200);
            return Promise.resolve<QueryShareRewardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryShareRewardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBotGame(body: GetBotGameCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetBotGameCommandResponse> {
        let url_ = this.baseUrl + "/api/Bot/GetBotGame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBotGame(_response);
        });
    }

    protected processGetBotGame(response: AxiosResponse): Promise<GetBotGameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBotGameCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetBotGameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBotGameCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyGame( cancelToken?: CancelToken): Promise<GetDailyGameCommandResponse> {
        let url_ = this.baseUrl + "/api/DailyGame/GetDailyGame";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyGame(_response);
        });
    }

    protected processGetDailyGame(response: AxiosResponse): Promise<GetDailyGameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyGameCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyGameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyGameCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitDailyGame(body: SubmitDailyGameCommandRequest | undefined, cancelToken?: CancelToken): Promise<SubmitDailyGameCommandResponse> {
        let url_ = this.baseUrl + "/api/DailyGame/SubmitDailyGame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitDailyGame(_response);
        });
    }

    protected processSubmitDailyGame(response: AxiosResponse): Promise<SubmitDailyGameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitDailyGameCommandResponse.fromJS(resultData200);
            return Promise.resolve<SubmitDailyGameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitDailyGameCommandResponse>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getMonthlyDailyChallenges(month: number | undefined, year: number | undefined, cancelToken?: CancelToken): Promise<GetMonthlyDailyChallengesCommandResponse> {
        let url_ = this.baseUrl + "/api/DailyGame/GetMonthlyDailyChallenges?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthlyDailyChallenges(_response);
        });
    }

    protected processGetMonthlyDailyChallenges(response: AxiosResponse): Promise<GetMonthlyDailyChallengesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMonthlyDailyChallengesCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetMonthlyDailyChallengesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMonthlyDailyChallengesCommandResponse>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    getDailyChallenge(date: string | undefined, cancelToken?: CancelToken): Promise<GetDailyChallengeCommandResponse> {
        let url_ = this.baseUrl + "/api/DailyGame/GetDailyChallenge?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyChallenge(_response);
        });
    }

    protected processGetDailyChallenge(response: AxiosResponse): Promise<GetDailyChallengeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyChallengeCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyChallengeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyChallengeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ensureDailyGameAccess(body: EnsureDailyGameAccessCommandRequest | undefined, cancelToken?: CancelToken): Promise<EnsureDailyGameAccessCommandResponse> {
        let url_ = this.baseUrl + "/api/DailyGame/EnsureDailyGameAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnsureDailyGameAccess(_response);
        });
    }

    protected processEnsureDailyGameAccess(response: AxiosResponse): Promise<EnsureDailyGameAccessCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnsureDailyGameAccessCommandResponse.fromJS(resultData200);
            return Promise.resolve<EnsureDailyGameAccessCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnsureDailyGameAccessCommandResponse>(null as any);
    }

    /**
     * @param dailyGameId (optional) 
     * @return Success
     */
    getDailyChallengeAccess(dailyGameId: string | undefined, cancelToken?: CancelToken): Promise<GetDailyChallengeAccessCommandResponse> {
        let url_ = this.baseUrl + "/api/DailyGame/GetDailyChallengeAccess?";
        if (dailyGameId === null)
            throw new Error("The parameter 'dailyGameId' cannot be null.");
        else if (dailyGameId !== undefined)
            url_ += "DailyGameId=" + encodeURIComponent("" + dailyGameId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyChallengeAccess(_response);
        });
    }

    protected processGetDailyChallengeAccess(response: AxiosResponse): Promise<GetDailyChallengeAccessCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyChallengeAccessCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyChallengeAccessCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyChallengeAccessCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteAccount( cancelToken?: CancelToken): Promise<RequestAccountDeletionCommandResponse> {
        let url_ = this.baseUrl + "/api/Deletion/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount(_response);
        });
    }

    protected processDeleteAccount(response: AxiosResponse): Promise<RequestAccountDeletionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestAccountDeletionCommandResponse.fromJS(resultData200);
            return Promise.resolve<RequestAccountDeletionCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestAccountDeletionCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPrivacyPolicyPDF( cancelToken?: CancelToken): Promise<GetFileQueryResponse> {
        let url_ = this.baseUrl + "/api/Document/GetPrivacyPolicyPDF";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrivacyPolicyPDF(_response);
        });
    }

    protected processGetPrivacyPolicyPDF(response: AxiosResponse): Promise<GetFileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFileQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPrivacyPolicyText( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Document/GetPrivacyPolicyText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrivacyPolicyText(_response);
        });
    }

    protected processGetPrivacyPolicyText(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getPrivacyPolicyText_alt( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Document/GetPrivacyPolicyText_alt";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrivacyPolicyText_alt(_response);
        });
    }

    protected processGetPrivacyPolicyText_alt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTermsAndConditionsPDF( cancelToken?: CancelToken): Promise<GetFileQueryResponse> {
        let url_ = this.baseUrl + "/api/Document/GetTermsAndConditionsPDF";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermsAndConditionsPDF(_response);
        });
    }

    protected processGetTermsAndConditionsPDF(response: AxiosResponse): Promise<GetFileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFileQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTermsAndConditionsText( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Document/GetTermsAndConditionsText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermsAndConditionsText(_response);
        });
    }

    protected processGetTermsAndConditionsText(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTermsAndConditionsText_alt( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Document/GetTermsAndConditionsText_alt";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermsAndConditionsText_alt(_response);
        });
    }

    protected processGetTermsAndConditionsText_alt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    howToPlayText( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Document/HowToPlayText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHowToPlayText(_response);
        });
    }

    protected processHowToPlayText(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getEulaPDF( cancelToken?: CancelToken): Promise<GetFileQueryResponse> {
        let url_ = this.baseUrl + "/api/Document/GetEulaPDF";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEulaPDF(_response);
        });
    }

    protected processGetEulaPDF(response: AxiosResponse): Promise<GetFileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetFileQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEulaText( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Document/GetEulaText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEulaText(_response);
        });
    }

    protected processGetEulaText(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param boardString (optional) 
     * @return Success
     */
    v2(gameId: string, userId: string, boardString: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ws/GetGame/v2/{gameId}?";
        if (gameId === undefined || gameId === null)
            throw new Error("The parameter 'gameId' must be defined.");
        url_ = url_.replace("{gameId}", encodeURIComponent("" + gameId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (boardString === null)
            throw new Error("The parameter 'boardString' cannot be null.");
        else if (boardString !== undefined)
            url_ += "boardString=" + encodeURIComponent("" + boardString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processV2(_response);
        });
    }

    protected processV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getGame(gameId: string, userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ws/GetGame/{gameId}?";
        if (gameId === undefined || gameId === null)
            throw new Error("The parameter 'gameId' must be defined.");
        url_ = url_.replace("{gameId}", encodeURIComponent("" + gameId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGame(_response);
        });
    }

    protected processGetGame(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param boardString (optional) 
     * @return Success
     */
    gamehelper(gameId: string, userId: string, boardString: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ws/Gamehelper/{gameId}?";
        if (gameId === undefined || gameId === null)
            throw new Error("The parameter 'gameId' must be defined.");
        url_ = url_.replace("{gameId}", encodeURIComponent("" + gameId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (boardString === null)
            throw new Error("The parameter 'boardString' cannot be null.");
        else if (boardString !== undefined)
            url_ += "boardString=" + encodeURIComponent("" + boardString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGamehelper(_response);
        });
    }

    protected processGamehelper(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param botToken (optional) 
     * @return Success
     */
    serviceBotGame(gameId: string, userId: string | undefined, botToken: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ws/ServiceBotGame/{gameId}?";
        if (gameId === undefined || gameId === null)
            throw new Error("The parameter 'gameId' must be defined.");
        url_ = url_.replace("{gameId}", encodeURIComponent("" + gameId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (botToken === null)
            throw new Error("The parameter 'botToken' cannot be null.");
        else if (botToken !== undefined)
            url_ += "botToken=" + encodeURIComponent("" + botToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processServiceBotGame(_response);
        });
    }

    protected processServiceBotGame(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    query(body: KnowledgeBotQueryCommandRequest | undefined, cancelToken?: CancelToken): Promise<KnowledgeBotQueryCommandResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBot/Query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<KnowledgeBotQueryCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KnowledgeBotQueryCommandResponse.fromJS(resultData200);
            return Promise.resolve<KnowledgeBotQueryCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KnowledgeBotQueryCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllNotifications( cancelToken?: CancelToken): Promise<GetAllPlayerNotificationCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAllNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllNotifications(_response);
        });
    }

    protected processGetAllNotifications(response: AxiosResponse): Promise<GetAllPlayerNotificationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllPlayerNotificationCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllPlayerNotificationCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPlayerNotificationCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUnreadNotifications( cancelToken?: CancelToken): Promise<GetUnreadNotificationsCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetUnreadNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnreadNotifications(_response);
        });
    }

    protected processGetUnreadNotifications(response: AxiosResponse): Promise<GetUnreadNotificationsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUnreadNotificationsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetUnreadNotificationsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUnreadNotificationsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllAchievements( cancelToken?: CancelToken): Promise<GetAllAchievementsCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAllAchievements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAchievements(_response);
        });
    }

    protected processGetAllAchievements(response: AxiosResponse): Promise<GetAllAchievementsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAchievementsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllAchievementsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAchievementsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllAchievementsQuery( cancelToken?: CancelToken): Promise<GetAllAchievementsQueryCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAllAchievementsQuery";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAchievementsQuery(_response);
        });
    }

    protected processGetAllAchievementsQuery(response: AxiosResponse): Promise<GetAllAchievementsQueryCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAchievementsQueryCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllAchievementsQueryCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAchievementsQueryCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAchievementsMilestones( cancelToken?: CancelToken): Promise<GetAchievementsMilestonesResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAchievementsMilestones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAchievementsMilestones(_response);
        });
    }

    protected processGetAchievementsMilestones(response: AxiosResponse): Promise<GetAchievementsMilestonesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAchievementsMilestonesResponse.fromJS(resultData200);
            return Promise.resolve<GetAchievementsMilestonesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAchievementsMilestonesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAchievementsStreaks( cancelToken?: CancelToken): Promise<GetAchievementsStreaksResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAchievementsStreaks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAchievementsStreaks(_response);
        });
    }

    protected processGetAchievementsStreaks(response: AxiosResponse): Promise<GetAchievementsStreaksResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAchievementsStreaksResponse.fromJS(resultData200);
            return Promise.resolve<GetAchievementsStreaksResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAchievementsStreaksResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAchievementsSocial( cancelToken?: CancelToken): Promise<GetAchievementsSocialResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAchievementsSocial";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAchievementsSocial(_response);
        });
    }

    protected processGetAchievementsSocial(response: AxiosResponse): Promise<GetAchievementsSocialResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAchievementsSocialResponse.fromJS(resultData200);
            return Promise.resolve<GetAchievementsSocialResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAchievementsSocialResponse>(null as any);
    }

    /**
     * @return Success
     */
    readNotification(notificationId: string, cancelToken?: CancelToken): Promise<ReadNotificationCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/ReadNotification/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadNotification(_response);
        });
    }

    protected processReadNotification(response: AxiosResponse): Promise<ReadNotificationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReadNotificationCommandResponse.fromJS(resultData200);
            return Promise.resolve<ReadNotificationCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReadNotificationCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    readAllNotifications( cancelToken?: CancelToken): Promise<ReadAllNotificationsCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/ReadAllNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadAllNotifications(_response);
        });
    }

    protected processReadAllNotifications(response: AxiosResponse): Promise<ReadAllNotificationsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReadAllNotificationsCommandResponse.fromJS(resultData200);
            return Promise.resolve<ReadAllNotificationsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReadAllNotificationsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    claimReward(rewardId: string, cancelToken?: CancelToken): Promise<ClaimRewardCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/ClaimReward/{rewardId}";
        if (rewardId === undefined || rewardId === null)
            throw new Error("The parameter 'rewardId' must be defined.");
        url_ = url_.replace("{rewardId}", encodeURIComponent("" + rewardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaimReward(_response);
        });
    }

    protected processClaimReward(response: AxiosResponse): Promise<ClaimRewardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClaimRewardCommandResponse.fromJS(resultData200);
            return Promise.resolve<ClaimRewardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimRewardCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    claimAllRewards( cancelToken?: CancelToken): Promise<ClaimAllRewardsCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/ClaimAllRewards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaimAllRewards(_response);
        });
    }

    protected processClaimAllRewards(response: AxiosResponse): Promise<ClaimAllRewardsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClaimAllRewardsCommandResponse.fromJS(resultData200);
            return Promise.resolve<ClaimAllRewardsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimAllRewardsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRewardProgress( cancelToken?: CancelToken): Promise<GetRewardProgressCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetRewardProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRewardProgress(_response);
        });
    }

    protected processGetRewardProgress(response: AxiosResponse): Promise<GetRewardProgressCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRewardProgressCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetRewardProgressCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRewardProgressCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRewardProgressWithAchievement( cancelToken?: CancelToken): Promise<GetRewardProgressWithAchievementCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetRewardProgressWithAchievement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRewardProgressWithAchievement(_response);
        });
    }

    protected processGetRewardProgressWithAchievement(response: AxiosResponse): Promise<GetRewardProgressWithAchievementCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRewardProgressWithAchievementCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetRewardProgressWithAchievementCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRewardProgressWithAchievementCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllSpecialRewards( cancelToken?: CancelToken): Promise<GetAllSpecialRewardsCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetAllSpecialRewards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSpecialRewards(_response);
        });
    }

    protected processGetAllSpecialRewards(response: AxiosResponse): Promise<GetAllSpecialRewardsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllSpecialRewardsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllSpecialRewardsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllSpecialRewardsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSpecialRewardByMilestoneKey(body: GetSpecialRewardCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetSpecialRewardCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/GetSpecialRewardByMilestoneKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialRewardByMilestoneKey(_response);
        });
    }

    protected processGetSpecialRewardByMilestoneKey(response: AxiosResponse): Promise<GetSpecialRewardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSpecialRewardCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetSpecialRewardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSpecialRewardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguage(body: UpdateLanguageCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdateLanguageCommandResponse> {
        let url_ = this.baseUrl + "/api/Notification/UpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLanguage(_response);
        });
    }

    protected processUpdateLanguage(response: AxiosResponse): Promise<UpdateLanguageCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateLanguageCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateLanguageCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateLanguageCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMoreTimeAdStatGET( cancelToken?: CancelToken): Promise<GetAdsMoreTimeStatsResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/GetMoreTimeAdStat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMoreTimeAdStatGET(_response);
        });
    }

    protected processGetMoreTimeAdStatGET(response: AxiosResponse): Promise<GetAdsMoreTimeStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdsMoreTimeStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetAdsMoreTimeStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdsMoreTimeStatsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMoreTimeAdStatPOST(body: GetAdsMoreTimeStatsRequest | undefined, cancelToken?: CancelToken): Promise<GetAdsMoreTimeStatsResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/GetMoreTimeAdStat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMoreTimeAdStatPOST(_response);
        });
    }

    protected processGetMoreTimeAdStatPOST(response: AxiosResponse): Promise<GetAdsMoreTimeStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdsMoreTimeStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetAdsMoreTimeStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdsMoreTimeStatsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBoardAdStatGET( cancelToken?: CancelToken): Promise<GetAdsBoardStatsResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/GetBoardAdStat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardAdStatGET(_response);
        });
    }

    protected processGetBoardAdStatGET(response: AxiosResponse): Promise<GetAdsBoardStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdsBoardStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetAdsBoardStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdsBoardStatsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBoardAdStatPOST(body: GetAdsBoardStatsRequest | undefined, cancelToken?: CancelToken): Promise<GetAdsBoardStatsResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/GetBoardAdStat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoardAdStatPOST(_response);
        });
    }

    protected processGetBoardAdStatPOST(response: AxiosResponse): Promise<GetAdsBoardStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdsBoardStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetAdsBoardStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdsBoardStatsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getHintAdStatGET( cancelToken?: CancelToken): Promise<GetAdsHintStatsResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/GetHintAdStat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHintAdStatGET(_response);
        });
    }

    protected processGetHintAdStatGET(response: AxiosResponse): Promise<GetAdsHintStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdsHintStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetAdsHintStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdsHintStatsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getHintAdStatPOST(body: GetAdsHintStatsRequest | undefined, cancelToken?: CancelToken): Promise<GetAdsHintStatsResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/GetHintAdStat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHintAdStatPOST(_response);
        });
    }

    protected processGetHintAdStatPOST(response: AxiosResponse): Promise<GetAdsHintStatsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdsHintStatsResponse.fromJS(resultData200);
            return Promise.resolve<GetAdsHintStatsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdsHintStatsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    incrementMoreTimeAdWatch(body: IncrementAdsWatchMoreTimeCommandRequest | undefined, cancelToken?: CancelToken): Promise<IncrementAdsWatchMoreTimeCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/IncrementMoreTimeAdWatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncrementMoreTimeAdWatch(_response);
        });
    }

    protected processIncrementMoreTimeAdWatch(response: AxiosResponse): Promise<IncrementAdsWatchMoreTimeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncrementAdsWatchMoreTimeCommandResponse.fromJS(resultData200);
            return Promise.resolve<IncrementAdsWatchMoreTimeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncrementAdsWatchMoreTimeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    incrementBoardAdWatch(body: IncrementAdsWatchBoardCommandRequest | undefined, cancelToken?: CancelToken): Promise<IncrementAdsWatchBoardCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/IncrementBoardAdWatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncrementBoardAdWatch(_response);
        });
    }

    protected processIncrementBoardAdWatch(response: AxiosResponse): Promise<IncrementAdsWatchBoardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncrementAdsWatchBoardCommandResponse.fromJS(resultData200);
            return Promise.resolve<IncrementAdsWatchBoardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncrementAdsWatchBoardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    incrementHintAdWatch(body: IncrementAdsWatchHintCommandRequest | undefined, cancelToken?: CancelToken): Promise<IncrementAdsWatchHintCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/IncrementHintAdWatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncrementHintAdWatch(_response);
        });
    }

    protected processIncrementHintAdWatch(response: AxiosResponse): Promise<IncrementAdsWatchHintCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncrementAdsWatchHintCommandResponse.fromJS(resultData200);
            return Promise.resolve<IncrementAdsWatchHintCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncrementAdsWatchHintCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetBoardAdStat(body: ResetAdStatsBoardCommandRequest | undefined, cancelToken?: CancelToken): Promise<ResetAdStatsBoardCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/ResetBoardAdStat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetBoardAdStat(_response);
        });
    }

    protected processResetBoardAdStat(response: AxiosResponse): Promise<ResetAdStatsBoardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetAdStatsBoardCommandResponse.fromJS(resultData200);
            return Promise.resolve<ResetAdStatsBoardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetAdStatsBoardCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetHintAdStat(body: ResetAdStatsHintCommandRequest | undefined, cancelToken?: CancelToken): Promise<ResetAdStatsHintCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Ads/ResetHintAdStat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetHintAdStat(_response);
        });
    }

    protected processResetHintAdStat(response: AxiosResponse): Promise<ResetAdStatsHintCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetAdStatsHintCommandResponse.fromJS(resultData200);
            return Promise.resolve<ResetAdStatsHintCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetAdStatsHintCommandResponse>(null as any);
    }

    /**
     * @param platform (optional) 
     * @param appVersion (optional) 
     * @return Success
     */
    checkAppVersion(platform: string | undefined, appVersion: string | undefined, cancelToken?: CancelToken): Promise<CheckAppVersionResponse> {
        let url_ = this.baseUrl + "/api/Player/CheckAppVersion?";
        if (platform === null)
            throw new Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (appVersion === null)
            throw new Error("The parameter 'appVersion' cannot be null.");
        else if (appVersion !== undefined)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckAppVersion(_response);
        });
    }

    protected processCheckAppVersion(response: AxiosResponse): Promise<CheckAppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckAppVersionResponse.fromJS(resultData200);
            return Promise.resolve<CheckAppVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckAppVersionResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPlayers( cancelToken?: CancelToken): Promise<GetPlayersCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetPlayers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayers(_response);
        });
    }

    protected processGetPlayers(response: AxiosResponse): Promise<GetPlayersCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayersCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayersCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayersCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSinglePlayerGameHistories( cancelToken?: CancelToken): Promise<GetSinglePlayerGameHistoryCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetSinglePlayerGameHistories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSinglePlayerGameHistories(_response);
        });
    }

    protected processGetSinglePlayerGameHistories(response: AxiosResponse): Promise<GetSinglePlayerGameHistoryCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSinglePlayerGameHistoryCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetSinglePlayerGameHistoryCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSinglePlayerGameHistoryCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPlayerPerformance( cancelToken?: CancelToken): Promise<GetPlayerPerformanceCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetPlayerPerformance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerPerformance(_response);
        });
    }

    protected processGetPlayerPerformance(response: AxiosResponse): Promise<GetPlayerPerformanceCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerPerformanceCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerPerformanceCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerPerformanceCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBoards( cancelToken?: CancelToken): Promise<GetPlayerBoardCountQueryResponse> {
        let url_ = this.baseUrl + "/api/Player/Boards/GetBoards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBoards(_response);
        });
    }

    protected processGetBoards(response: AxiosResponse): Promise<GetPlayerBoardCountQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerBoardCountQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerBoardCountQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerBoardCountQueryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getHints( cancelToken?: CancelToken): Promise<GetHintsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Hints/GetHints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHints(_response);
        });
    }

    protected processGetHints(response: AxiosResponse): Promise<GetHintsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHintsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetHintsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHintsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMoreTime( cancelToken?: CancelToken): Promise<GetMoreTimeCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/MoreTime/GetMoreTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMoreTime(_response);
        });
    }

    protected processGetMoreTime(response: AxiosResponse): Promise<GetMoreTimeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMoreTimeCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetMoreTimeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMoreTimeCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    generate( cancelToken?: CancelToken): Promise<FriendInviteCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Invite/Generate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: AxiosResponse): Promise<FriendInviteCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FriendInviteCommandResponse.fromJS(resultData200);
            return Promise.resolve<FriendInviteCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FriendInviteCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFriends( cancelToken?: CancelToken): Promise<GetPlayerFriendListQueryResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/GetFriends";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFriends(_response);
        });
    }

    protected processGetFriends(response: AxiosResponse): Promise<GetPlayerFriendListQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerFriendListQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerFriendListQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerFriendListQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMoves(body: SaveMovesCommandRequest | undefined, cancelToken?: CancelToken): Promise<SaveMovesCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/SaveMoves";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMoves(_response);
        });
    }

    protected processSaveMoves(response: AxiosResponse): Promise<SaveMovesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMovesCommandResponse.fromJS(resultData200);
            return Promise.resolve<SaveMovesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMovesCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePlayerGameStatistics(body: SavePlayerGameStatsCommandRequest | undefined, cancelToken?: CancelToken): Promise<SavePlayerGameStatsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/SavePlayerGameStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePlayerGameStatistics(_response);
        });
    }

    protected processSavePlayerGameStatistics(response: AxiosResponse): Promise<SavePlayerGameStatsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SavePlayerGameStatsCommandResponse.fromJS(resultData200);
            return Promise.resolve<SavePlayerGameStatsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavePlayerGameStatsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayerStatisticsById(body: GetPlayerStatisticsByIdCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetPlayerStatisticsByIdCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetPlayerStatisticsById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerStatisticsById(_response);
        });
    }

    protected processGetPlayerStatisticsById(response: AxiosResponse): Promise<GetPlayerStatisticsByIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerStatisticsByIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerStatisticsByIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerStatisticsByIdCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchForPlayer(body: GetPlayerSearchQueryRequest | undefined, cancelToken?: CancelToken): Promise<GetPlayerSearchQueryResponse> {
        let url_ = this.baseUrl + "/api/Player/SearchForPlayer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchForPlayer(_response);
        });
    }

    protected processSearchForPlayer(response: AxiosResponse): Promise<GetPlayerSearchQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerSearchQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerSearchQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerSearchQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addBoards(body: AddPlayerBoardCountCommandRequest | undefined, cancelToken?: CancelToken): Promise<AddPlayerBoardCountCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Boards/AddBoards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBoards(_response);
        });
    }

    protected processAddBoards(response: AxiosResponse): Promise<AddPlayerBoardCountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddPlayerBoardCountCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddPlayerBoardCountCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddPlayerBoardCountCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeBoards(body: SubtractPlayerBoardCountCommandRequest | undefined, cancelToken?: CancelToken): Promise<SubtractPlayerBoardCountCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Boards/RemoveBoards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveBoards(_response);
        });
    }

    protected processRemoveBoards(response: AxiosResponse): Promise<SubtractPlayerBoardCountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubtractPlayerBoardCountCommandResponse.fromJS(resultData200);
            return Promise.resolve<SubtractPlayerBoardCountCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubtractPlayerBoardCountCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBoards(body: UpdatePlayerBoardCountCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdatePlayerBoardCountCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Boards/UpdateBoards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBoards(_response);
        });
    }

    protected processUpdateBoards(response: AxiosResponse): Promise<UpdatePlayerBoardCountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdatePlayerBoardCountCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdatePlayerBoardCountCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdatePlayerBoardCountCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addHints(body: AddHintsCommandRequest | undefined, cancelToken?: CancelToken): Promise<AddHintsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Hints/AddHints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddHints(_response);
        });
    }

    protected processAddHints(response: AxiosResponse): Promise<AddHintsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddHintsCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddHintsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddHintsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeHints(body: RemoveHintsCommandRequest | undefined, cancelToken?: CancelToken): Promise<RemoveHintsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Hints/RemoveHints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveHints(_response);
        });
    }

    protected processRemoveHints(response: AxiosResponse): Promise<RemoveHintsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveHintsCommandResponse.fromJS(resultData200);
            return Promise.resolve<RemoveHintsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveHintsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHints(body: UpdateHintsCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdateHintsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Hints/UpdateHints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHints(_response);
        });
    }

    protected processUpdateHints(response: AxiosResponse): Promise<UpdateHintsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateHintsCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateHintsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateHintsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMoreTime(body: AddMoreTimeCommandRequest | undefined, cancelToken?: CancelToken): Promise<AddMoreTimeCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/MoreTime/AddMoreTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMoreTime(_response);
        });
    }

    protected processAddMoreTime(response: AxiosResponse): Promise<AddMoreTimeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMoreTimeCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddMoreTimeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMoreTimeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeMoreTime(body: RemoveMoreTimeCommandRequest | undefined, cancelToken?: CancelToken): Promise<RemoveMoreTimeCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/MoreTime/RemoveMoreTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMoreTime(_response);
        });
    }

    protected processRemoveMoreTime(response: AxiosResponse): Promise<RemoveMoreTimeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveMoreTimeCommandResponse.fromJS(resultData200);
            return Promise.resolve<RemoveMoreTimeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveMoreTimeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMoreTime(body: UpdateMoreTimeCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMoreTimeCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/MoreTime/UpdateMoreTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMoreTime(_response);
        });
    }

    protected processUpdateMoreTime(response: AxiosResponse): Promise<UpdateMoreTimeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMoreTimeCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMoreTimeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMoreTimeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getHintForCell(body: GetHintForCellCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetHintForCellCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Hints/GetHintForCell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHintForCell(_response);
        });
    }

    protected processGetHintForCell(response: AxiosResponse): Promise<GetHintForCellCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHintForCellCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetHintForCellCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHintForCellCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendRequest(body: SendFriendRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<SendFriendRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/SendRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendRequest(_response);
        });
    }

    protected processSendRequest(response: AxiosResponse): Promise<SendFriendRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendFriendRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<SendFriendRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendFriendRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelRequest(body: CancelFriendRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<CancelFriendRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/CancelRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelRequest(_response);
        });
    }

    protected processCancelRequest(response: AxiosResponse): Promise<CancelFriendRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelFriendRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<CancelFriendRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelFriendRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptRequest(body: AcceptFriendRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<AcceptFriendRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/AcceptRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptRequest(_response);
        });
    }

    protected processAcceptRequest(response: AxiosResponse): Promise<AcceptFriendRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptFriendRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<AcceptFriendRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptFriendRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectRequest(body: RejectFriendRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<RejectFriendRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/RejectRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectRequest(_response);
        });
    }

    protected processRejectRequest(response: AxiosResponse): Promise<RejectFriendRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RejectFriendRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<RejectFriendRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RejectFriendRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    remove(body: RemoveFriendCommandRequest | undefined, cancelToken?: CancelToken): Promise<RemoveFriendCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/Remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<RemoveFriendCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveFriendCommandResponse.fromJS(resultData200);
            return Promise.resolve<RemoveFriendCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveFriendCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gameSummary(body: GetGameSummaryCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetGameSummaryCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/GameSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGameSummary(_response);
        });
    }

    protected processGameSummary(response: AxiosResponse): Promise<GetGameSummaryCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGameSummaryCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetGameSummaryCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGameSummaryCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    enter( cancelToken?: CancelToken): Promise<RequestRandomGameCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/Queue/Enter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnter(_response);
        });
    }

    protected processEnter(response: AxiosResponse): Promise<RequestRandomGameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestRandomGameCommandResponse.fromJS(resultData200);
            return Promise.resolve<RequestRandomGameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestRandomGameCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    cancelGET( cancelToken?: CancelToken): Promise<CancelPlayerQueueCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/Queue/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelGET(_response);
        });
    }

    protected processCancelGET(response: AxiosResponse): Promise<CancelPlayerQueueCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelPlayerQueueCommandResponse.fromJS(resultData200);
            return Promise.resolve<CancelPlayerQueueCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelPlayerQueueCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    status( cancelToken?: CancelToken): Promise<GetPlayerQueueStatusCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/Queue/Status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: AxiosResponse): Promise<GetPlayerQueueStatusCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerQueueStatusCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerQueueStatusCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerQueueStatusCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    queue( cancelToken?: CancelToken): Promise<GetCurrentMatchesCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/Queue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueue(_response);
        });
    }

    protected processQueue(response: AxiosResponse): Promise<GetCurrentMatchesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentMatchesCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetCurrentMatchesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentMatchesCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    currentQueue( cancelToken?: CancelToken): Promise<GetCurrentMatchesCommandResponseOld> {
        let url_ = this.baseUrl + "/api/Player/Game/CurrentQueue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrentQueue(_response);
        });
    }

    protected processCurrentQueue(response: AxiosResponse): Promise<GetCurrentMatchesCommandResponseOld> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentMatchesCommandResponseOld.fromJS(resultData200);
            return Promise.resolve<GetCurrentMatchesCommandResponseOld>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentMatchesCommandResponseOld>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestRandomGame(body: RequestRandomGameCommandRequestOld | undefined, cancelToken?: CancelToken): Promise<RequestRandomGameCommandResponseOld> {
        let url_ = this.baseUrl + "/api/Player/Game/RequestRandomGame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestRandomGame(_response);
        });
    }

    protected processRequestRandomGame(response: AxiosResponse): Promise<RequestRandomGameCommandResponseOld> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestRandomGameCommandResponseOld.fromJS(resultData200);
            return Promise.resolve<RequestRandomGameCommandResponseOld>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestRandomGameCommandResponseOld>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptRandomGame(body: AcceptRandomGameRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<AcceptRandomGameRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/AcceptRandomGame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptRandomGame(_response);
        });
    }

    protected processAcceptRandomGame(response: AxiosResponse): Promise<AcceptRandomGameRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptRandomGameRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<AcceptRandomGameRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptRandomGameRequestCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getGameRequests( cancelToken?: CancelToken): Promise<GetGameRequestsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/GetGameRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameRequests(_response);
        });
    }

    protected processGetGameRequests(response: AxiosResponse): Promise<GetGameRequestsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGameRequestsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetGameRequestsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGameRequestsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptGameRequest(body: AcceptGameRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<AcceptGameRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/AcceptGameRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptGameRequest(_response);
        });
    }

    protected processAcceptGameRequest(response: AxiosResponse): Promise<AcceptGameRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptGameRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<AcceptGameRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptGameRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectGameRequest(body: RejectGameRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<RejectGameRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/RejectGameRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectGameRequest(_response);
        });
    }

    protected processRejectGameRequest(response: AxiosResponse): Promise<RejectGameRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RejectGameRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<RejectGameRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RejectGameRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelGameRequest(body: CancelGameRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<CancelGameRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/CancelGameRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelGameRequest(_response);
        });
    }

    protected processCancelGameRequest(response: AxiosResponse): Promise<CancelGameRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelGameRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<CancelGameRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelGameRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendGameRequest(body: SendGameRequestCommandRequest | undefined, cancelToken?: CancelToken): Promise<SendGameRequestCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/SendGameRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendGameRequest(_response);
        });
    }

    protected processSendGameRequest(response: AxiosResponse): Promise<SendGameRequestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendGameRequestCommandResponse.fromJS(resultData200);
            return Promise.resolve<SendGameRequestCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendGameRequestCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resignFromGame(body: ResignFromGameCommandRequest | undefined, cancelToken?: CancelToken): Promise<ResignFromGameCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Game/ResignFromGame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResignFromGame(_response);
        });
    }

    protected processResignFromGame(response: AxiosResponse): Promise<ResignFromGameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResignFromGameCommandResponse.fromJS(resultData200);
            return Promise.resolve<ResignFromGameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResignFromGameCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    compareFriendStats(body: CompareFriendStatsCommandRequest | undefined, cancelToken?: CancelToken): Promise<CompareFriendStatsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/Friend/CompareFriendStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompareFriendStats(_response);
        });
    }

    protected processCompareFriendStats(response: AxiosResponse): Promise<CompareFriendStatsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompareFriendStatsCommandResponse.fromJS(resultData200);
            return Promise.resolve<CompareFriendStatsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompareFriendStatsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getVsStats( cancelToken?: CancelToken): Promise<GetVsStatsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetVsStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVsStats(_response);
        });
    }

    protected processGetVsStats(response: AxiosResponse): Promise<GetVsStatsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVsStatsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetVsStatsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVsStatsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getLeaderboards( cancelToken?: CancelToken): Promise<GetLeaderboardsCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetLeaderboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeaderboards(_response);
        });
    }

    protected processGetLeaderboards(response: AxiosResponse): Promise<GetLeaderboardsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLeaderboardsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetLeaderboardsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLeaderboardsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCountryCode(body: SaveCountryCodeCommandRequest | undefined, cancelToken?: CancelToken): Promise<SaveCountryCodeCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/SaveCountryCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCountryCode(_response);
        });
    }

    protected processSaveCountryCode(response: AxiosResponse): Promise<SaveCountryCodeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveCountryCodeCommandResponse.fromJS(resultData200);
            return Promise.resolve<SaveCountryCodeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveCountryCodeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkIfUsernameAvailable(body: GetAvailableUsernameSearchQueryRequest | undefined, cancelToken?: CancelToken): Promise<GetAvailableUsernameSearchQueryResponse> {
        let url_ = this.baseUrl + "/api/Player/CheckIfUsernameAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfUsernameAvailable(_response);
        });
    }

    protected processCheckIfUsernameAvailable(response: AxiosResponse): Promise<GetAvailableUsernameSearchQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAvailableUsernameSearchQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetAvailableUsernameSearchQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAvailableUsernameSearchQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUsername(body: UpdateUsernameCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdateUsernameCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/UpdateUsername";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUsername(_response);
        });
    }

    protected processUpdateUsername(response: AxiosResponse): Promise<UpdateUsernameCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUsernameCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateUsernameCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUsernameCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayerInfo(body: GetPlayerInfoByIdCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetPlayerInfoByIdCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/GetPlayerInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerInfo(_response);
        });
    }

    protected processGetPlayerInfo(response: AxiosResponse): Promise<GetPlayerInfoByIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerInfoByIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerInfoByIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerInfoByIdCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlayerIcon(body: UpdateUserIconCommandRequest | undefined, cancelToken?: CancelToken): Promise<UpdateUserIconCommandResponse> {
        let url_ = this.baseUrl + "/api/Player/UpdatePlayerIcon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlayerIcon(_response);
        });
    }

    protected processUpdatePlayerIcon(response: AxiosResponse): Promise<UpdateUserIconCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserIconCommandResponse.fromJS(resultData200);
            return Promise.resolve<UpdateUserIconCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserIconCommandResponse>(null as any);
    }

    /**
     * @param lang (optional) 
     * @return Success
     */
    getActive(lang: string | undefined, cancelToken?: CancelToken): Promise<GetPublicPromotionsCommandResponse> {
        let url_ = this.baseUrl + "/api/Promotion/GetActive?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActive(_response);
        });
    }

    protected processGetActive(response: AxiosResponse): Promise<GetPublicPromotionsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPublicPromotionsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPublicPromotionsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPublicPromotionsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined, cancelToken?: CancelToken): Promise<LoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginCommandResponse.fromJS(resultData200);
            return Promise.resolve<LoginCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePlayerData(body: DeletePlayerDataCommandRequest | undefined, cancelToken?: CancelToken): Promise<DeletePlayerDataCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/DeletePlayerData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlayerData(_response);
        });
    }

    protected processDeletePlayerData(response: AxiosResponse): Promise<DeletePlayerDataCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeletePlayerDataCommandResponse.fromJS(resultData200);
            return Promise.resolve<DeletePlayerDataCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeletePlayerDataCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterCommandRequest | undefined, cancelToken?: CancelToken): Promise<RegisterResponseModel> {
        let url_ = this.baseUrl + "/api/Security/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterResponseModel.fromJS(resultData200);
            return Promise.resolve<RegisterResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerApple(body: RegisterAppleCommandRequest | undefined, cancelToken?: CancelToken): Promise<RegisterResponseModel> {
        let url_ = this.baseUrl + "/api/Security/RegisterApple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterApple(_response);
        });
    }

    protected processRegisterApple(response: AxiosResponse): Promise<RegisterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterResponseModel.fromJS(resultData200);
            return Promise.resolve<RegisterResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerGuest(body: RegisterGuestCommandRequest | undefined, cancelToken?: CancelToken): Promise<RegisterGuestResponseModel> {
        let url_ = this.baseUrl + "/api/Security/RegisterGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterGuest(_response);
        });
    }

    protected processRegisterGuest(response: AxiosResponse): Promise<RegisterGuestResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterGuestResponseModel.fromJS(resultData200);
            return Promise.resolve<RegisterGuestResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterGuestResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestDeletePlayerData(body: RequestDeletePlayerDataCommandRequest | undefined, cancelToken?: CancelToken): Promise<RequestDeletePlayerDataCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/RequestDeletePlayerData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestDeletePlayerData(_response);
        });
    }

    protected processRequestDeletePlayerData(response: AxiosResponse): Promise<RequestDeletePlayerDataCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestDeletePlayerDataCommandResponse.fromJS(resultData200);
            return Promise.resolve<RequestDeletePlayerDataCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestDeletePlayerDataCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkGuestAccount(body: LinkGuestAccountCommandRequest | undefined, cancelToken?: CancelToken): Promise<LinkGuestAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/LinkGuestAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkGuestAccount(_response);
        });
    }

    protected processLinkGuestAccount(response: AxiosResponse): Promise<LinkGuestAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LinkGuestAccountCommandResponse.fromJS(resultData200);
            return Promise.resolve<LinkGuestAccountCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LinkGuestAccountCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getLinkedAccounts( cancelToken?: CancelToken): Promise<GetLinkedAccountsQueryResponse> {
        let url_ = this.baseUrl + "/api/Security/GetLinkedAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedAccounts(_response);
        });
    }

    protected processGetLinkedAccounts(response: AxiosResponse): Promise<GetLinkedAccountsQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLinkedAccountsQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetLinkedAccountsQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLinkedAccountsQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addLinkedAccount(body: AddLinkedAccountCommandRequest | undefined, cancelToken?: CancelToken): Promise<AddLinkedAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/AddLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddLinkedAccount(_response);
        });
    }

    protected processAddLinkedAccount(response: AxiosResponse): Promise<AddLinkedAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddLinkedAccountCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddLinkedAccountCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddLinkedAccountCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordCommandRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(body: EditUserProfileCommandRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/EditUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditUserProfile(_response);
        });
    }

    protected processEditUserProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserPassword(body: ChangePasswordCommandRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/ChangeUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMarketingOptIn(body: UpdateMarketingOptInCommandRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/UpdateMarketingOptIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMarketingOptIn(_response);
        });
    }

    protected processUpdateMarketingOptIn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    pingUser( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/PingUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPingUser(_response);
        });
    }

    protected processPingUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getProducts( cancelToken?: CancelToken): Promise<GetProductsCommandResponse> {
        let url_ = this.baseUrl + "/api/Store/Store/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<GetProductsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetProductsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    restorePurchases( cancelToken?: CancelToken): Promise<RestorePurchasesCommandResponse> {
        let url_ = this.baseUrl + "/api/Store/RestorePurchases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestorePurchases(_response);
        });
    }

    protected processRestorePurchases(response: AxiosResponse): Promise<RestorePurchasesCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RestorePurchasesCommandResponse.fromJS(resultData200);
            return Promise.resolve<RestorePurchasesCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RestorePurchasesCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: AddProductCommandRequest | undefined, cancelToken?: CancelToken): Promise<AddProductCommandResponse> {
        let url_ = this.baseUrl + "/api/Store/Product/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<AddProductCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddProductCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddProductCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    purchase(body: PurchaseProductCommandRequest | undefined, cancelToken?: CancelToken): Promise<PurchaseProductCommandResponse> {
        let url_ = this.baseUrl + "/api/Store/Product/Purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurchase(_response);
        });
    }

    protected processPurchase(response: AxiosResponse): Promise<PurchaseProductCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaseProductCommandResponse.fromJS(resultData200);
            return Promise.resolve<PurchaseProductCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseProductCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPOST(body: CancelSubscriptionCommandRequest | undefined, cancelToken?: CancelToken): Promise<CancelSubscriptionCommandResponse> {
        let url_ = this.baseUrl + "/api/Store/Subscription/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelPOST(_response);
        });
    }

    protected processCancelPOST(response: AxiosResponse): Promise<CancelSubscriptionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelSubscriptionCommandResponse.fromJS(resultData200);
            return Promise.resolve<CancelSubscriptionCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelSubscriptionCommandResponse>(null as any);
    }

    /**
     * @param lang (optional) 
     * @return Success
     */
    getActive2(lang: string | undefined, cancelToken?: CancelToken): Promise<GetPublicTutorialsCommandResponse> {
        let url_ = this.baseUrl + "/api/Tutorial/GetActive?";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActive2(_response);
        });
    }

    protected processGetActive2(response: AxiosResponse): Promise<GetPublicTutorialsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPublicTutorialsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPublicTutorialsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPublicTutorialsCommandResponse>(null as any);
    }
}

export enum Difficulty {
    Easy = "Easy",
    Medium = "Medium",
    Hard = "Hard",
    Expert = "Expert",
    MediumHard = "MediumHard",
    EasyMedium = "EasyMedium",
    TremendouslyEasy = "TremendouslyEasy",
}

export enum GameStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Completed = "Completed",
    Expired = "Expired",
    Cancelled = "Cancelled",
}

export enum PlayerStatus {
    Playing = "Playing",
    Win = "Win",
    Lose = "Lose",
    Draw = "Draw",
    Forfeit = "Forfeit",
}

export enum UserStatus {
    Disabled = "Disabled",
    Active = "Active",
    Locked = "Locked",
    UnderReview = "UnderReview",
    Flagged = "Flagged",
    BotDisabled = "BotDisabled",
    BotActive = "BotActive",
    Deleted = "Deleted",
}

export enum UserType {
    Regular = "Regular",
    Guest = "Guest",
    Bot = "Bot",
    Admin = "Admin",
    HighAdmin = "HighAdmin",
}

export enum AgeBracket {
    Under18 = "Under18",
    Between18And35 = "Between18And35",
    Above35 = "Above35",
}

export enum SignUpMedium {
    Google = "Google",
    Facebook = "Facebook",
    Apple = "Apple",
    Email = "Email",
    Guest = "Guest",
    AppleTest = "AppleTest",
}

export enum AccessLevel {
    None = "None",
    One = "One",
    Two = "Two",
    Three = "Three",
    Four = "Four",
    Five = "Five",
}

export enum RoleStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export class Role implements IRole {
    description?: string | undefined;
    level?: AccessLevel;
    status?: RoleStatus;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
    accessCards?: UserRole[] | undefined;
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.accessCards) {
                this.accessCards = [];
                for (let i = 0; i < data.accessCards.length; i++) {
                    let item = data.accessCards[i];
                    this.accessCards[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.level = _data["level"];
            this.status = _data["status"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
            if (Array.isArray(_data["accessCards"])) {
                this.accessCards = [] as any;
                for (let item of _data["accessCards"])
                    this.accessCards!.push(UserRole.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["level"] = this.level;
        data["status"] = this.status;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        if (Array.isArray(this.accessCards)) {
            data["accessCards"] = [];
            for (let item of this.accessCards)
                data["accessCards"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        return data;
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole {
    description?: string | undefined;
    level?: AccessLevel;
    status?: RoleStatus;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
    accessCards?: IUserRole[] | undefined;
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class UserRole implements IUserRole {
    userId?: string;
    user?: User | undefined;
    roleId?: string;
    role?: Role | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    userId?: string;
    user?: IUser | undefined;
    roleId?: string;
    role?: IRole | undefined;
}

export enum PlayerRank {
    Beginner = "Beginner",
    Apprentice = "Apprentice",
    Professional = "Professional",
    Expert = "Expert",
    Master = "Master",
    GrandMaster = "GrandMaster",
}

export class PlayerProfile implements IPlayerProfile {
    userId?: string;
    rankScore?: number;
    rankName?: PlayerRank;
    hints?: number;
    boards?: number;
    moreTime?: number;
    boardAdsWatchedCount?: number | undefined;
    hintAdsWatchedCount?: number | undefined;
    moreTimeAdsWatchedCount?: number | undefined;
    lastBoardAdsWatchDate?: string | undefined;
    lastHintAdsWatchDate?: string | undefined;
    lastMoreTimeAdsWatchDate?: string | undefined;
    user?: User | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IPlayerProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.rankScore = _data["rankScore"];
            this.rankName = _data["rankName"];
            this.hints = _data["hints"];
            this.boards = _data["boards"];
            this.moreTime = _data["moreTime"];
            this.boardAdsWatchedCount = _data["boardAdsWatchedCount"];
            this.hintAdsWatchedCount = _data["hintAdsWatchedCount"];
            this.moreTimeAdsWatchedCount = _data["moreTimeAdsWatchedCount"];
            this.lastBoardAdsWatchDate = _data["lastBoardAdsWatchDate"];
            this.lastHintAdsWatchDate = _data["lastHintAdsWatchDate"];
            this.lastMoreTimeAdsWatchDate = _data["lastMoreTimeAdsWatchDate"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): PlayerProfile {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["moreTime"] = this.moreTime;
        data["boardAdsWatchedCount"] = this.boardAdsWatchedCount;
        data["hintAdsWatchedCount"] = this.hintAdsWatchedCount;
        data["moreTimeAdsWatchedCount"] = this.moreTimeAdsWatchedCount;
        data["lastBoardAdsWatchDate"] = this.lastBoardAdsWatchDate;
        data["lastHintAdsWatchDate"] = this.lastHintAdsWatchDate;
        data["lastMoreTimeAdsWatchDate"] = this.lastMoreTimeAdsWatchDate;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): PlayerProfile {
        const json = this.toJSON();
        let result = new PlayerProfile();
        result.init(json);
        return result;
    }
}

export interface IPlayerProfile {
    userId?: string;
    rankScore?: number;
    rankName?: PlayerRank;
    hints?: number;
    boards?: number;
    moreTime?: number;
    boardAdsWatchedCount?: number | undefined;
    hintAdsWatchedCount?: number | undefined;
    moreTimeAdsWatchedCount?: number | undefined;
    lastBoardAdsWatchDate?: string | undefined;
    lastHintAdsWatchDate?: string | undefined;
    lastMoreTimeAdsWatchDate?: string | undefined;
    user?: IUser | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export enum FriendRequestStatus {
    Pending = "Pending",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Removed = "Removed",
    Cancelled = "Cancelled",
}

export class FriendList implements IFriendList {
    inviterUserId?: string;
    inviteeUserId?: string;
    inviterUser?: User | undefined;
    inviteeUser?: User | undefined;
    status?: FriendRequestStatus;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IFriendList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.inviterUser = data.inviterUser && !(<any>data.inviterUser).toJSON ? new User(data.inviterUser) : <User>this.inviterUser;
            this.inviteeUser = data.inviteeUser && !(<any>data.inviteeUser).toJSON ? new User(data.inviteeUser) : <User>this.inviteeUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviterUserId = _data["inviterUserId"];
            this.inviteeUserId = _data["inviteeUserId"];
            this.inviterUser = _data["inviterUser"] ? User.fromJS(_data["inviterUser"]) : <any>undefined;
            this.inviteeUser = _data["inviteeUser"] ? User.fromJS(_data["inviteeUser"]) : <any>undefined;
            this.status = _data["status"];
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): FriendList {
        data = typeof data === 'object' ? data : {};
        let result = new FriendList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviterUserId"] = this.inviterUserId;
        data["inviteeUserId"] = this.inviteeUserId;
        data["inviterUser"] = this.inviterUser ? this.inviterUser.toJSON() : <any>undefined;
        data["inviteeUser"] = this.inviteeUser ? this.inviteeUser.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): FriendList {
        const json = this.toJSON();
        let result = new FriendList();
        result.init(json);
        return result;
    }
}

export interface IFriendList {
    inviterUserId?: string;
    inviteeUserId?: string;
    inviterUser?: IUser | undefined;
    inviteeUser?: IUser | undefined;
    status?: FriendRequestStatus;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export class Device implements IDevice {
    deviceName?: string | undefined;
    model?: string | undefined;
    manufacturer?: string | undefined;
    operatingSystem?: string | undefined;
    currentAppVersion?: string | undefined;
    screenSize?: string | undefined;
    resolution?: string | undefined;
    deviceId?: string | undefined;
    lastAccessDate?: string | undefined;
    userId?: string;
    user?: User | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceName = _data["deviceName"];
            this.model = _data["model"];
            this.manufacturer = _data["manufacturer"];
            this.operatingSystem = _data["operatingSystem"];
            this.currentAppVersion = _data["currentAppVersion"];
            this.screenSize = _data["screenSize"];
            this.resolution = _data["resolution"];
            this.deviceId = _data["deviceId"];
            this.lastAccessDate = _data["lastAccessDate"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["model"] = this.model;
        data["manufacturer"] = this.manufacturer;
        data["operatingSystem"] = this.operatingSystem;
        data["currentAppVersion"] = this.currentAppVersion;
        data["screenSize"] = this.screenSize;
        data["resolution"] = this.resolution;
        data["deviceId"] = this.deviceId;
        data["lastAccessDate"] = this.lastAccessDate;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): Device {
        const json = this.toJSON();
        let result = new Device();
        result.init(json);
        return result;
    }
}

export interface IDevice {
    deviceName?: string | undefined;
    model?: string | undefined;
    manufacturer?: string | undefined;
    operatingSystem?: string | undefined;
    currentAppVersion?: string | undefined;
    screenSize?: string | undefined;
    resolution?: string | undefined;
    deviceId?: string | undefined;
    lastAccessDate?: string | undefined;
    userId?: string;
    user?: IUser | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export class PlayerIcon implements IPlayerIcon {
    userId?: string;
    iconNumber?: number;
    user?: User | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IPlayerIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.iconNumber = _data["iconNumber"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): PlayerIcon {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerIcon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["iconNumber"] = this.iconNumber;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): PlayerIcon {
        const json = this.toJSON();
        let result = new PlayerIcon();
        result.init(json);
        return result;
    }
}

export interface IPlayerIcon {
    userId?: string;
    iconNumber?: number;
    user?: IUser | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export class User implements IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    userStatus?: UserStatus;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    lastActivityTime?: string | undefined;
    rowVersionStamp?: string | undefined;
    userType?: UserType;
    ageRange?: AgeBracket | undefined;
    signUpMediumUsed?: SignUpMedium;
    externalAccessToken?: string | undefined;
    externalId?: string | undefined;
    fcmToken?: string | undefined;
    noAds?: boolean;
    marketingEmailOptIn?: boolean;
    adminStatus?: UserStatus;
    accessCards?: UserRole[] | undefined;
    playerProfile?: PlayerProfile | undefined;
    invitedFriends?: FriendList[] | undefined;
    invitedByFriends?: FriendList[] | undefined;
    readonly friends?: FriendList[] | undefined;
    devices?: Device[] | undefined;
    countryCode?: string | undefined;
    playerIcon?: PlayerIcon | undefined;
    wasUsernameChanged?: boolean;
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.accessCards) {
                this.accessCards = [];
                for (let i = 0; i < data.accessCards.length; i++) {
                    let item = data.accessCards[i];
                    this.accessCards[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
            this.playerProfile = data.playerProfile && !(<any>data.playerProfile).toJSON ? new PlayerProfile(data.playerProfile) : <PlayerProfile>this.playerProfile;
            if (data.invitedFriends) {
                this.invitedFriends = [];
                for (let i = 0; i < data.invitedFriends.length; i++) {
                    let item = data.invitedFriends[i];
                    this.invitedFriends[i] = item && !(<any>item).toJSON ? new FriendList(item) : <FriendList>item;
                }
            }
            if (data.invitedByFriends) {
                this.invitedByFriends = [];
                for (let i = 0; i < data.invitedByFriends.length; i++) {
                    let item = data.invitedByFriends[i];
                    this.invitedByFriends[i] = item && !(<any>item).toJSON ? new FriendList(item) : <FriendList>item;
                }
            }
            if (data.friends) {
                this.friends = [];
                for (let i = 0; i < data.friends.length; i++) {
                    let item = data.friends[i];
                    this.friends[i] = item && !(<any>item).toJSON ? new FriendList(item) : <FriendList>item;
                }
            }
            if (data.devices) {
                this.devices = [];
                for (let i = 0; i < data.devices.length; i++) {
                    let item = data.devices[i];
                    this.devices[i] = item && !(<any>item).toJSON ? new Device(item) : <Device>item;
                }
            }
            this.playerIcon = data.playerIcon && !(<any>data.playerIcon).toJSON ? new PlayerIcon(data.playerIcon) : <PlayerIcon>this.playerIcon;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userStatus = _data["userStatus"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.lastActivityTime = _data["lastActivityTime"];
            this.rowVersionStamp = _data["rowVersionStamp"];
            this.userType = _data["userType"];
            this.ageRange = _data["ageRange"];
            this.signUpMediumUsed = _data["signUpMediumUsed"];
            this.externalAccessToken = _data["externalAccessToken"];
            this.externalId = _data["externalId"];
            this.fcmToken = _data["fcmToken"];
            this.noAds = _data["noAds"];
            this.marketingEmailOptIn = _data["marketingEmailOptIn"];
            this.adminStatus = _data["adminStatus"];
            if (Array.isArray(_data["accessCards"])) {
                this.accessCards = [] as any;
                for (let item of _data["accessCards"])
                    this.accessCards!.push(UserRole.fromJS(item));
            }
            this.playerProfile = _data["playerProfile"] ? PlayerProfile.fromJS(_data["playerProfile"]) : <any>undefined;
            if (Array.isArray(_data["invitedFriends"])) {
                this.invitedFriends = [] as any;
                for (let item of _data["invitedFriends"])
                    this.invitedFriends!.push(FriendList.fromJS(item));
            }
            if (Array.isArray(_data["invitedByFriends"])) {
                this.invitedByFriends = [] as any;
                for (let item of _data["invitedByFriends"])
                    this.invitedByFriends!.push(FriendList.fromJS(item));
            }
            if (Array.isArray(_data["friends"])) {
                (<any>this).friends = [] as any;
                for (let item of _data["friends"])
                    (<any>this).friends!.push(FriendList.fromJS(item));
            }
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Device.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.playerIcon = _data["playerIcon"] ? PlayerIcon.fromJS(_data["playerIcon"]) : <any>undefined;
            this.wasUsernameChanged = _data["wasUsernameChanged"];
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userStatus"] = this.userStatus;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["lastActivityTime"] = this.lastActivityTime;
        data["rowVersionStamp"] = this.rowVersionStamp;
        data["userType"] = this.userType;
        data["ageRange"] = this.ageRange;
        data["signUpMediumUsed"] = this.signUpMediumUsed;
        data["externalAccessToken"] = this.externalAccessToken;
        data["externalId"] = this.externalId;
        data["fcmToken"] = this.fcmToken;
        data["noAds"] = this.noAds;
        data["marketingEmailOptIn"] = this.marketingEmailOptIn;
        data["adminStatus"] = this.adminStatus;
        if (Array.isArray(this.accessCards)) {
            data["accessCards"] = [];
            for (let item of this.accessCards)
                data["accessCards"].push(item.toJSON());
        }
        data["playerProfile"] = this.playerProfile ? this.playerProfile.toJSON() : <any>undefined;
        if (Array.isArray(this.invitedFriends)) {
            data["invitedFriends"] = [];
            for (let item of this.invitedFriends)
                data["invitedFriends"].push(item.toJSON());
        }
        if (Array.isArray(this.invitedByFriends)) {
            data["invitedByFriends"] = [];
            for (let item of this.invitedByFriends)
                data["invitedByFriends"].push(item.toJSON());
        }
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["countryCode"] = this.countryCode;
        data["playerIcon"] = this.playerIcon ? this.playerIcon.toJSON() : <any>undefined;
        data["wasUsernameChanged"] = this.wasUsernameChanged;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    userStatus?: UserStatus;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    lastActivityTime?: string | undefined;
    rowVersionStamp?: string | undefined;
    userType?: UserType;
    ageRange?: AgeBracket | undefined;
    signUpMediumUsed?: SignUpMedium;
    externalAccessToken?: string | undefined;
    externalId?: string | undefined;
    fcmToken?: string | undefined;
    noAds?: boolean;
    marketingEmailOptIn?: boolean;
    adminStatus?: UserStatus;
    accessCards?: IUserRole[] | undefined;
    playerProfile?: IPlayerProfile | undefined;
    invitedFriends?: IFriendList[] | undefined;
    invitedByFriends?: IFriendList[] | undefined;
    friends?: IFriendList[] | undefined;
    devices?: IDevice[] | undefined;
    countryCode?: string | undefined;
    playerIcon?: IPlayerIcon | undefined;
    wasUsernameChanged?: boolean;
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class PlayerState implements IPlayerState {
    gameBoardId?: string | undefined;
    notes?: string | undefined;
    plays?: string | undefined;
    lastMoves?: string | undefined;
    previousMoves?: string | undefined;
    wrongMoves?: string | undefined;
    score?: number;
    remainingMoves?: number;
    errors?: number;
    hintsUsed?: number;
    moreTimeUsed?: number;
    adsWatched?: number;
    timeTaken?: number;
    playerStatus?: PlayerStatus;
    userId?: string;
    user?: User | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IPlayerState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameBoardId = _data["gameBoardId"];
            this.notes = _data["notes"];
            this.plays = _data["plays"];
            this.lastMoves = _data["lastMoves"];
            this.previousMoves = _data["previousMoves"];
            this.wrongMoves = _data["wrongMoves"];
            this.score = _data["score"];
            this.remainingMoves = _data["remainingMoves"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.adsWatched = _data["adsWatched"];
            this.timeTaken = _data["timeTaken"];
            this.playerStatus = _data["playerStatus"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): PlayerState {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameBoardId"] = this.gameBoardId;
        data["notes"] = this.notes;
        data["plays"] = this.plays;
        data["lastMoves"] = this.lastMoves;
        data["previousMoves"] = this.previousMoves;
        data["wrongMoves"] = this.wrongMoves;
        data["score"] = this.score;
        data["remainingMoves"] = this.remainingMoves;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["adsWatched"] = this.adsWatched;
        data["timeTaken"] = this.timeTaken;
        data["playerStatus"] = this.playerStatus;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): PlayerState {
        const json = this.toJSON();
        let result = new PlayerState();
        result.init(json);
        return result;
    }
}

export interface IPlayerState {
    gameBoardId?: string | undefined;
    notes?: string | undefined;
    plays?: string | undefined;
    lastMoves?: string | undefined;
    previousMoves?: string | undefined;
    wrongMoves?: string | undefined;
    score?: number;
    remainingMoves?: number;
    errors?: number;
    hintsUsed?: number;
    moreTimeUsed?: number;
    adsWatched?: number;
    timeTaken?: number;
    playerStatus?: PlayerStatus;
    userId?: string;
    user?: IUser | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export enum WinLossReason {
    Score = "Score",
    NumbersPlaced = "NumbersPlaced",
    TimeOut = "TimeOut",
    Forfeit = "Forfeit",
    Errors = "Errors",
}

export class EndGamePlayerStats implements IEndGamePlayerStats {
    playerId?: string;
    playerUsername?: string | undefined;
    playerRank?: PlayerRank;
    gainedRating?: number;
    currentRating?: number;
    ratingText?: string | undefined;
    score?: number;
    numbersPlaced?: number;
    errors?: number;
    winLossReason?: WinLossReason | undefined;
    isWinner?: boolean;
    vsMode?: boolean;
    dateFinished?: string;
    playerState?: PlayerState | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IEndGamePlayerStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerState = data.playerState && !(<any>data.playerState).toJSON ? new PlayerState(data.playerState) : <PlayerState>this.playerState;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerUsername = _data["playerUsername"];
            this.playerRank = _data["playerRank"];
            this.gainedRating = _data["gainedRating"];
            this.currentRating = _data["currentRating"];
            this.ratingText = _data["ratingText"];
            this.score = _data["score"];
            this.numbersPlaced = _data["numbersPlaced"];
            this.errors = _data["errors"];
            this.winLossReason = _data["winLossReason"];
            this.isWinner = _data["isWinner"];
            this.vsMode = _data["vsMode"];
            this.dateFinished = _data["dateFinished"];
            this.playerState = _data["playerState"] ? PlayerState.fromJS(_data["playerState"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): EndGamePlayerStats {
        data = typeof data === 'object' ? data : {};
        let result = new EndGamePlayerStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerUsername"] = this.playerUsername;
        data["playerRank"] = this.playerRank;
        data["gainedRating"] = this.gainedRating;
        data["currentRating"] = this.currentRating;
        data["ratingText"] = this.ratingText;
        data["score"] = this.score;
        data["numbersPlaced"] = this.numbersPlaced;
        data["errors"] = this.errors;
        data["winLossReason"] = this.winLossReason;
        data["isWinner"] = this.isWinner;
        data["vsMode"] = this.vsMode;
        data["dateFinished"] = this.dateFinished;
        data["playerState"] = this.playerState ? this.playerState.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): EndGamePlayerStats {
        const json = this.toJSON();
        let result = new EndGamePlayerStats();
        result.init(json);
        return result;
    }
}

export interface IEndGamePlayerStats {
    playerId?: string;
    playerUsername?: string | undefined;
    playerRank?: PlayerRank;
    gainedRating?: number;
    currentRating?: number;
    ratingText?: string | undefined;
    score?: number;
    numbersPlaced?: number;
    errors?: number;
    winLossReason?: WinLossReason | undefined;
    isWinner?: boolean;
    vsMode?: boolean;
    dateFinished?: string;
    playerState?: IPlayerState | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export class EndGameSummary implements IEndGameSummary {
    gameId?: string;
    player1Stats?: EndGamePlayerStats | undefined;
    player2Stats?: EndGamePlayerStats | undefined;
    game?: GameBoard | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IEndGameSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.player1Stats = data.player1Stats && !(<any>data.player1Stats).toJSON ? new EndGamePlayerStats(data.player1Stats) : <EndGamePlayerStats>this.player1Stats;
            this.player2Stats = data.player2Stats && !(<any>data.player2Stats).toJSON ? new EndGamePlayerStats(data.player2Stats) : <EndGamePlayerStats>this.player2Stats;
            this.game = data.game && !(<any>data.game).toJSON ? new GameBoard(data.game) : <GameBoard>this.game;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.player1Stats = _data["player1Stats"] ? EndGamePlayerStats.fromJS(_data["player1Stats"]) : <any>undefined;
            this.player2Stats = _data["player2Stats"] ? EndGamePlayerStats.fromJS(_data["player2Stats"]) : <any>undefined;
            this.game = _data["game"] ? GameBoard.fromJS(_data["game"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): EndGameSummary {
        data = typeof data === 'object' ? data : {};
        let result = new EndGameSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["player1Stats"] = this.player1Stats ? this.player1Stats.toJSON() : <any>undefined;
        data["player2Stats"] = this.player2Stats ? this.player2Stats.toJSON() : <any>undefined;
        data["game"] = this.game ? this.game.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): EndGameSummary {
        const json = this.toJSON();
        let result = new EndGameSummary();
        result.init(json);
        return result;
    }
}

export interface IEndGameSummary {
    gameId?: string;
    player1Stats?: IEndGamePlayerStats | undefined;
    player2Stats?: IEndGamePlayerStats | undefined;
    game?: IGameBoard | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export enum GameRequestStatus {
    Pending = "Pending",
    InQueue = "InQueue",
    Matched = "Matched",
    InGame = "InGame",
    Cancelled = "Cancelled",
    Rejected = "Rejected",
    Completed = "Completed",
}

export class GameRequest implements IGameRequest {
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    rank?: number | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    requestor?: User | undefined;
    matchedPlayer?: User | undefined;
    game?: GameBoard | undefined;
    botRequested?: boolean;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IGameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.requestor = data.requestor && !(<any>data.requestor).toJSON ? new User(data.requestor) : <User>this.requestor;
            this.matchedPlayer = data.matchedPlayer && !(<any>data.matchedPlayer).toJSON ? new User(data.matchedPlayer) : <User>this.matchedPlayer;
            this.game = data.game && !(<any>data.game).toJSON ? new GameBoard(data.game) : <GameBoard>this.game;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestorId = _data["requestorId"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.rank = _data["rank"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.gameRequestStatus = _data["gameRequestStatus"];
            this.requestor = _data["requestor"] ? User.fromJS(_data["requestor"]) : <any>undefined;
            this.matchedPlayer = _data["matchedPlayer"] ? User.fromJS(_data["matchedPlayer"]) : <any>undefined;
            this.game = _data["game"] ? GameBoard.fromJS(_data["game"]) : <any>undefined;
            this.botRequested = _data["botRequested"];
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): GameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorId"] = this.requestorId;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["rank"] = this.rank;
        data["gameDifficulty"] = this.gameDifficulty;
        data["gameRequestStatus"] = this.gameRequestStatus;
        data["requestor"] = this.requestor ? this.requestor.toJSON() : <any>undefined;
        data["matchedPlayer"] = this.matchedPlayer ? this.matchedPlayer.toJSON() : <any>undefined;
        data["game"] = this.game ? this.game.toJSON() : <any>undefined;
        data["botRequested"] = this.botRequested;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): GameRequest {
        const json = this.toJSON();
        let result = new GameRequest();
        result.init(json);
        return result;
    }
}

export interface IGameRequest {
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    rank?: number | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    requestor?: IUser | undefined;
    matchedPlayer?: IUser | undefined;
    game?: IGameBoard | undefined;
    botRequested?: boolean;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export class GameBoard implements IGameBoard {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string;
    playerTwoId?: string | undefined;
    gameDifficulty?: Difficulty;
    readonly isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
    gameRequestId?: string | undefined;
    currentPlayersTurn?: string | undefined;
    singlePlayGameHints?: number | undefined;
    botGame?: boolean;
    ranked?: boolean;
    isGameValid?: boolean;
    playerOne?: PlayerState | undefined;
    playerTwo?: PlayerState | undefined;
    endGameSummary?: EndGameSummary | undefined;
    gameRequest?: GameRequest | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;

    constructor(data?: IGameBoard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerOne = data.playerOne && !(<any>data.playerOne).toJSON ? new PlayerState(data.playerOne) : <PlayerState>this.playerOne;
            this.playerTwo = data.playerTwo && !(<any>data.playerTwo).toJSON ? new PlayerState(data.playerTwo) : <PlayerState>this.playerTwo;
            this.endGameSummary = data.endGameSummary && !(<any>data.endGameSummary).toJSON ? new EndGameSummary(data.endGameSummary) : <EndGameSummary>this.endGameSummary;
            this.gameRequest = data.gameRequest && !(<any>data.gameRequest).toJSON ? new GameRequest(data.gameRequest) : <GameRequest>this.gameRequest;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.currentBoard = _data["currentBoard"];
            this.playerOneId = _data["playerOneId"];
            this.playerTwoId = _data["playerTwoId"];
            this.gameDifficulty = _data["gameDifficulty"];
            (<any>this).isSinglePlayer = _data["isSinglePlayer"];
            this.gameStatus = _data["gameStatus"];
            this.gameRequestId = _data["gameRequestId"];
            this.currentPlayersTurn = _data["currentPlayersTurn"];
            this.singlePlayGameHints = _data["singlePlayGameHints"];
            this.botGame = _data["botGame"];
            this.ranked = _data["ranked"];
            this.isGameValid = _data["isGameValid"];
            this.playerOne = _data["playerOne"] ? PlayerState.fromJS(_data["playerOne"]) : <any>undefined;
            this.playerTwo = _data["playerTwo"] ? PlayerState.fromJS(_data["playerTwo"]) : <any>undefined;
            this.endGameSummary = _data["endGameSummary"] ? EndGameSummary.fromJS(_data["endGameSummary"]) : <any>undefined;
            this.gameRequest = _data["gameRequest"] ? GameRequest.fromJS(_data["gameRequest"]) : <any>undefined;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersionStamp = _data["rowVersionStamp"];
        }
    }

    static fromJS(data: any): GameBoard {
        data = typeof data === 'object' ? data : {};
        let result = new GameBoard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["currentBoard"] = this.currentBoard;
        data["playerOneId"] = this.playerOneId;
        data["playerTwoId"] = this.playerTwoId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["gameStatus"] = this.gameStatus;
        data["gameRequestId"] = this.gameRequestId;
        data["currentPlayersTurn"] = this.currentPlayersTurn;
        data["singlePlayGameHints"] = this.singlePlayGameHints;
        data["botGame"] = this.botGame;
        data["ranked"] = this.ranked;
        data["isGameValid"] = this.isGameValid;
        data["playerOne"] = this.playerOne ? this.playerOne.toJSON() : <any>undefined;
        data["playerTwo"] = this.playerTwo ? this.playerTwo.toJSON() : <any>undefined;
        data["endGameSummary"] = this.endGameSummary ? this.endGameSummary.toJSON() : <any>undefined;
        data["gameRequest"] = this.gameRequest ? this.gameRequest.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersionStamp"] = this.rowVersionStamp;
        return data;
    }

    clone(): GameBoard {
        const json = this.toJSON();
        let result = new GameBoard();
        result.init(json);
        return result;
    }
}

export interface IGameBoard {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string;
    playerTwoId?: string | undefined;
    gameDifficulty?: Difficulty;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
    gameRequestId?: string | undefined;
    currentPlayersTurn?: string | undefined;
    singlePlayGameHints?: number | undefined;
    botGame?: boolean;
    ranked?: boolean;
    isGameValid?: boolean;
    playerOne?: IPlayerState | undefined;
    playerTwo?: IPlayerState | undefined;
    endGameSummary?: IEndGameSummary | undefined;
    gameRequest?: IGameRequest | undefined;
    id?: string;
    createdById?: string;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedById?: string;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersionStamp?: string | undefined;
}

export class GetGamesCommandResponse implements IGetGamesCommandResponse {
    games?: GameBoard[] | undefined;
    messages?: string | undefined;

    constructor(data?: IGetGamesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.games) {
                this.games = [];
                for (let i = 0; i < data.games.length; i++) {
                    let item = data.games[i];
                    this.games[i] = item && !(<any>item).toJSON ? new GameBoard(item) : <GameBoard>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(GameBoard.fromJS(item));
            }
            this.messages = _data["messages"];
        }
    }

    static fromJS(data: any): GetGamesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGamesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        data["messages"] = this.messages;
        return data;
    }

    clone(): GetGamesCommandResponse {
        const json = this.toJSON();
        let result = new GetGamesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetGamesCommandResponse {
    games?: IGameBoard[] | undefined;
    messages?: string | undefined;
}

export class SimplePlayerScores implements ISimplePlayerScores {
    username?: string | undefined;
    rankName?: string | undefined;
    rankScore?: number;
    score?: number;
    remainingMoves?: number;
    errors?: number;
    hintsUsed?: number;
    adsWatched?: number;
    moreTimeUsed?: number;
    timeTaken?: string | undefined;
    plays?: string | undefined;
    playerErrrors?: string | undefined;
    notes?: string | undefined;
    playerId?: string | undefined;
    userId?: string | undefined;
    isLoggedIn?: boolean;
    icon?: number | undefined;
    countryCode?: string | undefined;
    inputsMade?: number;

    constructor(data?: ISimplePlayerScores) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.rankName = _data["rankName"];
            this.rankScore = _data["rankScore"];
            this.score = _data["score"];
            this.remainingMoves = _data["remainingMoves"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.adsWatched = _data["adsWatched"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.timeTaken = _data["timeTaken"];
            this.plays = _data["plays"];
            this.playerErrrors = _data["playerErrrors"];
            this.notes = _data["notes"];
            this.playerId = _data["playerId"];
            this.userId = _data["userId"];
            this.isLoggedIn = _data["isLoggedIn"];
            this.icon = _data["icon"];
            this.countryCode = _data["countryCode"];
            this.inputsMade = _data["inputsMade"];
        }
    }

    static fromJS(data: any): SimplePlayerScores {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePlayerScores();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["rankName"] = this.rankName;
        data["rankScore"] = this.rankScore;
        data["score"] = this.score;
        data["remainingMoves"] = this.remainingMoves;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["adsWatched"] = this.adsWatched;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["timeTaken"] = this.timeTaken;
        data["plays"] = this.plays;
        data["playerErrrors"] = this.playerErrrors;
        data["notes"] = this.notes;
        data["playerId"] = this.playerId;
        data["userId"] = this.userId;
        data["isLoggedIn"] = this.isLoggedIn;
        data["icon"] = this.icon;
        data["countryCode"] = this.countryCode;
        data["inputsMade"] = this.inputsMade;
        return data;
    }

    clone(): SimplePlayerScores {
        const json = this.toJSON();
        let result = new SimplePlayerScores();
        result.init(json);
        return result;
    }
}

export interface ISimplePlayerScores {
    username?: string | undefined;
    rankName?: string | undefined;
    rankScore?: number;
    score?: number;
    remainingMoves?: number;
    errors?: number;
    hintsUsed?: number;
    adsWatched?: number;
    moreTimeUsed?: number;
    timeTaken?: string | undefined;
    plays?: string | undefined;
    playerErrrors?: string | undefined;
    notes?: string | undefined;
    playerId?: string | undefined;
    userId?: string | undefined;
    isLoggedIn?: boolean;
    icon?: number | undefined;
    countryCode?: string | undefined;
    inputsMade?: number;
}

export class PlayerMatch implements IPlayerMatch {
    gameId?: string;
    playerOne?: SimplePlayerScores | undefined;
    playerTwo?: SimplePlayerScores | undefined;
    isCurrentUsersTurn?: boolean;
    difficulty?: string | undefined;
    isBotGame?: boolean;
    isRanked?: boolean;

    constructor(data?: IPlayerMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerOne = data.playerOne && !(<any>data.playerOne).toJSON ? new SimplePlayerScores(data.playerOne) : <SimplePlayerScores>this.playerOne;
            this.playerTwo = data.playerTwo && !(<any>data.playerTwo).toJSON ? new SimplePlayerScores(data.playerTwo) : <SimplePlayerScores>this.playerTwo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.playerOne = _data["playerOne"] ? SimplePlayerScores.fromJS(_data["playerOne"]) : <any>undefined;
            this.playerTwo = _data["playerTwo"] ? SimplePlayerScores.fromJS(_data["playerTwo"]) : <any>undefined;
            this.isCurrentUsersTurn = _data["isCurrentUsersTurn"];
            this.difficulty = _data["difficulty"];
            this.isBotGame = _data["isBotGame"];
            this.isRanked = _data["isRanked"];
        }
    }

    static fromJS(data: any): PlayerMatch {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["playerOne"] = this.playerOne ? this.playerOne.toJSON() : <any>undefined;
        data["playerTwo"] = this.playerTwo ? this.playerTwo.toJSON() : <any>undefined;
        data["isCurrentUsersTurn"] = this.isCurrentUsersTurn;
        data["difficulty"] = this.difficulty;
        data["isBotGame"] = this.isBotGame;
        data["isRanked"] = this.isRanked;
        return data;
    }

    clone(): PlayerMatch {
        const json = this.toJSON();
        let result = new PlayerMatch();
        result.init(json);
        return result;
    }
}

export interface IPlayerMatch {
    gameId?: string;
    playerOne?: ISimplePlayerScores | undefined;
    playerTwo?: ISimplePlayerScores | undefined;
    isCurrentUsersTurn?: boolean;
    difficulty?: string | undefined;
    isBotGame?: boolean;
    isRanked?: boolean;
}

export class GetActiveGamesCommandResponse implements IGetActiveGamesCommandResponse {
    queuedMatch?: PlayerMatch | undefined;
    matches?: PlayerMatch[] | undefined;

    constructor(data?: IGetActiveGamesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.queuedMatch = data.queuedMatch && !(<any>data.queuedMatch).toJSON ? new PlayerMatch(data.queuedMatch) : <PlayerMatch>this.queuedMatch;
            if (data.matches) {
                this.matches = [];
                for (let i = 0; i < data.matches.length; i++) {
                    let item = data.matches[i];
                    this.matches[i] = item && !(<any>item).toJSON ? new PlayerMatch(item) : <PlayerMatch>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queuedMatch = _data["queuedMatch"] ? PlayerMatch.fromJS(_data["queuedMatch"]) : <any>undefined;
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(PlayerMatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActiveGamesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveGamesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queuedMatch"] = this.queuedMatch ? this.queuedMatch.toJSON() : <any>undefined;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetActiveGamesCommandResponse {
        const json = this.toJSON();
        let result = new GetActiveGamesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetActiveGamesCommandResponse {
    queuedMatch?: IPlayerMatch | undefined;
    matches?: IPlayerMatch[] | undefined;
}

export class GetLastSinglePlayerGameCommandResponse implements IGetLastSinglePlayerGameCommandResponse {
    gameId?: string;
    playerId?: string;
    userId?: string;
    score?: number;
    difficulty?: Difficulty;
    errors?: number;
    hintsUsed?: number;
    adsWatched?: number;
    timeTaken?: string | undefined;
    plays?: string | undefined;
    playerErrors?: string | undefined;
    gameStatus?: GameStatus;

    constructor(data?: IGetLastSinglePlayerGameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.playerId = _data["playerId"];
            this.userId = _data["userId"];
            this.score = _data["score"];
            this.difficulty = _data["difficulty"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.adsWatched = _data["adsWatched"];
            this.timeTaken = _data["timeTaken"];
            this.plays = _data["plays"];
            this.playerErrors = _data["playerErrors"];
            this.gameStatus = _data["gameStatus"];
        }
    }

    static fromJS(data: any): GetLastSinglePlayerGameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLastSinglePlayerGameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["playerId"] = this.playerId;
        data["userId"] = this.userId;
        data["score"] = this.score;
        data["difficulty"] = this.difficulty;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["adsWatched"] = this.adsWatched;
        data["timeTaken"] = this.timeTaken;
        data["plays"] = this.plays;
        data["playerErrors"] = this.playerErrors;
        data["gameStatus"] = this.gameStatus;
        return data;
    }

    clone(): GetLastSinglePlayerGameCommandResponse {
        const json = this.toJSON();
        let result = new GetLastSinglePlayerGameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetLastSinglePlayerGameCommandResponse {
    gameId?: string;
    playerId?: string;
    userId?: string;
    score?: number;
    difficulty?: Difficulty;
    errors?: number;
    hintsUsed?: number;
    adsWatched?: number;
    timeTaken?: string | undefined;
    plays?: string | undefined;
    playerErrors?: string | undefined;
    gameStatus?: GameStatus;
}

export class SaveBoardCommandRequest implements ISaveBoardCommandRequest {
    gameId?: string | undefined;
    user1Id?: string | undefined;
    user2Id?: string | undefined;
    solution?: string | undefined;
    currentBoard?: string | undefined;
    isSinglePlayer?: boolean;
    difficulty?: Difficulty;
    requestId?: string | undefined;
    endTurn?: boolean;
    ranked?: boolean;
    playerNotes?: string | undefined;
    playerMoves?: string | undefined;
    playerErrors?: string | undefined;

    constructor(data?: ISaveBoardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.user1Id = _data["user1Id"];
            this.user2Id = _data["user2Id"];
            this.solution = _data["solution"];
            this.currentBoard = _data["currentBoard"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.difficulty = _data["difficulty"];
            this.requestId = _data["requestId"];
            this.endTurn = _data["endTurn"];
            this.ranked = _data["ranked"];
            this.playerNotes = _data["playerNotes"];
            this.playerMoves = _data["playerMoves"];
            this.playerErrors = _data["playerErrors"];
        }
    }

    static fromJS(data: any): SaveBoardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBoardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["user1Id"] = this.user1Id;
        data["user2Id"] = this.user2Id;
        data["solution"] = this.solution;
        data["currentBoard"] = this.currentBoard;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["difficulty"] = this.difficulty;
        data["requestId"] = this.requestId;
        data["endTurn"] = this.endTurn;
        data["ranked"] = this.ranked;
        data["playerNotes"] = this.playerNotes;
        data["playerMoves"] = this.playerMoves;
        data["playerErrors"] = this.playerErrors;
        return data;
    }

    clone(): SaveBoardCommandRequest {
        const json = this.toJSON();
        let result = new SaveBoardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveBoardCommandRequest {
    gameId?: string | undefined;
    user1Id?: string | undefined;
    user2Id?: string | undefined;
    solution?: string | undefined;
    currentBoard?: string | undefined;
    isSinglePlayer?: boolean;
    difficulty?: Difficulty;
    requestId?: string | undefined;
    endTurn?: boolean;
    ranked?: boolean;
    playerNotes?: string | undefined;
    playerMoves?: string | undefined;
    playerErrors?: string | undefined;
}

export class MiniEndGamePlayerStats implements IMiniEndGamePlayerStats {
    playerId?: string;
    playerUsername?: string | undefined;
    playerRank?: string | undefined;
    winLossReason?: string | undefined;
    gainedRating?: number;
    currentRating?: number;
    ratingText?: string | undefined;
    score?: number;
    highScore?: boolean;
    numbersPlaced?: number;
    errors?: number;
    hintsUsed?: number;
    moreTimeUsed?: number;
    timeTaken?: string | undefined;
    isWinner?: boolean;
    dateFinished?: string;
    userId?: string;
    isLoggedIn?: boolean;
    countryCode?: string | undefined;
    icon?: number | undefined;
    inputsMade?: number | undefined;

    constructor(data?: IMiniEndGamePlayerStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerUsername = _data["playerUsername"];
            this.playerRank = _data["playerRank"];
            this.winLossReason = _data["winLossReason"];
            this.gainedRating = _data["gainedRating"];
            this.currentRating = _data["currentRating"];
            this.ratingText = _data["ratingText"];
            this.score = _data["score"];
            this.highScore = _data["highScore"];
            this.numbersPlaced = _data["numbersPlaced"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.timeTaken = _data["timeTaken"];
            this.isWinner = _data["isWinner"];
            this.dateFinished = _data["dateFinished"];
            this.userId = _data["userId"];
            this.isLoggedIn = _data["isLoggedIn"];
            this.countryCode = _data["countryCode"];
            this.icon = _data["icon"];
            this.inputsMade = _data["inputsMade"];
        }
    }

    static fromJS(data: any): MiniEndGamePlayerStats {
        data = typeof data === 'object' ? data : {};
        let result = new MiniEndGamePlayerStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerUsername"] = this.playerUsername;
        data["playerRank"] = this.playerRank;
        data["winLossReason"] = this.winLossReason;
        data["gainedRating"] = this.gainedRating;
        data["currentRating"] = this.currentRating;
        data["ratingText"] = this.ratingText;
        data["score"] = this.score;
        data["highScore"] = this.highScore;
        data["numbersPlaced"] = this.numbersPlaced;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["timeTaken"] = this.timeTaken;
        data["isWinner"] = this.isWinner;
        data["dateFinished"] = this.dateFinished;
        data["userId"] = this.userId;
        data["isLoggedIn"] = this.isLoggedIn;
        data["countryCode"] = this.countryCode;
        data["icon"] = this.icon;
        data["inputsMade"] = this.inputsMade;
        return data;
    }

    clone(): MiniEndGamePlayerStats {
        const json = this.toJSON();
        let result = new MiniEndGamePlayerStats();
        result.init(json);
        return result;
    }
}

export interface IMiniEndGamePlayerStats {
    playerId?: string;
    playerUsername?: string | undefined;
    playerRank?: string | undefined;
    winLossReason?: string | undefined;
    gainedRating?: number;
    currentRating?: number;
    ratingText?: string | undefined;
    score?: number;
    highScore?: boolean;
    numbersPlaced?: number;
    errors?: number;
    hintsUsed?: number;
    moreTimeUsed?: number;
    timeTaken?: string | undefined;
    isWinner?: boolean;
    dateFinished?: string;
    userId?: string;
    isLoggedIn?: boolean;
    countryCode?: string | undefined;
    icon?: number | undefined;
    inputsMade?: number | undefined;
}

export class EndGameSummaryModel implements IEndGameSummaryModel {
    gameId?: string;
    gameCompleted?: boolean;
    isSinglePlayer?: boolean;
    dateFinished?: string;
    difficultyLevel?: Difficulty;
    isBotGame?: boolean;
    isRanked?: boolean;
    playerOne?: MiniEndGamePlayerStats | undefined;
    playerTwo?: MiniEndGamePlayerStats | undefined;

    constructor(data?: IEndGameSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerOne = data.playerOne && !(<any>data.playerOne).toJSON ? new MiniEndGamePlayerStats(data.playerOne) : <MiniEndGamePlayerStats>this.playerOne;
            this.playerTwo = data.playerTwo && !(<any>data.playerTwo).toJSON ? new MiniEndGamePlayerStats(data.playerTwo) : <MiniEndGamePlayerStats>this.playerTwo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.gameCompleted = _data["gameCompleted"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.dateFinished = _data["dateFinished"];
            this.difficultyLevel = _data["difficultyLevel"];
            this.isBotGame = _data["isBotGame"];
            this.isRanked = _data["isRanked"];
            this.playerOne = _data["playerOne"] ? MiniEndGamePlayerStats.fromJS(_data["playerOne"]) : <any>undefined;
            this.playerTwo = _data["playerTwo"] ? MiniEndGamePlayerStats.fromJS(_data["playerTwo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EndGameSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndGameSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["gameCompleted"] = this.gameCompleted;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["dateFinished"] = this.dateFinished;
        data["difficultyLevel"] = this.difficultyLevel;
        data["isBotGame"] = this.isBotGame;
        data["isRanked"] = this.isRanked;
        data["playerOne"] = this.playerOne ? this.playerOne.toJSON() : <any>undefined;
        data["playerTwo"] = this.playerTwo ? this.playerTwo.toJSON() : <any>undefined;
        return data;
    }

    clone(): EndGameSummaryModel {
        const json = this.toJSON();
        let result = new EndGameSummaryModel();
        result.init(json);
        return result;
    }
}

export interface IEndGameSummaryModel {
    gameId?: string;
    gameCompleted?: boolean;
    isSinglePlayer?: boolean;
    dateFinished?: string;
    difficultyLevel?: Difficulty;
    isBotGame?: boolean;
    isRanked?: boolean;
    playerOne?: IMiniEndGamePlayerStats | undefined;
    playerTwo?: IMiniEndGamePlayerStats | undefined;
}

export class SaveBoardCommandResponse implements ISaveBoardCommandResponse {
    gameId?: string;
    playerOneId?: string;
    playerTwoId?: string | undefined;
    success?: boolean;
    currentUsersTurn?: string | undefined;
    gameSummary?: EndGameSummaryModel | undefined;

    constructor(data?: ISaveBoardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.gameSummary = data.gameSummary && !(<any>data.gameSummary).toJSON ? new EndGameSummaryModel(data.gameSummary) : <EndGameSummaryModel>this.gameSummary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.playerOneId = _data["playerOneId"];
            this.playerTwoId = _data["playerTwoId"];
            this.success = _data["success"];
            this.currentUsersTurn = _data["currentUsersTurn"];
            this.gameSummary = _data["gameSummary"] ? EndGameSummaryModel.fromJS(_data["gameSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveBoardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBoardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["playerOneId"] = this.playerOneId;
        data["playerTwoId"] = this.playerTwoId;
        data["success"] = this.success;
        data["currentUsersTurn"] = this.currentUsersTurn;
        data["gameSummary"] = this.gameSummary ? this.gameSummary.toJSON() : <any>undefined;
        return data;
    }

    clone(): SaveBoardCommandResponse {
        const json = this.toJSON();
        let result = new SaveBoardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveBoardCommandResponse {
    gameId?: string;
    playerOneId?: string;
    playerTwoId?: string | undefined;
    success?: boolean;
    currentUsersTurn?: string | undefined;
    gameSummary?: IEndGameSummaryModel | undefined;
}

export class SaveTurnCommandRequest implements ISaveTurnCommandRequest {
    gameId?: string | undefined;
    user1Id?: string | undefined;
    user2Id?: string | undefined;
    solution?: string | undefined;
    currentBoard?: string | undefined;
    isSinglePlayer?: boolean;
    difficulty?: Difficulty | undefined;
    requestId?: string | undefined;
    endTurn?: boolean;
    playerId?: string | undefined;
    score?: number | undefined;
    moves?: number | undefined;
    errors?: number | undefined;
    hintsUsed?: number | undefined;
    moreTimeUsed?: number | undefined;
    adsWatched?: number | undefined;
    timeTaken?: number | undefined;
    playerNotes?: string | undefined;
    playerMoves?: string | undefined;
    playerErrors?: string | undefined;

    constructor(data?: ISaveTurnCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.user1Id = _data["user1Id"];
            this.user2Id = _data["user2Id"];
            this.solution = _data["solution"];
            this.currentBoard = _data["currentBoard"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.difficulty = _data["difficulty"];
            this.requestId = _data["requestId"];
            this.endTurn = _data["endTurn"];
            this.playerId = _data["playerId"];
            this.score = _data["score"];
            this.moves = _data["moves"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.adsWatched = _data["adsWatched"];
            this.timeTaken = _data["timeTaken"];
            this.playerNotes = _data["playerNotes"];
            this.playerMoves = _data["playerMoves"];
            this.playerErrors = _data["playerErrors"];
        }
    }

    static fromJS(data: any): SaveTurnCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTurnCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["user1Id"] = this.user1Id;
        data["user2Id"] = this.user2Id;
        data["solution"] = this.solution;
        data["currentBoard"] = this.currentBoard;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["difficulty"] = this.difficulty;
        data["requestId"] = this.requestId;
        data["endTurn"] = this.endTurn;
        data["playerId"] = this.playerId;
        data["score"] = this.score;
        data["moves"] = this.moves;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["adsWatched"] = this.adsWatched;
        data["timeTaken"] = this.timeTaken;
        data["playerNotes"] = this.playerNotes;
        data["playerMoves"] = this.playerMoves;
        data["playerErrors"] = this.playerErrors;
        return data;
    }

    clone(): SaveTurnCommandRequest {
        const json = this.toJSON();
        let result = new SaveTurnCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveTurnCommandRequest {
    gameId?: string | undefined;
    user1Id?: string | undefined;
    user2Id?: string | undefined;
    solution?: string | undefined;
    currentBoard?: string | undefined;
    isSinglePlayer?: boolean;
    difficulty?: Difficulty | undefined;
    requestId?: string | undefined;
    endTurn?: boolean;
    playerId?: string | undefined;
    score?: number | undefined;
    moves?: number | undefined;
    errors?: number | undefined;
    hintsUsed?: number | undefined;
    moreTimeUsed?: number | undefined;
    adsWatched?: number | undefined;
    timeTaken?: number | undefined;
    playerNotes?: string | undefined;
    playerMoves?: string | undefined;
    playerErrors?: string | undefined;
}

export class SaveTurnCommandResponse implements ISaveTurnCommandResponse {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string | undefined;
    playerTwoId?: string | undefined;
    gameDifficulty?: Difficulty;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
    isCurrentUsersTurn?: boolean;
    currentUsersTurnPlayerId?: string | undefined;
    playerOne?: SimplePlayerScores | undefined;
    playerTwo?: SimplePlayerScores | undefined;
    gameSummary?: EndGameSummaryModel | undefined;
    errors?: string[] | undefined;

    constructor(data?: ISaveTurnCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerOne = data.playerOne && !(<any>data.playerOne).toJSON ? new SimplePlayerScores(data.playerOne) : <SimplePlayerScores>this.playerOne;
            this.playerTwo = data.playerTwo && !(<any>data.playerTwo).toJSON ? new SimplePlayerScores(data.playerTwo) : <SimplePlayerScores>this.playerTwo;
            this.gameSummary = data.gameSummary && !(<any>data.gameSummary).toJSON ? new EndGameSummaryModel(data.gameSummary) : <EndGameSummaryModel>this.gameSummary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.currentBoard = _data["currentBoard"];
            this.playerOneId = _data["playerOneId"];
            this.playerTwoId = _data["playerTwoId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.gameStatus = _data["gameStatus"];
            this.isCurrentUsersTurn = _data["isCurrentUsersTurn"];
            this.currentUsersTurnPlayerId = _data["currentUsersTurnPlayerId"];
            this.playerOne = _data["playerOne"] ? SimplePlayerScores.fromJS(_data["playerOne"]) : <any>undefined;
            this.playerTwo = _data["playerTwo"] ? SimplePlayerScores.fromJS(_data["playerTwo"]) : <any>undefined;
            this.gameSummary = _data["gameSummary"] ? EndGameSummaryModel.fromJS(_data["gameSummary"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveTurnCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTurnCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["currentBoard"] = this.currentBoard;
        data["playerOneId"] = this.playerOneId;
        data["playerTwoId"] = this.playerTwoId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["gameStatus"] = this.gameStatus;
        data["isCurrentUsersTurn"] = this.isCurrentUsersTurn;
        data["currentUsersTurnPlayerId"] = this.currentUsersTurnPlayerId;
        data["playerOne"] = this.playerOne ? this.playerOne.toJSON() : <any>undefined;
        data["playerTwo"] = this.playerTwo ? this.playerTwo.toJSON() : <any>undefined;
        data["gameSummary"] = this.gameSummary ? this.gameSummary.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): SaveTurnCommandResponse {
        const json = this.toJSON();
        let result = new SaveTurnCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveTurnCommandResponse {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string | undefined;
    playerTwoId?: string | undefined;
    gameDifficulty?: Difficulty;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
    isCurrentUsersTurn?: boolean;
    currentUsersTurnPlayerId?: string | undefined;
    playerOne?: ISimplePlayerScores | undefined;
    playerTwo?: ISimplePlayerScores | undefined;
    gameSummary?: IEndGameSummaryModel | undefined;
    errors?: string[] | undefined;
}

export class GetBoardByGameIdCommandRequest implements IGetBoardByGameIdCommandRequest {
    gameId?: string | undefined;

    constructor(data?: IGetBoardByGameIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): GetBoardByGameIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoardByGameIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): GetBoardByGameIdCommandRequest {
        const json = this.toJSON();
        let result = new GetBoardByGameIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetBoardByGameIdCommandRequest {
    gameId?: string | undefined;
}

export class GetBoardByGameIdCommandResponse implements IGetBoardByGameIdCommandResponse {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string | undefined;
    playerTwoId?: string | undefined;
    gameDifficulty?: string | undefined;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
    isCurrentUsersTurn?: boolean;
    isBotGame?: boolean;
    isRanked?: boolean;
    currentUsersTurnPlayerId?: string | undefined;
    playerOne?: SimplePlayerScores | undefined;
    playerTwo?: SimplePlayerScores | undefined;
    gameSummary?: EndGameSummaryModel | undefined;

    constructor(data?: IGetBoardByGameIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerOne = data.playerOne && !(<any>data.playerOne).toJSON ? new SimplePlayerScores(data.playerOne) : <SimplePlayerScores>this.playerOne;
            this.playerTwo = data.playerTwo && !(<any>data.playerTwo).toJSON ? new SimplePlayerScores(data.playerTwo) : <SimplePlayerScores>this.playerTwo;
            this.gameSummary = data.gameSummary && !(<any>data.gameSummary).toJSON ? new EndGameSummaryModel(data.gameSummary) : <EndGameSummaryModel>this.gameSummary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.currentBoard = _data["currentBoard"];
            this.playerOneId = _data["playerOneId"];
            this.playerTwoId = _data["playerTwoId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.gameStatus = _data["gameStatus"];
            this.isCurrentUsersTurn = _data["isCurrentUsersTurn"];
            this.isBotGame = _data["isBotGame"];
            this.isRanked = _data["isRanked"];
            this.currentUsersTurnPlayerId = _data["currentUsersTurnPlayerId"];
            this.playerOne = _data["playerOne"] ? SimplePlayerScores.fromJS(_data["playerOne"]) : <any>undefined;
            this.playerTwo = _data["playerTwo"] ? SimplePlayerScores.fromJS(_data["playerTwo"]) : <any>undefined;
            this.gameSummary = _data["gameSummary"] ? EndGameSummaryModel.fromJS(_data["gameSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBoardByGameIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoardByGameIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["currentBoard"] = this.currentBoard;
        data["playerOneId"] = this.playerOneId;
        data["playerTwoId"] = this.playerTwoId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["gameStatus"] = this.gameStatus;
        data["isCurrentUsersTurn"] = this.isCurrentUsersTurn;
        data["isBotGame"] = this.isBotGame;
        data["isRanked"] = this.isRanked;
        data["currentUsersTurnPlayerId"] = this.currentUsersTurnPlayerId;
        data["playerOne"] = this.playerOne ? this.playerOne.toJSON() : <any>undefined;
        data["playerTwo"] = this.playerTwo ? this.playerTwo.toJSON() : <any>undefined;
        data["gameSummary"] = this.gameSummary ? this.gameSummary.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBoardByGameIdCommandResponse {
        const json = this.toJSON();
        let result = new GetBoardByGameIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBoardByGameIdCommandResponse {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string | undefined;
    playerTwoId?: string | undefined;
    gameDifficulty?: string | undefined;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
    isCurrentUsersTurn?: boolean;
    isBotGame?: boolean;
    isRanked?: boolean;
    currentUsersTurnPlayerId?: string | undefined;
    playerOne?: ISimplePlayerScores | undefined;
    playerTwo?: ISimplePlayerScores | undefined;
    gameSummary?: IEndGameSummaryModel | undefined;
}

export class UpdateGameStatusCommandRequest implements IUpdateGameStatusCommandRequest {
    gameId?: string;
    gameStatus?: number;

    constructor(data?: IUpdateGameStatusCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.gameStatus = _data["gameStatus"];
        }
    }

    static fromJS(data: any): UpdateGameStatusCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGameStatusCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["gameStatus"] = this.gameStatus;
        return data;
    }

    clone(): UpdateGameStatusCommandRequest {
        const json = this.toJSON();
        let result = new UpdateGameStatusCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateGameStatusCommandRequest {
    gameId?: string;
    gameStatus?: number;
}

export class UpdateGameStatusCommandResponse implements IUpdateGameStatusCommandResponse {
    gameId?: string;
    status?: GameStatus;
    message?: string | undefined;

    constructor(data?: IUpdateGameStatusCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateGameStatusCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGameStatusCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }

    clone(): UpdateGameStatusCommandResponse {
        const json = this.toJSON();
        let result = new UpdateGameStatusCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateGameStatusCommandResponse {
    gameId?: string;
    status?: GameStatus;
    message?: string | undefined;
}

export class GetGameSummaryByGameIdCommandRequest implements IGetGameSummaryByGameIdCommandRequest {
    gameId?: string;

    constructor(data?: IGetGameSummaryByGameIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): GetGameSummaryByGameIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameSummaryByGameIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): GetGameSummaryByGameIdCommandRequest {
        const json = this.toJSON();
        let result = new GetGameSummaryByGameIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetGameSummaryByGameIdCommandRequest {
    gameId?: string;
}

export class GetGameSummaryByGameIdCommandResponse implements IGetGameSummaryByGameIdCommandResponse {
    gameSummary?: EndGameSummaryModel | undefined;

    constructor(data?: IGetGameSummaryByGameIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.gameSummary = data.gameSummary && !(<any>data.gameSummary).toJSON ? new EndGameSummaryModel(data.gameSummary) : <EndGameSummaryModel>this.gameSummary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameSummary = _data["gameSummary"] ? EndGameSummaryModel.fromJS(_data["gameSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameSummaryByGameIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameSummaryByGameIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameSummary"] = this.gameSummary ? this.gameSummary.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetGameSummaryByGameIdCommandResponse {
        const json = this.toJSON();
        let result = new GetGameSummaryByGameIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetGameSummaryByGameIdCommandResponse {
    gameSummary?: IEndGameSummaryModel | undefined;
}

export class GetAllGameSummariesForPlayerCommandResponse implements IGetAllGameSummariesForPlayerCommandResponse {
    gameSummaries?: EndGameSummaryModel[] | undefined;

    constructor(data?: IGetAllGameSummariesForPlayerCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.gameSummaries) {
                this.gameSummaries = [];
                for (let i = 0; i < data.gameSummaries.length; i++) {
                    let item = data.gameSummaries[i];
                    this.gameSummaries[i] = item && !(<any>item).toJSON ? new EndGameSummaryModel(item) : <EndGameSummaryModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gameSummaries"])) {
                this.gameSummaries = [] as any;
                for (let item of _data["gameSummaries"])
                    this.gameSummaries!.push(EndGameSummaryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllGameSummariesForPlayerCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameSummariesForPlayerCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gameSummaries)) {
            data["gameSummaries"] = [];
            for (let item of this.gameSummaries)
                data["gameSummaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllGameSummariesForPlayerCommandResponse {
        const json = this.toJSON();
        let result = new GetAllGameSummariesForPlayerCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllGameSummariesForPlayerCommandResponse {
    gameSummaries?: IEndGameSummaryModel[] | undefined;
}

export class GenerateBoardCommandRequest implements IGenerateBoardCommandRequest {
    difficulty?: Difficulty;

    constructor(data?: IGenerateBoardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.difficulty = _data["difficulty"];
        }
    }

    static fromJS(data: any): GenerateBoardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateBoardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["difficulty"] = this.difficulty;
        return data;
    }

    clone(): GenerateBoardCommandRequest {
        const json = this.toJSON();
        let result = new GenerateBoardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGenerateBoardCommandRequest {
    difficulty?: Difficulty;
}

export class GenerateBoardCommandResponse implements IGenerateBoardCommandResponse {
    board?: string | undefined;
    difficulty?: Difficulty;

    constructor(data?: IGenerateBoardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.board = _data["board"];
            this.difficulty = _data["difficulty"];
        }
    }

    static fromJS(data: any): GenerateBoardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateBoardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["board"] = this.board;
        data["difficulty"] = this.difficulty;
        return data;
    }

    clone(): GenerateBoardCommandResponse {
        const json = this.toJSON();
        let result = new GenerateBoardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGenerateBoardCommandResponse {
    board?: string | undefined;
    difficulty?: Difficulty;
}

export class GetAvailablePlaysCommandRequest implements IGetAvailablePlaysCommandRequest {
    board?: string | undefined;
    gameId?: string | undefined;

    constructor(data?: IGetAvailablePlaysCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.board = _data["board"];
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): GetAvailablePlaysCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailablePlaysCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["board"] = this.board;
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): GetAvailablePlaysCommandRequest {
        const json = this.toJSON();
        let result = new GetAvailablePlaysCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAvailablePlaysCommandRequest {
    board?: string | undefined;
    gameId?: string | undefined;
}

export class GetAvailablePlaysCommandResponse implements IGetAvailablePlaysCommandResponse {
    plays?: number[] | undefined;

    constructor(data?: IGetAvailablePlaysCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plays"])) {
                this.plays = [] as any;
                for (let item of _data["plays"])
                    this.plays!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAvailablePlaysCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailablePlaysCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plays)) {
            data["plays"] = [];
            for (let item of this.plays)
                data["plays"].push(item);
        }
        return data;
    }

    clone(): GetAvailablePlaysCommandResponse {
        const json = this.toJSON();
        let result = new GetAvailablePlaysCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAvailablePlaysCommandResponse {
    plays?: number[] | undefined;
}

export class SolveBoardCommandRequest implements ISolveBoardCommandRequest {
    gameId?: string | undefined;
    board?: string | undefined;

    constructor(data?: ISolveBoardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.board = _data["board"];
        }
    }

    static fromJS(data: any): SolveBoardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SolveBoardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["board"] = this.board;
        return data;
    }

    clone(): SolveBoardCommandRequest {
        const json = this.toJSON();
        let result = new SolveBoardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISolveBoardCommandRequest {
    gameId?: string | undefined;
    board?: string | undefined;
}

export class SolveBoardCommandResponse implements ISolveBoardCommandResponse {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string | undefined;
    playerTwoId?: string | undefined;
    gameDifficulty?: string | undefined;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;

    constructor(data?: ISolveBoardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"];
            this.currentBoard = _data["currentBoard"];
            this.playerOneId = _data["playerOneId"];
            this.playerTwoId = _data["playerTwoId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.gameStatus = _data["gameStatus"];
        }
    }

    static fromJS(data: any): SolveBoardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SolveBoardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solution"] = this.solution;
        data["currentBoard"] = this.currentBoard;
        data["playerOneId"] = this.playerOneId;
        data["playerTwoId"] = this.playerTwoId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["gameStatus"] = this.gameStatus;
        return data;
    }

    clone(): SolveBoardCommandResponse {
        const json = this.toJSON();
        let result = new SolveBoardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISolveBoardCommandResponse {
    solution?: string | undefined;
    currentBoard?: string | undefined;
    playerOneId?: string | undefined;
    playerTwoId?: string | undefined;
    gameDifficulty?: string | undefined;
    isSinglePlayer?: boolean;
    gameStatus?: GameStatus;
}

export class QueryShareRewardCommandRequest implements IQueryShareRewardCommandRequest {
    gameId?: string;

    constructor(data?: IQueryShareRewardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): QueryShareRewardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QueryShareRewardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): QueryShareRewardCommandRequest {
        const json = this.toJSON();
        let result = new QueryShareRewardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IQueryShareRewardCommandRequest {
    gameId?: string;
}

export class QueryShareRewardCommandResponse implements IQueryShareRewardCommandResponse {
    success?: boolean;

    constructor(data?: IQueryShareRewardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): QueryShareRewardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QueryShareRewardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): QueryShareRewardCommandResponse {
        const json = this.toJSON();
        let result = new QueryShareRewardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IQueryShareRewardCommandResponse {
    success?: boolean;
}

export class GetBotGameCommandRequest implements IGetBotGameCommandRequest {
    ranked?: boolean;
    difficulty?: Difficulty;

    constructor(data?: IGetBotGameCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ranked = _data["ranked"];
            this.difficulty = _data["difficulty"];
        }
    }

    static fromJS(data: any): GetBotGameCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBotGameCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ranked"] = this.ranked;
        data["difficulty"] = this.difficulty;
        return data;
    }

    clone(): GetBotGameCommandRequest {
        const json = this.toJSON();
        let result = new GetBotGameCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetBotGameCommandRequest {
    ranked?: boolean;
    difficulty?: Difficulty;
}

export class GetBotGameCommandResponse implements IGetBotGameCommandResponse {
    gameRequestId?: string;
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    hasExistingBotGame?: boolean;

    constructor(data?: IGetBotGameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameRequestId = _data["gameRequestId"];
            this.requestorId = _data["requestorId"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.gameRequestStatus = _data["gameRequestStatus"];
            this.hasExistingBotGame = _data["hasExistingBotGame"];
        }
    }

    static fromJS(data: any): GetBotGameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBotGameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameRequestId"] = this.gameRequestId;
        data["requestorId"] = this.requestorId;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["gameRequestStatus"] = this.gameRequestStatus;
        data["hasExistingBotGame"] = this.hasExistingBotGame;
        return data;
    }

    clone(): GetBotGameCommandResponse {
        const json = this.toJSON();
        let result = new GetBotGameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBotGameCommandResponse {
    gameRequestId?: string;
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    hasExistingBotGame?: boolean;
}

export class DailyChallengeCompletionModel implements IDailyChallengeCompletionModel {
    dailyGameId?: string;
    userId?: string;
    playerId?: string;
    hintsUsed?: number;
    errorsMade?: number;
    timeTaken?: number;
    solvedTime?: number | undefined;
    completionTime?: number | undefined;
    rank?: number;
    topPercent?: number;
    totalPlayers?: number;
    averageTimeTaken?: number;

    constructor(data?: IDailyChallengeCompletionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGameId = _data["dailyGameId"];
            this.userId = _data["userId"];
            this.playerId = _data["playerId"];
            this.hintsUsed = _data["hintsUsed"];
            this.errorsMade = _data["errorsMade"];
            this.timeTaken = _data["timeTaken"];
            this.solvedTime = _data["solvedTime"];
            this.completionTime = _data["completionTime"];
            this.rank = _data["rank"];
            this.topPercent = _data["topPercent"];
            this.totalPlayers = _data["totalPlayers"];
            this.averageTimeTaken = _data["averageTimeTaken"];
        }
    }

    static fromJS(data: any): DailyChallengeCompletionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyChallengeCompletionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGameId"] = this.dailyGameId;
        data["userId"] = this.userId;
        data["playerId"] = this.playerId;
        data["hintsUsed"] = this.hintsUsed;
        data["errorsMade"] = this.errorsMade;
        data["timeTaken"] = this.timeTaken;
        data["solvedTime"] = this.solvedTime;
        data["completionTime"] = this.completionTime;
        data["rank"] = this.rank;
        data["topPercent"] = this.topPercent;
        data["totalPlayers"] = this.totalPlayers;
        data["averageTimeTaken"] = this.averageTimeTaken;
        return data;
    }

    clone(): DailyChallengeCompletionModel {
        const json = this.toJSON();
        let result = new DailyChallengeCompletionModel();
        result.init(json);
        return result;
    }
}

export interface IDailyChallengeCompletionModel {
    dailyGameId?: string;
    userId?: string;
    playerId?: string;
    hintsUsed?: number;
    errorsMade?: number;
    timeTaken?: number;
    solvedTime?: number | undefined;
    completionTime?: number | undefined;
    rank?: number;
    topPercent?: number;
    totalPlayers?: number;
    averageTimeTaken?: number;
}

export class GetDailyGameCommandResponse implements IGetDailyGameCommandResponse {
    dailyGameId?: string;
    difficulty?: Difficulty;
    board?: string | undefined;
    maxErrors?: number;
    maxHints?: number;
    gameCompleted?: boolean;
    completionStats?: DailyChallengeCompletionModel | undefined;

    constructor(data?: IGetDailyGameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.completionStats = data.completionStats && !(<any>data.completionStats).toJSON ? new DailyChallengeCompletionModel(data.completionStats) : <DailyChallengeCompletionModel>this.completionStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGameId = _data["dailyGameId"];
            this.difficulty = _data["difficulty"];
            this.board = _data["board"];
            this.maxErrors = _data["maxErrors"];
            this.maxHints = _data["maxHints"];
            this.gameCompleted = _data["gameCompleted"];
            this.completionStats = _data["completionStats"] ? DailyChallengeCompletionModel.fromJS(_data["completionStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDailyGameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyGameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGameId"] = this.dailyGameId;
        data["difficulty"] = this.difficulty;
        data["board"] = this.board;
        data["maxErrors"] = this.maxErrors;
        data["maxHints"] = this.maxHints;
        data["gameCompleted"] = this.gameCompleted;
        data["completionStats"] = this.completionStats ? this.completionStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetDailyGameCommandResponse {
        const json = this.toJSON();
        let result = new GetDailyGameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDailyGameCommandResponse {
    dailyGameId?: string;
    difficulty?: Difficulty;
    board?: string | undefined;
    maxErrors?: number;
    maxHints?: number;
    gameCompleted?: boolean;
    completionStats?: IDailyChallengeCompletionModel | undefined;
}

export class SubmitDailyGameCommandRequest implements ISubmitDailyGameCommandRequest {
    dailyGameId?: string;
    submittedBoard?: string | undefined;
    errors?: number;
    hints?: number;
    timeTaken?: number;

    constructor(data?: ISubmitDailyGameCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGameId = _data["dailyGameId"];
            this.submittedBoard = _data["submittedBoard"];
            this.errors = _data["errors"];
            this.hints = _data["hints"];
            this.timeTaken = _data["timeTaken"];
        }
    }

    static fromJS(data: any): SubmitDailyGameCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitDailyGameCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGameId"] = this.dailyGameId;
        data["submittedBoard"] = this.submittedBoard;
        data["errors"] = this.errors;
        data["hints"] = this.hints;
        data["timeTaken"] = this.timeTaken;
        return data;
    }

    clone(): SubmitDailyGameCommandRequest {
        const json = this.toJSON();
        let result = new SubmitDailyGameCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISubmitDailyGameCommandRequest {
    dailyGameId?: string;
    submittedBoard?: string | undefined;
    errors?: number;
    hints?: number;
    timeTaken?: number;
}

export class DailyGameCompletionModel implements IDailyGameCompletionModel {
    dailyGameId?: string;
    userId?: string;
    playerId?: string;
    errorsMade?: number;
    hintsUsed?: number;
    timeTaken?: number;
    completionTime?: number | undefined;

    constructor(data?: IDailyGameCompletionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGameId = _data["dailyGameId"];
            this.userId = _data["userId"];
            this.playerId = _data["playerId"];
            this.errorsMade = _data["errorsMade"];
            this.hintsUsed = _data["hintsUsed"];
            this.timeTaken = _data["timeTaken"];
            this.completionTime = _data["completionTime"];
        }
    }

    static fromJS(data: any): DailyGameCompletionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyGameCompletionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGameId"] = this.dailyGameId;
        data["userId"] = this.userId;
        data["playerId"] = this.playerId;
        data["errorsMade"] = this.errorsMade;
        data["hintsUsed"] = this.hintsUsed;
        data["timeTaken"] = this.timeTaken;
        data["completionTime"] = this.completionTime;
        return data;
    }

    clone(): DailyGameCompletionModel {
        const json = this.toJSON();
        let result = new DailyGameCompletionModel();
        result.init(json);
        return result;
    }
}

export interface IDailyGameCompletionModel {
    dailyGameId?: string;
    userId?: string;
    playerId?: string;
    errorsMade?: number;
    hintsUsed?: number;
    timeTaken?: number;
    completionTime?: number | undefined;
}

export class SubmitDailyGameCommandResponse implements ISubmitDailyGameCommandResponse {
    dailyGameId?: string;
    difficulty?: Difficulty;
    board?: string | undefined;
    maxErrors?: number;
    maxHints?: number;
    gameCompleted?: boolean;
    completionStats?: DailyGameCompletionModel | undefined;

    constructor(data?: ISubmitDailyGameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.completionStats = data.completionStats && !(<any>data.completionStats).toJSON ? new DailyGameCompletionModel(data.completionStats) : <DailyGameCompletionModel>this.completionStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGameId = _data["dailyGameId"];
            this.difficulty = _data["difficulty"];
            this.board = _data["board"];
            this.maxErrors = _data["maxErrors"];
            this.maxHints = _data["maxHints"];
            this.gameCompleted = _data["gameCompleted"];
            this.completionStats = _data["completionStats"] ? DailyGameCompletionModel.fromJS(_data["completionStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitDailyGameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitDailyGameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGameId"] = this.dailyGameId;
        data["difficulty"] = this.difficulty;
        data["board"] = this.board;
        data["maxErrors"] = this.maxErrors;
        data["maxHints"] = this.maxHints;
        data["gameCompleted"] = this.gameCompleted;
        data["completionStats"] = this.completionStats ? this.completionStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): SubmitDailyGameCommandResponse {
        const json = this.toJSON();
        let result = new SubmitDailyGameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISubmitDailyGameCommandResponse {
    dailyGameId?: string;
    difficulty?: Difficulty;
    board?: string | undefined;
    maxErrors?: number;
    maxHints?: number;
    gameCompleted?: boolean;
    completionStats?: IDailyGameCompletionModel | undefined;
}

export class SimpleDailyChallengeDayInfo implements ISimpleDailyChallengeDayInfo {
    day?: number;
    dailyChallengeId?: string | undefined;
    date?: string;
    challengeExists?: boolean;
    isCompleted?: boolean;
    isSolved?: boolean;
    isCurrentDay?: boolean;
    isPastDay?: boolean;
    isFutureDay?: boolean;

    constructor(data?: ISimpleDailyChallengeDayInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.dailyChallengeId = _data["dailyChallengeId"];
            this.date = _data["date"];
            this.challengeExists = _data["challengeExists"];
            this.isCompleted = _data["isCompleted"];
            this.isSolved = _data["isSolved"];
            this.isCurrentDay = _data["isCurrentDay"];
            this.isPastDay = _data["isPastDay"];
            this.isFutureDay = _data["isFutureDay"];
        }
    }

    static fromJS(data: any): SimpleDailyChallengeDayInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleDailyChallengeDayInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["dailyChallengeId"] = this.dailyChallengeId;
        data["date"] = this.date;
        data["challengeExists"] = this.challengeExists;
        data["isCompleted"] = this.isCompleted;
        data["isSolved"] = this.isSolved;
        data["isCurrentDay"] = this.isCurrentDay;
        data["isPastDay"] = this.isPastDay;
        data["isFutureDay"] = this.isFutureDay;
        return data;
    }

    clone(): SimpleDailyChallengeDayInfo {
        const json = this.toJSON();
        let result = new SimpleDailyChallengeDayInfo();
        result.init(json);
        return result;
    }
}

export interface ISimpleDailyChallengeDayInfo {
    day?: number;
    dailyChallengeId?: string | undefined;
    date?: string;
    challengeExists?: boolean;
    isCompleted?: boolean;
    isSolved?: boolean;
    isCurrentDay?: boolean;
    isPastDay?: boolean;
    isFutureDay?: boolean;
}

export class GetMonthlyDailyChallengesCommandResponse implements IGetMonthlyDailyChallengesCommandResponse {
    month?: number;
    year?: number;
    monthName?: string | undefined;
    totalDays?: number;
    completedDays?: number;
    days?: SimpleDailyChallengeDayInfo[] | undefined;

    constructor(data?: IGetMonthlyDailyChallengesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.days) {
                this.days = [];
                for (let i = 0; i < data.days.length; i++) {
                    let item = data.days[i];
                    this.days[i] = item && !(<any>item).toJSON ? new SimpleDailyChallengeDayInfo(item) : <SimpleDailyChallengeDayInfo>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.monthName = _data["monthName"];
            this.totalDays = _data["totalDays"];
            this.completedDays = _data["completedDays"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(SimpleDailyChallengeDayInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMonthlyDailyChallengesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlyDailyChallengesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["monthName"] = this.monthName;
        data["totalDays"] = this.totalDays;
        data["completedDays"] = this.completedDays;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetMonthlyDailyChallengesCommandResponse {
        const json = this.toJSON();
        let result = new GetMonthlyDailyChallengesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMonthlyDailyChallengesCommandResponse {
    month?: number;
    year?: number;
    monthName?: string | undefined;
    totalDays?: number;
    completedDays?: number;
    days?: ISimpleDailyChallengeDayInfo[] | undefined;
}

export enum DailyGameAccessType {
    Subscription = "Subscription",
    RewardedAd = "RewardedAd",
    Promotion = "Promotion",
    Gift = "Gift",
    Admin = "Admin",
}

export class GetDailyChallengeCommandResponse implements IGetDailyChallengeCommandResponse {
    day?: number;
    date?: string;
    dailyGameId?: string | undefined;
    board?: string | undefined;
    challengeExists?: boolean;
    isCompleted?: boolean;
    isSolved?: boolean;
    maxErrors?: number | undefined;
    maxHints?: number | undefined;
    completionStats?: DailyChallengeCompletionModel | undefined;
    isCurrentDay?: boolean;
    isFutureDay?: boolean;
    isPastDay?: boolean;
    hasAccess?: boolean;
    accessType?: DailyGameAccessType | undefined;

    constructor(data?: IGetDailyChallengeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.completionStats = data.completionStats && !(<any>data.completionStats).toJSON ? new DailyChallengeCompletionModel(data.completionStats) : <DailyChallengeCompletionModel>this.completionStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.date = _data["date"];
            this.dailyGameId = _data["dailyGameId"];
            this.board = _data["board"];
            this.challengeExists = _data["challengeExists"];
            this.isCompleted = _data["isCompleted"];
            this.isSolved = _data["isSolved"];
            this.maxErrors = _data["maxErrors"];
            this.maxHints = _data["maxHints"];
            this.completionStats = _data["completionStats"] ? DailyChallengeCompletionModel.fromJS(_data["completionStats"]) : <any>undefined;
            this.isCurrentDay = _data["isCurrentDay"];
            this.isFutureDay = _data["isFutureDay"];
            this.isPastDay = _data["isPastDay"];
            this.hasAccess = _data["hasAccess"];
            this.accessType = _data["accessType"];
        }
    }

    static fromJS(data: any): GetDailyChallengeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyChallengeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["date"] = this.date;
        data["dailyGameId"] = this.dailyGameId;
        data["board"] = this.board;
        data["challengeExists"] = this.challengeExists;
        data["isCompleted"] = this.isCompleted;
        data["isSolved"] = this.isSolved;
        data["maxErrors"] = this.maxErrors;
        data["maxHints"] = this.maxHints;
        data["completionStats"] = this.completionStats ? this.completionStats.toJSON() : <any>undefined;
        data["isCurrentDay"] = this.isCurrentDay;
        data["isFutureDay"] = this.isFutureDay;
        data["isPastDay"] = this.isPastDay;
        data["hasAccess"] = this.hasAccess;
        data["accessType"] = this.accessType;
        return data;
    }

    clone(): GetDailyChallengeCommandResponse {
        const json = this.toJSON();
        let result = new GetDailyChallengeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDailyChallengeCommandResponse {
    day?: number;
    date?: string;
    dailyGameId?: string | undefined;
    board?: string | undefined;
    challengeExists?: boolean;
    isCompleted?: boolean;
    isSolved?: boolean;
    maxErrors?: number | undefined;
    maxHints?: number | undefined;
    completionStats?: IDailyChallengeCompletionModel | undefined;
    isCurrentDay?: boolean;
    isFutureDay?: boolean;
    isPastDay?: boolean;
    hasAccess?: boolean;
    accessType?: DailyGameAccessType | undefined;
}

export class EnsureDailyGameAccessCommandRequest implements IEnsureDailyGameAccessCommandRequest {
    dailyGameId?: string;
    accessType?: DailyGameAccessType;
    expiresOn?: string | undefined;

    constructor(data?: IEnsureDailyGameAccessCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyGameId = _data["dailyGameId"];
            this.accessType = _data["accessType"];
            this.expiresOn = _data["expiresOn"];
        }
    }

    static fromJS(data: any): EnsureDailyGameAccessCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnsureDailyGameAccessCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyGameId"] = this.dailyGameId;
        data["accessType"] = this.accessType;
        data["expiresOn"] = this.expiresOn;
        return data;
    }

    clone(): EnsureDailyGameAccessCommandRequest {
        const json = this.toJSON();
        let result = new EnsureDailyGameAccessCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEnsureDailyGameAccessCommandRequest {
    dailyGameId?: string;
    accessType?: DailyGameAccessType;
    expiresOn?: string | undefined;
}

export class EnsureDailyGameAccessCommandResponse implements IEnsureDailyGameAccessCommandResponse {
    hasAccess?: boolean;
    newlyGranted?: boolean;
    upgraded?: boolean;
    accessMethod?: string | undefined;

    constructor(data?: IEnsureDailyGameAccessCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAccess = _data["hasAccess"];
            this.newlyGranted = _data["newlyGranted"];
            this.upgraded = _data["upgraded"];
            this.accessMethod = _data["accessMethod"];
        }
    }

    static fromJS(data: any): EnsureDailyGameAccessCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsureDailyGameAccessCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAccess"] = this.hasAccess;
        data["newlyGranted"] = this.newlyGranted;
        data["upgraded"] = this.upgraded;
        data["accessMethod"] = this.accessMethod;
        return data;
    }

    clone(): EnsureDailyGameAccessCommandResponse {
        const json = this.toJSON();
        let result = new EnsureDailyGameAccessCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEnsureDailyGameAccessCommandResponse {
    hasAccess?: boolean;
    newlyGranted?: boolean;
    upgraded?: boolean;
    accessMethod?: string | undefined;
}

export class GetDailyChallengeAccessCommandResponse implements IGetDailyChallengeAccessCommandResponse {
    hasAccess?: boolean;
    canWatchAd?: boolean;
    requiresSubscription?: boolean;
    isCurrentDay?: boolean;
    accessType?: DailyGameAccessType | undefined;
    expiresOn?: string | undefined;

    constructor(data?: IGetDailyChallengeAccessCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAccess = _data["hasAccess"];
            this.canWatchAd = _data["canWatchAd"];
            this.requiresSubscription = _data["requiresSubscription"];
            this.isCurrentDay = _data["isCurrentDay"];
            this.accessType = _data["accessType"];
            this.expiresOn = _data["expiresOn"];
        }
    }

    static fromJS(data: any): GetDailyChallengeAccessCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyChallengeAccessCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAccess"] = this.hasAccess;
        data["canWatchAd"] = this.canWatchAd;
        data["requiresSubscription"] = this.requiresSubscription;
        data["isCurrentDay"] = this.isCurrentDay;
        data["accessType"] = this.accessType;
        data["expiresOn"] = this.expiresOn;
        return data;
    }

    clone(): GetDailyChallengeAccessCommandResponse {
        const json = this.toJSON();
        let result = new GetDailyChallengeAccessCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetDailyChallengeAccessCommandResponse {
    hasAccess?: boolean;
    canWatchAd?: boolean;
    requiresSubscription?: boolean;
    isCurrentDay?: boolean;
    accessType?: DailyGameAccessType | undefined;
    expiresOn?: string | undefined;
}

export class RequestAccountDeletionCommandResponse implements IRequestAccountDeletionCommandResponse {
    readonly success?: boolean;
    readonly message?: string | undefined;

    constructor(data?: IRequestAccountDeletionCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).success = _data["success"];
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): RequestAccountDeletionCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestAccountDeletionCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }

    clone(): RequestAccountDeletionCommandResponse {
        const json = this.toJSON();
        let result = new RequestAccountDeletionCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRequestAccountDeletionCommandResponse {
    success?: boolean;
    message?: string | undefined;
}

export class MemoryStream implements IMemoryStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canWrite?: boolean;
    capacity?: number;
    readonly length?: number;
    position?: number;
    readonly canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IMemoryStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            this.capacity = _data["capacity"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): MemoryStream {
        data = typeof data === 'object' ? data : {};
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }

    clone(): MemoryStream {
        const json = this.toJSON();
        let result = new MemoryStream();
        result.init(json);
        return result;
    }
}

export interface IMemoryStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export class GetFileQueryResponse implements IGetFileQueryResponse {
    file?: MemoryStream | undefined;
    readonly name?: string | undefined;
    extension?: string | undefined;
    readonly mimeType?: string | undefined;

    constructor(data?: IGetFileQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.file = data.file && !(<any>data.file).toJSON ? new MemoryStream(data.file) : <MemoryStream>this.file;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? MemoryStream.fromJS(_data["file"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.extension = _data["extension"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): GetFileQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): GetFileQueryResponse {
        const json = this.toJSON();
        let result = new GetFileQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFileQueryResponse {
    file?: IMemoryStream | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
}

export class KnowledgeBotQueryCommandRequest implements IKnowledgeBotQueryCommandRequest {
    userInput?: string | undefined;

    constructor(data?: IKnowledgeBotQueryCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInput = _data["userInput"];
        }
    }

    static fromJS(data: any): KnowledgeBotQueryCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeBotQueryCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInput"] = this.userInput;
        return data;
    }

    clone(): KnowledgeBotQueryCommandRequest {
        const json = this.toJSON();
        let result = new KnowledgeBotQueryCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeBotQueryCommandRequest {
    userInput?: string | undefined;
}

export class KnowledgeBotQueryCommandResponse implements IKnowledgeBotQueryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    quickReplies?: string[] | undefined;

    constructor(data?: IKnowledgeBotQueryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["quickReplies"])) {
                this.quickReplies = [] as any;
                for (let item of _data["quickReplies"])
                    this.quickReplies!.push(item);
            }
        }
    }

    static fromJS(data: any): KnowledgeBotQueryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeBotQueryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.quickReplies)) {
            data["quickReplies"] = [];
            for (let item of this.quickReplies)
                data["quickReplies"].push(item);
        }
        return data;
    }

    clone(): KnowledgeBotQueryCommandResponse {
        const json = this.toJSON();
        let result = new KnowledgeBotQueryCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IKnowledgeBotQueryCommandResponse {
    success?: boolean;
    message?: string | undefined;
    quickReplies?: string[] | undefined;
}

export enum NotificationType {
    Reminder = "Reminder",
    FriendRequest = "FriendRequest",
    MatchRequest = "MatchRequest",
    PlayersTurn = "PlayersTurn",
    DailyGame = "DailyGame",
    Rewards = "Rewards",
}

export class MiniMilestone implements IMiniMilestone {
    id?: string;
    key?: string | undefined;
    level?: number;

    constructor(data?: IMiniMilestone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): MiniMilestone {
        data = typeof data === 'object' ? data : {};
        let result = new MiniMilestone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["level"] = this.level;
        return data;
    }

    clone(): MiniMilestone {
        const json = this.toJSON();
        let result = new MiniMilestone();
        result.init(json);
        return result;
    }
}

export interface IMiniMilestone {
    id?: string;
    key?: string | undefined;
    level?: number;
}

export class MiniReward implements IMiniReward {
    id?: string;
    boards?: number;
    hints?: number;
    moreTime?: number;
    adFreeDays?: number;
    claimed?: boolean;
    claimedDate?: string | undefined;
    rewardType?: string | undefined;
    milestone?: MiniMilestone | undefined;

    constructor(data?: IMiniReward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.milestone = data.milestone && !(<any>data.milestone).toJSON ? new MiniMilestone(data.milestone) : <MiniMilestone>this.milestone;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.moreTime = _data["moreTime"];
            this.adFreeDays = _data["adFreeDays"];
            this.claimed = _data["claimed"];
            this.claimedDate = _data["claimedDate"];
            this.rewardType = _data["rewardType"];
            this.milestone = _data["milestone"] ? MiniMilestone.fromJS(_data["milestone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MiniReward {
        data = typeof data === 'object' ? data : {};
        let result = new MiniReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["moreTime"] = this.moreTime;
        data["adFreeDays"] = this.adFreeDays;
        data["claimed"] = this.claimed;
        data["claimedDate"] = this.claimedDate;
        data["rewardType"] = this.rewardType;
        data["milestone"] = this.milestone ? this.milestone.toJSON() : <any>undefined;
        return data;
    }

    clone(): MiniReward {
        const json = this.toJSON();
        let result = new MiniReward();
        result.init(json);
        return result;
    }
}

export interface IMiniReward {
    id?: string;
    boards?: number;
    hints?: number;
    moreTime?: number;
    adFreeDays?: number;
    claimed?: boolean;
    claimedDate?: string | undefined;
    rewardType?: string | undefined;
    milestone?: IMiniMilestone | undefined;
}

export class MiniNotification implements IMiniNotification {
    id?: string;
    type?: NotificationType;
    title?: string | undefined;
    message?: string | undefined;
    isRead?: boolean;
    creationDate?: string | undefined;
    reward?: MiniReward | undefined;

    constructor(data?: IMiniNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.reward = data.reward && !(<any>data.reward).toJSON ? new MiniReward(data.reward) : <MiniReward>this.reward;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.isRead = _data["isRead"];
            this.creationDate = _data["creationDate"];
            this.reward = _data["reward"] ? MiniReward.fromJS(_data["reward"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MiniNotification {
        data = typeof data === 'object' ? data : {};
        let result = new MiniNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["message"] = this.message;
        data["isRead"] = this.isRead;
        data["creationDate"] = this.creationDate;
        data["reward"] = this.reward ? this.reward.toJSON() : <any>undefined;
        return data;
    }

    clone(): MiniNotification {
        const json = this.toJSON();
        let result = new MiniNotification();
        result.init(json);
        return result;
    }
}

export interface IMiniNotification {
    id?: string;
    type?: NotificationType;
    title?: string | undefined;
    message?: string | undefined;
    isRead?: boolean;
    creationDate?: string | undefined;
    reward?: IMiniReward | undefined;
}

export class GetAllPlayerNotificationCommandResponse implements IGetAllPlayerNotificationCommandResponse {
    success?: boolean;
    notifications?: MiniNotification[] | undefined;

    constructor(data?: IGetAllPlayerNotificationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.notifications) {
                this.notifications = [];
                for (let i = 0; i < data.notifications.length; i++) {
                    let item = data.notifications[i];
                    this.notifications[i] = item && !(<any>item).toJSON ? new MiniNotification(item) : <MiniNotification>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(MiniNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPlayerNotificationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlayerNotificationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllPlayerNotificationCommandResponse {
        const json = this.toJSON();
        let result = new GetAllPlayerNotificationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllPlayerNotificationCommandResponse {
    success?: boolean;
    notifications?: IMiniNotification[] | undefined;
}

export class GetUnreadNotificationsCommandResponse implements IGetUnreadNotificationsCommandResponse {
    success?: boolean;
    notifications?: MiniNotification[] | undefined;

    constructor(data?: IGetUnreadNotificationsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.notifications) {
                this.notifications = [];
                for (let i = 0; i < data.notifications.length; i++) {
                    let item = data.notifications[i];
                    this.notifications[i] = item && !(<any>item).toJSON ? new MiniNotification(item) : <MiniNotification>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(MiniNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUnreadNotificationsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnreadNotificationsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUnreadNotificationsCommandResponse {
        const json = this.toJSON();
        let result = new GetUnreadNotificationsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUnreadNotificationsCommandResponse {
    success?: boolean;
    notifications?: IMiniNotification[] | undefined;
}

export class GetAllAchievementsCommandResponse implements IGetAllAchievementsCommandResponse {
    success?: boolean;
    achievements?: MiniReward[] | undefined;

    constructor(data?: IGetAllAchievementsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.achievements) {
                this.achievements = [];
                for (let i = 0; i < data.achievements.length; i++) {
                    let item = data.achievements[i];
                    this.achievements[i] = item && !(<any>item).toJSON ? new MiniReward(item) : <MiniReward>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["achievements"])) {
                this.achievements = [] as any;
                for (let item of _data["achievements"])
                    this.achievements!.push(MiniReward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAchievementsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAchievementsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.achievements)) {
            data["achievements"] = [];
            for (let item of this.achievements)
                data["achievements"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllAchievementsCommandResponse {
        const json = this.toJSON();
        let result = new GetAllAchievementsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllAchievementsCommandResponse {
    success?: boolean;
    achievements?: IMiniReward[] | undefined;
}

export enum MilestoneCategory {
    DailyPlayStreak = "DailyPlayStreak",
    ConsecutiveWinStreak = "ConsecutiveWinStreak",
    SkillBasedWins = "SkillBasedWins",
    RankProgression = "RankProgression",
    SocialActivity = "SocialActivity",
    SpecialPromotion = "SpecialPromotion",
}

export enum MilestoneSubCategory {
    DailyVsPlayStreak = "DailyVsPlayStreak",
    DailySinglePlayStreak = "DailySinglePlayStreak",
    DailyChallengeStreak = "DailyChallengeStreak",
    TotalVsWins = "TotalVsWins",
    ConsecutiveVSWins = "ConsecutiveVSWins",
    ConsecutiveSingleWins = "ConsecutiveSingleWins",
    SkillBasedVsWins = "SkillBasedVsWins",
    SkillBasedSingleWins = "SkillBasedSingleWins",
    SkillBasedDailyChallenge = "SkillBasedDailyChallenge",
    ReachApprentice = "ReachApprentice",
    ReachProfessional = "ReachProfessional",
    ReachExpert = "ReachExpert",
    ReachMaster = "ReachMaster",
    ReachGrandMaster = "ReachGrandMaster",
    UpdateUsername = "UpdateUsername",
    UpdateUserIcon = "UpdateUserIcon",
    UpdateFlag = "UpdateFlag",
    AddFriend = "AddFriend",
    ShareGameResult = "ShareGameResult",
}

export class MiniAchievement implements IMiniAchievement {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    milestoneType?: string | undefined;
    rewardType?: string | undefined;
    key?: string | undefined;
    level?: number;
    boards?: number;
    hints?: number;
    adFreeDays?: number;
    multiple?: boolean;
    category?: MilestoneCategory;
    milestone?: MilestoneSubCategory;

    constructor(data?: IMiniAchievement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.milestoneType = _data["milestoneType"];
            this.rewardType = _data["rewardType"];
            this.key = _data["key"];
            this.level = _data["level"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.adFreeDays = _data["adFreeDays"];
            this.multiple = _data["multiple"];
            this.category = _data["category"];
            this.milestone = _data["milestone"];
        }
    }

    static fromJS(data: any): MiniAchievement {
        data = typeof data === 'object' ? data : {};
        let result = new MiniAchievement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["milestoneType"] = this.milestoneType;
        data["rewardType"] = this.rewardType;
        data["key"] = this.key;
        data["level"] = this.level;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["adFreeDays"] = this.adFreeDays;
        data["multiple"] = this.multiple;
        data["category"] = this.category;
        data["milestone"] = this.milestone;
        return data;
    }

    clone(): MiniAchievement {
        const json = this.toJSON();
        let result = new MiniAchievement();
        result.init(json);
        return result;
    }
}

export interface IMiniAchievement {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    milestoneType?: string | undefined;
    rewardType?: string | undefined;
    key?: string | undefined;
    level?: number;
    boards?: number;
    hints?: number;
    adFreeDays?: number;
    multiple?: boolean;
    category?: MilestoneCategory;
    milestone?: MilestoneSubCategory;
}

export class GetAllAchievementsQueryCommandResponse implements IGetAllAchievementsQueryCommandResponse {
    success?: boolean;
    achievements?: MiniAchievement[] | undefined;

    constructor(data?: IGetAllAchievementsQueryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.achievements) {
                this.achievements = [];
                for (let i = 0; i < data.achievements.length; i++) {
                    let item = data.achievements[i];
                    this.achievements[i] = item && !(<any>item).toJSON ? new MiniAchievement(item) : <MiniAchievement>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["achievements"])) {
                this.achievements = [] as any;
                for (let item of _data["achievements"])
                    this.achievements!.push(MiniAchievement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAchievementsQueryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAchievementsQueryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.achievements)) {
            data["achievements"] = [];
            for (let item of this.achievements)
                data["achievements"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllAchievementsQueryCommandResponse {
        const json = this.toJSON();
        let result = new GetAllAchievementsQueryCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllAchievementsQueryCommandResponse {
    success?: boolean;
    achievements?: IMiniAchievement[] | undefined;
}

export class MiniAchievementProgress implements IMiniAchievementProgress {
    id?: string;
    milestoneKey?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    milestoneType?: string | undefined;
    rewardType?: string | undefined;
    targetValue?: number;
    boards?: number;
    hints?: number;
    adFreeDays?: number;
    multiple?: boolean;
    category?: MilestoneCategory;
    milestone?: MilestoneSubCategory;
    currentProgress?: number;
    progressPercentage?: number;
    isCompleted?: boolean;
    completedDate?: string | undefined;
    rewardId?: string | undefined;
    isClaimed?: boolean;
    claimedDate?: string | undefined;

    constructor(data?: IMiniAchievementProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.milestoneKey = _data["milestoneKey"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.milestoneType = _data["milestoneType"];
            this.rewardType = _data["rewardType"];
            this.targetValue = _data["targetValue"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.adFreeDays = _data["adFreeDays"];
            this.multiple = _data["multiple"];
            this.category = _data["category"];
            this.milestone = _data["milestone"];
            this.currentProgress = _data["currentProgress"];
            this.progressPercentage = _data["progressPercentage"];
            this.isCompleted = _data["isCompleted"];
            this.completedDate = _data["completedDate"];
            this.rewardId = _data["rewardId"];
            this.isClaimed = _data["isClaimed"];
            this.claimedDate = _data["claimedDate"];
        }
    }

    static fromJS(data: any): MiniAchievementProgress {
        data = typeof data === 'object' ? data : {};
        let result = new MiniAchievementProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["milestoneKey"] = this.milestoneKey;
        data["title"] = this.title;
        data["description"] = this.description;
        data["milestoneType"] = this.milestoneType;
        data["rewardType"] = this.rewardType;
        data["targetValue"] = this.targetValue;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["adFreeDays"] = this.adFreeDays;
        data["multiple"] = this.multiple;
        data["category"] = this.category;
        data["milestone"] = this.milestone;
        data["currentProgress"] = this.currentProgress;
        data["progressPercentage"] = this.progressPercentage;
        data["isCompleted"] = this.isCompleted;
        data["completedDate"] = this.completedDate;
        data["rewardId"] = this.rewardId;
        data["isClaimed"] = this.isClaimed;
        data["claimedDate"] = this.claimedDate;
        return data;
    }

    clone(): MiniAchievementProgress {
        const json = this.toJSON();
        let result = new MiniAchievementProgress();
        result.init(json);
        return result;
    }
}

export interface IMiniAchievementProgress {
    id?: string;
    milestoneKey?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    milestoneType?: string | undefined;
    rewardType?: string | undefined;
    targetValue?: number;
    boards?: number;
    hints?: number;
    adFreeDays?: number;
    multiple?: boolean;
    category?: MilestoneCategory;
    milestone?: MilestoneSubCategory;
    currentProgress?: number;
    progressPercentage?: number;
    isCompleted?: boolean;
    completedDate?: string | undefined;
    rewardId?: string | undefined;
    isClaimed?: boolean;
    claimedDate?: string | undefined;
}

export class AchievementSubCategory implements IAchievementSubCategory {
    key?: string | undefined;
    subCategoryKey?: string | undefined;
    subCategoryLabel?: string | undefined;
    subTitle?: string | undefined;
    items?: MiniAchievementProgress[] | undefined;

    constructor(data?: IAchievementSubCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new MiniAchievementProgress(item) : <MiniAchievementProgress>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.subCategoryKey = _data["subCategoryKey"];
            this.subCategoryLabel = _data["subCategoryLabel"];
            this.subTitle = _data["subTitle"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MiniAchievementProgress.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AchievementSubCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementSubCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["subCategoryKey"] = this.subCategoryKey;
        data["subCategoryLabel"] = this.subCategoryLabel;
        data["subTitle"] = this.subTitle;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AchievementSubCategory {
        const json = this.toJSON();
        let result = new AchievementSubCategory();
        result.init(json);
        return result;
    }
}

export interface IAchievementSubCategory {
    key?: string | undefined;
    subCategoryKey?: string | undefined;
    subCategoryLabel?: string | undefined;
    subTitle?: string | undefined;
    items?: IMiniAchievementProgress[] | undefined;
}

export class GetAchievementsMilestonesResponse implements IGetAchievementsMilestonesResponse {
    success?: boolean;
    subCategories?: AchievementSubCategory[] | undefined;

    constructor(data?: IGetAchievementsMilestonesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subCategories) {
                this.subCategories = [];
                for (let i = 0; i < data.subCategories.length; i++) {
                    let item = data.subCategories[i];
                    this.subCategories[i] = item && !(<any>item).toJSON ? new AchievementSubCategory(item) : <AchievementSubCategory>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(AchievementSubCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAchievementsMilestonesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAchievementsMilestonesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAchievementsMilestonesResponse {
        const json = this.toJSON();
        let result = new GetAchievementsMilestonesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAchievementsMilestonesResponse {
    success?: boolean;
    subCategories?: IAchievementSubCategory[] | undefined;
}

export class GetAchievementsStreaksResponse implements IGetAchievementsStreaksResponse {
    success?: boolean;
    subCategories?: AchievementSubCategory[] | undefined;

    constructor(data?: IGetAchievementsStreaksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subCategories) {
                this.subCategories = [];
                for (let i = 0; i < data.subCategories.length; i++) {
                    let item = data.subCategories[i];
                    this.subCategories[i] = item && !(<any>item).toJSON ? new AchievementSubCategory(item) : <AchievementSubCategory>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(AchievementSubCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAchievementsStreaksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAchievementsStreaksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAchievementsStreaksResponse {
        const json = this.toJSON();
        let result = new GetAchievementsStreaksResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAchievementsStreaksResponse {
    success?: boolean;
    subCategories?: IAchievementSubCategory[] | undefined;
}

export class GetAchievementsSocialResponse implements IGetAchievementsSocialResponse {
    success?: boolean;
    subCategories?: AchievementSubCategory[] | undefined;

    constructor(data?: IGetAchievementsSocialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subCategories) {
                this.subCategories = [];
                for (let i = 0; i < data.subCategories.length; i++) {
                    let item = data.subCategories[i];
                    this.subCategories[i] = item && !(<any>item).toJSON ? new AchievementSubCategory(item) : <AchievementSubCategory>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(AchievementSubCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAchievementsSocialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAchievementsSocialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAchievementsSocialResponse {
        const json = this.toJSON();
        let result = new GetAchievementsSocialResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAchievementsSocialResponse {
    success?: boolean;
    subCategories?: IAchievementSubCategory[] | undefined;
}

export class ReadNotificationCommandResponse implements IReadNotificationCommandResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IReadNotificationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReadNotificationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReadNotificationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }

    clone(): ReadNotificationCommandResponse {
        const json = this.toJSON();
        let result = new ReadNotificationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IReadNotificationCommandResponse {
    success?: boolean;
    message?: string | undefined;
}

export class ReadAllNotificationsCommandResponse implements IReadAllNotificationsCommandResponse {
    success?: boolean;
    message?: string | undefined;
    readCount?: number;

    constructor(data?: IReadAllNotificationsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.readCount = _data["readCount"];
        }
    }

    static fromJS(data: any): ReadAllNotificationsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReadAllNotificationsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["readCount"] = this.readCount;
        return data;
    }

    clone(): ReadAllNotificationsCommandResponse {
        const json = this.toJSON();
        let result = new ReadAllNotificationsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IReadAllNotificationsCommandResponse {
    success?: boolean;
    message?: string | undefined;
    readCount?: number;
}

export class ClaimRewardCommandResponse implements IClaimRewardCommandResponse {
    success?: boolean;
    message?: string | undefined;
    boards?: number;
    hints?: number;
    moreTime?: number;
    adFreeDays?: number;

    constructor(data?: IClaimRewardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.moreTime = _data["moreTime"];
            this.adFreeDays = _data["adFreeDays"];
        }
    }

    static fromJS(data: any): ClaimRewardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimRewardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["moreTime"] = this.moreTime;
        data["adFreeDays"] = this.adFreeDays;
        return data;
    }

    clone(): ClaimRewardCommandResponse {
        const json = this.toJSON();
        let result = new ClaimRewardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IClaimRewardCommandResponse {
    success?: boolean;
    message?: string | undefined;
    boards?: number;
    hints?: number;
    moreTime?: number;
    adFreeDays?: number;
}

export class ClaimAllRewardsCommandResponse implements IClaimAllRewardsCommandResponse {
    success?: boolean;
    message?: string | undefined;
    boards?: number;
    hints?: number;
    moreTime?: number;
    adFreeDays?: number;

    constructor(data?: IClaimAllRewardsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.moreTime = _data["moreTime"];
            this.adFreeDays = _data["adFreeDays"];
        }
    }

    static fromJS(data: any): ClaimAllRewardsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAllRewardsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["moreTime"] = this.moreTime;
        data["adFreeDays"] = this.adFreeDays;
        return data;
    }

    clone(): ClaimAllRewardsCommandResponse {
        const json = this.toJSON();
        let result = new ClaimAllRewardsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IClaimAllRewardsCommandResponse {
    success?: boolean;
    message?: string | undefined;
    boards?: number;
    hints?: number;
    moreTime?: number;
    adFreeDays?: number;
}

export class PlayerRewardProgressModel implements IPlayerRewardProgressModel {
    vsGamesWon?: number;
    highestRank?: PlayerRank;
    consecutiveSingleWins?: number;
    maxDailySinglePlayStreak?: number;
    dailySinglePlayStreak?: number;
    consecutiveVsWins?: number;
    maxDailyVsPlayStreak?: number;
    dailyVsPlayStreak?: number;
    consecutiveSkillWins?: number;
    maxConsecutiveSkillWins?: number;
    consecutiveDailyChallengeWins?: number;
    consecutiveDailyChallengeAttempts?: number;

    constructor(data?: IPlayerRewardProgressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsGamesWon = _data["vsGamesWon"];
            this.highestRank = _data["highestRank"];
            this.consecutiveSingleWins = _data["consecutiveSingleWins"];
            this.maxDailySinglePlayStreak = _data["maxDailySinglePlayStreak"];
            this.dailySinglePlayStreak = _data["dailySinglePlayStreak"];
            this.consecutiveVsWins = _data["consecutiveVsWins"];
            this.maxDailyVsPlayStreak = _data["maxDailyVsPlayStreak"];
            this.dailyVsPlayStreak = _data["dailyVsPlayStreak"];
            this.consecutiveSkillWins = _data["consecutiveSkillWins"];
            this.maxConsecutiveSkillWins = _data["maxConsecutiveSkillWins"];
            this.consecutiveDailyChallengeWins = _data["consecutiveDailyChallengeWins"];
            this.consecutiveDailyChallengeAttempts = _data["consecutiveDailyChallengeAttempts"];
        }
    }

    static fromJS(data: any): PlayerRewardProgressModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerRewardProgressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsGamesWon"] = this.vsGamesWon;
        data["highestRank"] = this.highestRank;
        data["consecutiveSingleWins"] = this.consecutiveSingleWins;
        data["maxDailySinglePlayStreak"] = this.maxDailySinglePlayStreak;
        data["dailySinglePlayStreak"] = this.dailySinglePlayStreak;
        data["consecutiveVsWins"] = this.consecutiveVsWins;
        data["maxDailyVsPlayStreak"] = this.maxDailyVsPlayStreak;
        data["dailyVsPlayStreak"] = this.dailyVsPlayStreak;
        data["consecutiveSkillWins"] = this.consecutiveSkillWins;
        data["maxConsecutiveSkillWins"] = this.maxConsecutiveSkillWins;
        data["consecutiveDailyChallengeWins"] = this.consecutiveDailyChallengeWins;
        data["consecutiveDailyChallengeAttempts"] = this.consecutiveDailyChallengeAttempts;
        return data;
    }

    clone(): PlayerRewardProgressModel {
        const json = this.toJSON();
        let result = new PlayerRewardProgressModel();
        result.init(json);
        return result;
    }
}

export interface IPlayerRewardProgressModel {
    vsGamesWon?: number;
    highestRank?: PlayerRank;
    consecutiveSingleWins?: number;
    maxDailySinglePlayStreak?: number;
    dailySinglePlayStreak?: number;
    consecutiveVsWins?: number;
    maxDailyVsPlayStreak?: number;
    dailyVsPlayStreak?: number;
    consecutiveSkillWins?: number;
    maxConsecutiveSkillWins?: number;
    consecutiveDailyChallengeWins?: number;
    consecutiveDailyChallengeAttempts?: number;
}

export class GetRewardProgressCommandResponse implements IGetRewardProgressCommandResponse {
    success?: boolean;
    progress?: PlayerRewardProgressModel | undefined;

    constructor(data?: IGetRewardProgressCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.progress = data.progress && !(<any>data.progress).toJSON ? new PlayerRewardProgressModel(data.progress) : <PlayerRewardProgressModel>this.progress;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.progress = _data["progress"] ? PlayerRewardProgressModel.fromJS(_data["progress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRewardProgressCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRewardProgressCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["progress"] = this.progress ? this.progress.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetRewardProgressCommandResponse {
        const json = this.toJSON();
        let result = new GetRewardProgressCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRewardProgressCommandResponse {
    success?: boolean;
    progress?: IPlayerRewardProgressModel | undefined;
}

export class GetRewardProgressWithAchievementCommandResponse implements IGetRewardProgressWithAchievementCommandResponse {
    success?: boolean;
    progress?: MiniAchievementProgress[] | undefined;

    constructor(data?: IGetRewardProgressWithAchievementCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.progress) {
                this.progress = [];
                for (let i = 0; i < data.progress.length; i++) {
                    let item = data.progress[i];
                    this.progress[i] = item && !(<any>item).toJSON ? new MiniAchievementProgress(item) : <MiniAchievementProgress>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["progress"])) {
                this.progress = [] as any;
                for (let item of _data["progress"])
                    this.progress!.push(MiniAchievementProgress.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRewardProgressWithAchievementCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRewardProgressWithAchievementCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.progress)) {
            data["progress"] = [];
            for (let item of this.progress)
                data["progress"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetRewardProgressWithAchievementCommandResponse {
        const json = this.toJSON();
        let result = new GetRewardProgressWithAchievementCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRewardProgressWithAchievementCommandResponse {
    success?: boolean;
    progress?: IMiniAchievementProgress[] | undefined;
}

export class SpecialRewardDetails implements ISpecialRewardDetails {
    specialPromotionDefinitionId?: string;
    rewardId?: string;
    subCategory?: MilestoneSubCategory;
    mileStoneKey?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    htmlDescription?: string | undefined;
    rewardType?: string | undefined;
    progressCount?: number;
    progressGoal?: number;
    progressPercentage?: number;
    amountAvailable?: number;
    amountClaimed?: number;
    readonly slotsRemaining?: number;
    validTo?: string;
    validFrom?: string;
    readonly isExpired?: boolean;
    readonly canClaim?: boolean;
    giftCardSerialNumber?: string | undefined;
    isEarned?: boolean;
    isClaimed?: boolean;
    earnedDate?: string | undefined;
    readonly categoryLabel?: string | undefined;

    constructor(data?: ISpecialRewardDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialPromotionDefinitionId = _data["specialPromotionDefinitionId"];
            this.rewardId = _data["rewardId"];
            this.subCategory = _data["subCategory"];
            this.mileStoneKey = _data["mileStoneKey"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.htmlDescription = _data["htmlDescription"];
            this.rewardType = _data["rewardType"];
            this.progressCount = _data["progressCount"];
            this.progressGoal = _data["progressGoal"];
            this.progressPercentage = _data["progressPercentage"];
            this.amountAvailable = _data["amountAvailable"];
            this.amountClaimed = _data["amountClaimed"];
            (<any>this).slotsRemaining = _data["slotsRemaining"];
            this.validTo = _data["validTo"];
            this.validFrom = _data["validFrom"];
            (<any>this).isExpired = _data["isExpired"];
            (<any>this).canClaim = _data["canClaim"];
            this.giftCardSerialNumber = _data["giftCardSerialNumber"];
            this.isEarned = _data["isEarned"];
            this.isClaimed = _data["isClaimed"];
            this.earnedDate = _data["earnedDate"];
            (<any>this).categoryLabel = _data["categoryLabel"];
        }
    }

    static fromJS(data: any): SpecialRewardDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialRewardDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialPromotionDefinitionId"] = this.specialPromotionDefinitionId;
        data["rewardId"] = this.rewardId;
        data["subCategory"] = this.subCategory;
        data["mileStoneKey"] = this.mileStoneKey;
        data["title"] = this.title;
        data["description"] = this.description;
        data["htmlDescription"] = this.htmlDescription;
        data["rewardType"] = this.rewardType;
        data["progressCount"] = this.progressCount;
        data["progressGoal"] = this.progressGoal;
        data["progressPercentage"] = this.progressPercentage;
        data["amountAvailable"] = this.amountAvailable;
        data["amountClaimed"] = this.amountClaimed;
        data["slotsRemaining"] = this.slotsRemaining;
        data["validTo"] = this.validTo;
        data["validFrom"] = this.validFrom;
        data["isExpired"] = this.isExpired;
        data["canClaim"] = this.canClaim;
        data["giftCardSerialNumber"] = this.giftCardSerialNumber;
        data["isEarned"] = this.isEarned;
        data["isClaimed"] = this.isClaimed;
        data["earnedDate"] = this.earnedDate;
        data["categoryLabel"] = this.categoryLabel;
        return data;
    }

    clone(): SpecialRewardDetails {
        const json = this.toJSON();
        let result = new SpecialRewardDetails();
        result.init(json);
        return result;
    }
}

export interface ISpecialRewardDetails {
    specialPromotionDefinitionId?: string;
    rewardId?: string;
    subCategory?: MilestoneSubCategory;
    mileStoneKey?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    htmlDescription?: string | undefined;
    rewardType?: string | undefined;
    progressCount?: number;
    progressGoal?: number;
    progressPercentage?: number;
    amountAvailable?: number;
    amountClaimed?: number;
    slotsRemaining?: number;
    validTo?: string;
    validFrom?: string;
    isExpired?: boolean;
    canClaim?: boolean;
    giftCardSerialNumber?: string | undefined;
    isEarned?: boolean;
    isClaimed?: boolean;
    earnedDate?: string | undefined;
    categoryLabel?: string | undefined;
}

export class GetAllSpecialRewardsCommandResponse implements IGetAllSpecialRewardsCommandResponse {
    success?: boolean;
    allRewards?: SpecialRewardDetails[] | undefined;

    constructor(data?: IGetAllSpecialRewardsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.allRewards) {
                this.allRewards = [];
                for (let i = 0; i < data.allRewards.length; i++) {
                    let item = data.allRewards[i];
                    this.allRewards[i] = item && !(<any>item).toJSON ? new SpecialRewardDetails(item) : <SpecialRewardDetails>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["allRewards"])) {
                this.allRewards = [] as any;
                for (let item of _data["allRewards"])
                    this.allRewards!.push(SpecialRewardDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllSpecialRewardsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSpecialRewardsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.allRewards)) {
            data["allRewards"] = [];
            for (let item of this.allRewards)
                data["allRewards"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllSpecialRewardsCommandResponse {
        const json = this.toJSON();
        let result = new GetAllSpecialRewardsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllSpecialRewardsCommandResponse {
    success?: boolean;
    allRewards?: ISpecialRewardDetails[] | undefined;
}

export class GetSpecialRewardCommandRequest implements IGetSpecialRewardCommandRequest {
    specialRewardMileStoneKey?: string | undefined;
    locale?: string | undefined;

    constructor(data?: IGetSpecialRewardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialRewardMileStoneKey = _data["specialRewardMileStoneKey"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): GetSpecialRewardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSpecialRewardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialRewardMileStoneKey"] = this.specialRewardMileStoneKey;
        data["locale"] = this.locale;
        return data;
    }

    clone(): GetSpecialRewardCommandRequest {
        const json = this.toJSON();
        let result = new GetSpecialRewardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetSpecialRewardCommandRequest {
    specialRewardMileStoneKey?: string | undefined;
    locale?: string | undefined;
}

export class GetSpecialRewardCommandResponse implements IGetSpecialRewardCommandResponse {
    success?: boolean;
    details?: SpecialRewardDetails | undefined;

    constructor(data?: IGetSpecialRewardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.details = data.details && !(<any>data.details).toJSON ? new SpecialRewardDetails(data.details) : <SpecialRewardDetails>this.details;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.details = _data["details"] ? SpecialRewardDetails.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSpecialRewardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSpecialRewardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetSpecialRewardCommandResponse {
        const json = this.toJSON();
        let result = new GetSpecialRewardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSpecialRewardCommandResponse {
    success?: boolean;
    details?: ISpecialRewardDetails | undefined;
}

export class UpdateLanguageCommandRequest implements IUpdateLanguageCommandRequest {
    locale?: string | undefined;

    constructor(data?: IUpdateLanguageCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): UpdateLanguageCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        return data;
    }

    clone(): UpdateLanguageCommandRequest {
        const json = this.toJSON();
        let result = new UpdateLanguageCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateLanguageCommandRequest {
    locale?: string | undefined;
}

export class UpdateLanguageCommandResponse implements IUpdateLanguageCommandResponse {
    readonly success?: boolean;
    readonly accessTokenExpiresIn?: number;
    readonly accessToken?: string | undefined;

    constructor(data?: IUpdateLanguageCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).success = _data["success"];
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): UpdateLanguageCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        return data;
    }

    clone(): UpdateLanguageCommandResponse {
        const json = this.toJSON();
        let result = new UpdateLanguageCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateLanguageCommandResponse {
    success?: boolean;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
}

export class WatchedAdStatsModel implements IWatchedAdStatsModel {
    adWatchedAmount?: number;
    adRemainingAmount?: number;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;
    canWatchAd?: boolean;

    constructor(data?: IWatchedAdStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adWatchedAmount = _data["adWatchedAmount"];
            this.adRemainingAmount = _data["adRemainingAmount"];
            this.lastAdWatchedDate = _data["lastAdWatchedDate"];
            this.playerCurrentDate = _data["playerCurrentDate"];
            this.condition = _data["condition"];
            this.canWatchAd = _data["canWatchAd"];
        }
    }

    static fromJS(data: any): WatchedAdStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new WatchedAdStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adWatchedAmount"] = this.adWatchedAmount;
        data["adRemainingAmount"] = this.adRemainingAmount;
        data["lastAdWatchedDate"] = this.lastAdWatchedDate;
        data["playerCurrentDate"] = this.playerCurrentDate;
        data["condition"] = this.condition;
        data["canWatchAd"] = this.canWatchAd;
        return data;
    }

    clone(): WatchedAdStatsModel {
        const json = this.toJSON();
        let result = new WatchedAdStatsModel();
        result.init(json);
        return result;
    }
}

export interface IWatchedAdStatsModel {
    adWatchedAmount?: number;
    adRemainingAmount?: number;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;
    canWatchAd?: boolean;
}

export class GetAdsMoreTimeStatsResponse implements IGetAdsMoreTimeStatsResponse {
    watchedAdStats?: WatchedAdStatsModel | undefined;

    constructor(data?: IGetAdsMoreTimeStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.watchedAdStats = data.watchedAdStats && !(<any>data.watchedAdStats).toJSON ? new WatchedAdStatsModel(data.watchedAdStats) : <WatchedAdStatsModel>this.watchedAdStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.watchedAdStats = _data["watchedAdStats"] ? WatchedAdStatsModel.fromJS(_data["watchedAdStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdsMoreTimeStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdsMoreTimeStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["watchedAdStats"] = this.watchedAdStats ? this.watchedAdStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAdsMoreTimeStatsResponse {
        const json = this.toJSON();
        let result = new GetAdsMoreTimeStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAdsMoreTimeStatsResponse {
    watchedAdStats?: IWatchedAdStatsModel | undefined;
}

export class GetAdsMoreTimeStatsRequest implements IGetAdsMoreTimeStatsRequest {
    timeZoneOffset?: number;

    constructor(data?: IGetAdsMoreTimeStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): GetAdsMoreTimeStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdsMoreTimeStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }

    clone(): GetAdsMoreTimeStatsRequest {
        const json = this.toJSON();
        let result = new GetAdsMoreTimeStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAdsMoreTimeStatsRequest {
    timeZoneOffset?: number;
}

export class GetAdsBoardStatsResponse implements IGetAdsBoardStatsResponse {
    watchedAdStats?: WatchedAdStatsModel | undefined;

    constructor(data?: IGetAdsBoardStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.watchedAdStats = data.watchedAdStats && !(<any>data.watchedAdStats).toJSON ? new WatchedAdStatsModel(data.watchedAdStats) : <WatchedAdStatsModel>this.watchedAdStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.watchedAdStats = _data["watchedAdStats"] ? WatchedAdStatsModel.fromJS(_data["watchedAdStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdsBoardStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdsBoardStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["watchedAdStats"] = this.watchedAdStats ? this.watchedAdStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAdsBoardStatsResponse {
        const json = this.toJSON();
        let result = new GetAdsBoardStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAdsBoardStatsResponse {
    watchedAdStats?: IWatchedAdStatsModel | undefined;
}

export class GetAdsBoardStatsRequest implements IGetAdsBoardStatsRequest {
    timeZoneOffset?: number;

    constructor(data?: IGetAdsBoardStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): GetAdsBoardStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdsBoardStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }

    clone(): GetAdsBoardStatsRequest {
        const json = this.toJSON();
        let result = new GetAdsBoardStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAdsBoardStatsRequest {
    timeZoneOffset?: number;
}

export class GetAdsHintStatsResponse implements IGetAdsHintStatsResponse {
    watchedAdStats?: WatchedAdStatsModel | undefined;

    constructor(data?: IGetAdsHintStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.watchedAdStats = data.watchedAdStats && !(<any>data.watchedAdStats).toJSON ? new WatchedAdStatsModel(data.watchedAdStats) : <WatchedAdStatsModel>this.watchedAdStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.watchedAdStats = _data["watchedAdStats"] ? WatchedAdStatsModel.fromJS(_data["watchedAdStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdsHintStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdsHintStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["watchedAdStats"] = this.watchedAdStats ? this.watchedAdStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAdsHintStatsResponse {
        const json = this.toJSON();
        let result = new GetAdsHintStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAdsHintStatsResponse {
    watchedAdStats?: IWatchedAdStatsModel | undefined;
}

export class GetAdsHintStatsRequest implements IGetAdsHintStatsRequest {
    timeZoneOffset?: number;

    constructor(data?: IGetAdsHintStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): GetAdsHintStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdsHintStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }

    clone(): GetAdsHintStatsRequest {
        const json = this.toJSON();
        let result = new GetAdsHintStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAdsHintStatsRequest {
    timeZoneOffset?: number;
}

export class IncrementAdsWatchMoreTimeCommandRequest implements IIncrementAdsWatchMoreTimeCommandRequest {
    timeZoneOffset?: number;

    constructor(data?: IIncrementAdsWatchMoreTimeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): IncrementAdsWatchMoreTimeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementAdsWatchMoreTimeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }

    clone(): IncrementAdsWatchMoreTimeCommandRequest {
        const json = this.toJSON();
        let result = new IncrementAdsWatchMoreTimeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IIncrementAdsWatchMoreTimeCommandRequest {
    timeZoneOffset?: number;
}

export class IncrementAdsWatchMoreTimeCommandResponse implements IIncrementAdsWatchMoreTimeCommandResponse {
    isSuccessful?: boolean;
    adWatchedAmount?: number | undefined;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;

    constructor(data?: IIncrementAdsWatchMoreTimeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.adWatchedAmount = _data["adWatchedAmount"];
            this.lastAdWatchedDate = _data["lastAdWatchedDate"];
            this.playerCurrentDate = _data["playerCurrentDate"];
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): IncrementAdsWatchMoreTimeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementAdsWatchMoreTimeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["adWatchedAmount"] = this.adWatchedAmount;
        data["lastAdWatchedDate"] = this.lastAdWatchedDate;
        data["playerCurrentDate"] = this.playerCurrentDate;
        data["condition"] = this.condition;
        return data;
    }

    clone(): IncrementAdsWatchMoreTimeCommandResponse {
        const json = this.toJSON();
        let result = new IncrementAdsWatchMoreTimeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IIncrementAdsWatchMoreTimeCommandResponse {
    isSuccessful?: boolean;
    adWatchedAmount?: number | undefined;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;
}

export class IncrementAdsWatchBoardCommandRequest implements IIncrementAdsWatchBoardCommandRequest {
    timeZoneOffset?: number;

    constructor(data?: IIncrementAdsWatchBoardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): IncrementAdsWatchBoardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementAdsWatchBoardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }

    clone(): IncrementAdsWatchBoardCommandRequest {
        const json = this.toJSON();
        let result = new IncrementAdsWatchBoardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IIncrementAdsWatchBoardCommandRequest {
    timeZoneOffset?: number;
}

export class IncrementAdsWatchBoardCommandResponse implements IIncrementAdsWatchBoardCommandResponse {
    isSuccessful?: boolean;
    adWatchedAmount?: number | undefined;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;

    constructor(data?: IIncrementAdsWatchBoardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.adWatchedAmount = _data["adWatchedAmount"];
            this.lastAdWatchedDate = _data["lastAdWatchedDate"];
            this.playerCurrentDate = _data["playerCurrentDate"];
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): IncrementAdsWatchBoardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementAdsWatchBoardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["adWatchedAmount"] = this.adWatchedAmount;
        data["lastAdWatchedDate"] = this.lastAdWatchedDate;
        data["playerCurrentDate"] = this.playerCurrentDate;
        data["condition"] = this.condition;
        return data;
    }

    clone(): IncrementAdsWatchBoardCommandResponse {
        const json = this.toJSON();
        let result = new IncrementAdsWatchBoardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IIncrementAdsWatchBoardCommandResponse {
    isSuccessful?: boolean;
    adWatchedAmount?: number | undefined;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;
}

export class IncrementAdsWatchHintCommandRequest implements IIncrementAdsWatchHintCommandRequest {
    timeZoneOffset?: number;

    constructor(data?: IIncrementAdsWatchHintCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): IncrementAdsWatchHintCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementAdsWatchHintCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }

    clone(): IncrementAdsWatchHintCommandRequest {
        const json = this.toJSON();
        let result = new IncrementAdsWatchHintCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IIncrementAdsWatchHintCommandRequest {
    timeZoneOffset?: number;
}

export class IncrementAdsWatchHintCommandResponse implements IIncrementAdsWatchHintCommandResponse {
    isSuccessful?: boolean;
    adWatchedAmount?: number | undefined;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;

    constructor(data?: IIncrementAdsWatchHintCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.adWatchedAmount = _data["adWatchedAmount"];
            this.lastAdWatchedDate = _data["lastAdWatchedDate"];
            this.playerCurrentDate = _data["playerCurrentDate"];
            this.condition = _data["condition"];
        }
    }

    static fromJS(data: any): IncrementAdsWatchHintCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementAdsWatchHintCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["adWatchedAmount"] = this.adWatchedAmount;
        data["lastAdWatchedDate"] = this.lastAdWatchedDate;
        data["playerCurrentDate"] = this.playerCurrentDate;
        data["condition"] = this.condition;
        return data;
    }

    clone(): IncrementAdsWatchHintCommandResponse {
        const json = this.toJSON();
        let result = new IncrementAdsWatchHintCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IIncrementAdsWatchHintCommandResponse {
    isSuccessful?: boolean;
    adWatchedAmount?: number | undefined;
    lastAdWatchedDate?: string | undefined;
    playerCurrentDate?: string | undefined;
    condition?: string | undefined;
}

export class ResetAdStatsBoardCommandRequest implements IResetAdStatsBoardCommandRequest {

    constructor(data?: IResetAdStatsBoardCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResetAdStatsBoardCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAdStatsBoardCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ResetAdStatsBoardCommandRequest {
        const json = this.toJSON();
        let result = new ResetAdStatsBoardCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResetAdStatsBoardCommandRequest {
}

export class ResetAdStatsBoardCommandResponse implements IResetAdStatsBoardCommandResponse {
    isSuccessful?: boolean;

    constructor(data?: IResetAdStatsBoardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): ResetAdStatsBoardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAdStatsBoardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }

    clone(): ResetAdStatsBoardCommandResponse {
        const json = this.toJSON();
        let result = new ResetAdStatsBoardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResetAdStatsBoardCommandResponse {
    isSuccessful?: boolean;
}

export class ResetAdStatsHintCommandRequest implements IResetAdStatsHintCommandRequest {

    constructor(data?: IResetAdStatsHintCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResetAdStatsHintCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAdStatsHintCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ResetAdStatsHintCommandRequest {
        const json = this.toJSON();
        let result = new ResetAdStatsHintCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResetAdStatsHintCommandRequest {
}

export class ResetAdStatsHintCommandResponse implements IResetAdStatsHintCommandResponse {
    isSuccessful?: boolean;

    constructor(data?: IResetAdStatsHintCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): ResetAdStatsHintCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAdStatsHintCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }

    clone(): ResetAdStatsHintCommandResponse {
        const json = this.toJSON();
        let result = new ResetAdStatsHintCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResetAdStatsHintCommandResponse {
    isSuccessful?: boolean;
}

export class CheckAppVersionResponse implements ICheckAppVersionResponse {
    promptToUpdate?: boolean;
    lockGameplay?: boolean;
    minimumVersion?: string | undefined;
    currentVersion?: string | undefined;

    constructor(data?: ICheckAppVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptToUpdate = _data["promptToUpdate"];
            this.lockGameplay = _data["lockGameplay"];
            this.minimumVersion = _data["minimumVersion"];
            this.currentVersion = _data["currentVersion"];
        }
    }

    static fromJS(data: any): CheckAppVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAppVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptToUpdate"] = this.promptToUpdate;
        data["lockGameplay"] = this.lockGameplay;
        data["minimumVersion"] = this.minimumVersion;
        data["currentVersion"] = this.currentVersion;
        return data;
    }

    clone(): CheckAppVersionResponse {
        const json = this.toJSON();
        let result = new CheckAppVersionResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckAppVersionResponse {
    promptToUpdate?: boolean;
    lockGameplay?: boolean;
    minimumVersion?: string | undefined;
    currentVersion?: string | undefined;
}

export class SimpleUserProfile implements ISimpleUserProfile {
    id?: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    creationDate?: string | undefined;
    readonly signUpMediumUsed?: SignUpMedium;

    constructor(data?: ISimpleUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.creationDate = _data["creationDate"];
            (<any>this).signUpMediumUsed = _data["signUpMediumUsed"];
        }
    }

    static fromJS(data: any): SimpleUserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["creationDate"] = this.creationDate;
        data["signUpMediumUsed"] = this.signUpMediumUsed;
        return data;
    }

    clone(): SimpleUserProfile {
        const json = this.toJSON();
        let result = new SimpleUserProfile();
        result.init(json);
        return result;
    }
}

export interface ISimpleUserProfile {
    id?: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    creationDate?: string | undefined;
    signUpMediumUsed?: SignUpMedium;
}

export class GetPlayersCommandResponse implements IGetPlayersCommandResponse {
    playerAccounts?: SimpleUserProfile[] | undefined;

    constructor(data?: IGetPlayersCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.playerAccounts) {
                this.playerAccounts = [];
                for (let i = 0; i < data.playerAccounts.length; i++) {
                    let item = data.playerAccounts[i];
                    this.playerAccounts[i] = item && !(<any>item).toJSON ? new SimpleUserProfile(item) : <SimpleUserProfile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playerAccounts"])) {
                this.playerAccounts = [] as any;
                for (let item of _data["playerAccounts"])
                    this.playerAccounts!.push(SimpleUserProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlayersCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayersCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playerAccounts)) {
            data["playerAccounts"] = [];
            for (let item of this.playerAccounts)
                data["playerAccounts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPlayersCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayersCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayersCommandResponse {
    playerAccounts?: ISimpleUserProfile[] | undefined;
}

export class SinglePlayerGameHistoryModel implements ISinglePlayerGameHistoryModel {
    gameId?: string;
    timeTaken?: number | undefined;
    gameDifficulty?: Difficulty;
    errors?: number;

    constructor(data?: ISinglePlayerGameHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.timeTaken = _data["timeTaken"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): SinglePlayerGameHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SinglePlayerGameHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["timeTaken"] = this.timeTaken;
        data["gameDifficulty"] = this.gameDifficulty;
        data["errors"] = this.errors;
        return data;
    }

    clone(): SinglePlayerGameHistoryModel {
        const json = this.toJSON();
        let result = new SinglePlayerGameHistoryModel();
        result.init(json);
        return result;
    }
}

export interface ISinglePlayerGameHistoryModel {
    gameId?: string;
    timeTaken?: number | undefined;
    gameDifficulty?: Difficulty;
    errors?: number;
}

export class GetSinglePlayerGameHistoryCommandResponse implements IGetSinglePlayerGameHistoryCommandResponse {
    singlePlayerGameHistories?: SinglePlayerGameHistoryModel[] | undefined;

    constructor(data?: IGetSinglePlayerGameHistoryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.singlePlayerGameHistories) {
                this.singlePlayerGameHistories = [];
                for (let i = 0; i < data.singlePlayerGameHistories.length; i++) {
                    let item = data.singlePlayerGameHistories[i];
                    this.singlePlayerGameHistories[i] = item && !(<any>item).toJSON ? new SinglePlayerGameHistoryModel(item) : <SinglePlayerGameHistoryModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["singlePlayerGameHistories"])) {
                this.singlePlayerGameHistories = [] as any;
                for (let item of _data["singlePlayerGameHistories"])
                    this.singlePlayerGameHistories!.push(SinglePlayerGameHistoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSinglePlayerGameHistoryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSinglePlayerGameHistoryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.singlePlayerGameHistories)) {
            data["singlePlayerGameHistories"] = [];
            for (let item of this.singlePlayerGameHistories)
                data["singlePlayerGameHistories"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetSinglePlayerGameHistoryCommandResponse {
        const json = this.toJSON();
        let result = new GetSinglePlayerGameHistoryCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSinglePlayerGameHistoryCommandResponse {
    singlePlayerGameHistories?: ISinglePlayerGameHistoryModel[] | undefined;
}

export class TotalGamesPerDifficulty implements ITotalGamesPerDifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;

    constructor(data?: ITotalGamesPerDifficulty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.easy = _data["easy"];
            this.medium = _data["medium"];
            this.hard = _data["hard"];
            this.expert = _data["expert"];
        }
    }

    static fromJS(data: any): TotalGamesPerDifficulty {
        data = typeof data === 'object' ? data : {};
        let result = new TotalGamesPerDifficulty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["easy"] = this.easy;
        data["medium"] = this.medium;
        data["hard"] = this.hard;
        data["expert"] = this.expert;
        return data;
    }

    clone(): TotalGamesPerDifficulty {
        const json = this.toJSON();
        let result = new TotalGamesPerDifficulty();
        result.init(json);
        return result;
    }
}

export interface ITotalGamesPerDifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;
}

export class AverageTimeTakenPerDifficulty implements IAverageTimeTakenPerDifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;

    constructor(data?: IAverageTimeTakenPerDifficulty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.easy = _data["easy"];
            this.medium = _data["medium"];
            this.hard = _data["hard"];
            this.expert = _data["expert"];
        }
    }

    static fromJS(data: any): AverageTimeTakenPerDifficulty {
        data = typeof data === 'object' ? data : {};
        let result = new AverageTimeTakenPerDifficulty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["easy"] = this.easy;
        data["medium"] = this.medium;
        data["hard"] = this.hard;
        data["expert"] = this.expert;
        return data;
    }

    clone(): AverageTimeTakenPerDifficulty {
        const json = this.toJSON();
        let result = new AverageTimeTakenPerDifficulty();
        result.init(json);
        return result;
    }
}

export interface IAverageTimeTakenPerDifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;
}

export class LongestTimePerDifficulty implements ILongestTimePerDifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;

    constructor(data?: ILongestTimePerDifficulty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.easy = _data["easy"];
            this.medium = _data["medium"];
            this.hard = _data["hard"];
            this.expert = _data["expert"];
        }
    }

    static fromJS(data: any): LongestTimePerDifficulty {
        data = typeof data === 'object' ? data : {};
        let result = new LongestTimePerDifficulty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["easy"] = this.easy;
        data["medium"] = this.medium;
        data["hard"] = this.hard;
        data["expert"] = this.expert;
        return data;
    }

    clone(): LongestTimePerDifficulty {
        const json = this.toJSON();
        let result = new LongestTimePerDifficulty();
        result.init(json);
        return result;
    }
}

export interface ILongestTimePerDifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;
}

export class ShortestTimePerifficulty implements IShortestTimePerifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;

    constructor(data?: IShortestTimePerifficulty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.easy = _data["easy"];
            this.medium = _data["medium"];
            this.hard = _data["hard"];
            this.expert = _data["expert"];
        }
    }

    static fromJS(data: any): ShortestTimePerifficulty {
        data = typeof data === 'object' ? data : {};
        let result = new ShortestTimePerifficulty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["easy"] = this.easy;
        data["medium"] = this.medium;
        data["hard"] = this.hard;
        data["expert"] = this.expert;
        return data;
    }

    clone(): ShortestTimePerifficulty {
        const json = this.toJSON();
        let result = new ShortestTimePerifficulty();
        result.init(json);
        return result;
    }
}

export interface IShortestTimePerifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;
}

export class AverageErrorsPerifficulty implements IAverageErrorsPerifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;

    constructor(data?: IAverageErrorsPerifficulty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.easy = _data["easy"];
            this.medium = _data["medium"];
            this.hard = _data["hard"];
            this.expert = _data["expert"];
        }
    }

    static fromJS(data: any): AverageErrorsPerifficulty {
        data = typeof data === 'object' ? data : {};
        let result = new AverageErrorsPerifficulty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["easy"] = this.easy;
        data["medium"] = this.medium;
        data["hard"] = this.hard;
        data["expert"] = this.expert;
        return data;
    }

    clone(): AverageErrorsPerifficulty {
        const json = this.toJSON();
        let result = new AverageErrorsPerifficulty();
        result.init(json);
        return result;
    }
}

export interface IAverageErrorsPerifficulty {
    easy?: number;
    medium?: number;
    hard?: number;
    expert?: number;
}

export class GetPlayerPerformanceCommandResponse implements IGetPlayerPerformanceCommandResponse {
    totalGames?: number;
    averageTimeTaken?: number;
    totalGamesForEachDifficulty?: TotalGamesPerDifficulty | undefined;
    averageTimeTakenForEachDifficulty?: AverageTimeTakenPerDifficulty | undefined;
    longestTimeForEachDifficulty?: LongestTimePerDifficulty | undefined;
    shortestTimeForEachDifficulty?: ShortestTimePerifficulty | undefined;
    averageErrorsForEachDifficulty?: AverageErrorsPerifficulty | undefined;

    constructor(data?: IGetPlayerPerformanceCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.totalGamesForEachDifficulty = data.totalGamesForEachDifficulty && !(<any>data.totalGamesForEachDifficulty).toJSON ? new TotalGamesPerDifficulty(data.totalGamesForEachDifficulty) : <TotalGamesPerDifficulty>this.totalGamesForEachDifficulty;
            this.averageTimeTakenForEachDifficulty = data.averageTimeTakenForEachDifficulty && !(<any>data.averageTimeTakenForEachDifficulty).toJSON ? new AverageTimeTakenPerDifficulty(data.averageTimeTakenForEachDifficulty) : <AverageTimeTakenPerDifficulty>this.averageTimeTakenForEachDifficulty;
            this.longestTimeForEachDifficulty = data.longestTimeForEachDifficulty && !(<any>data.longestTimeForEachDifficulty).toJSON ? new LongestTimePerDifficulty(data.longestTimeForEachDifficulty) : <LongestTimePerDifficulty>this.longestTimeForEachDifficulty;
            this.shortestTimeForEachDifficulty = data.shortestTimeForEachDifficulty && !(<any>data.shortestTimeForEachDifficulty).toJSON ? new ShortestTimePerifficulty(data.shortestTimeForEachDifficulty) : <ShortestTimePerifficulty>this.shortestTimeForEachDifficulty;
            this.averageErrorsForEachDifficulty = data.averageErrorsForEachDifficulty && !(<any>data.averageErrorsForEachDifficulty).toJSON ? new AverageErrorsPerifficulty(data.averageErrorsForEachDifficulty) : <AverageErrorsPerifficulty>this.averageErrorsForEachDifficulty;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalGames = _data["totalGames"];
            this.averageTimeTaken = _data["averageTimeTaken"];
            this.totalGamesForEachDifficulty = _data["totalGamesForEachDifficulty"] ? TotalGamesPerDifficulty.fromJS(_data["totalGamesForEachDifficulty"]) : <any>undefined;
            this.averageTimeTakenForEachDifficulty = _data["averageTimeTakenForEachDifficulty"] ? AverageTimeTakenPerDifficulty.fromJS(_data["averageTimeTakenForEachDifficulty"]) : <any>undefined;
            this.longestTimeForEachDifficulty = _data["longestTimeForEachDifficulty"] ? LongestTimePerDifficulty.fromJS(_data["longestTimeForEachDifficulty"]) : <any>undefined;
            this.shortestTimeForEachDifficulty = _data["shortestTimeForEachDifficulty"] ? ShortestTimePerifficulty.fromJS(_data["shortestTimeForEachDifficulty"]) : <any>undefined;
            this.averageErrorsForEachDifficulty = _data["averageErrorsForEachDifficulty"] ? AverageErrorsPerifficulty.fromJS(_data["averageErrorsForEachDifficulty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerPerformanceCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerPerformanceCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalGames"] = this.totalGames;
        data["averageTimeTaken"] = this.averageTimeTaken;
        data["totalGamesForEachDifficulty"] = this.totalGamesForEachDifficulty ? this.totalGamesForEachDifficulty.toJSON() : <any>undefined;
        data["averageTimeTakenForEachDifficulty"] = this.averageTimeTakenForEachDifficulty ? this.averageTimeTakenForEachDifficulty.toJSON() : <any>undefined;
        data["longestTimeForEachDifficulty"] = this.longestTimeForEachDifficulty ? this.longestTimeForEachDifficulty.toJSON() : <any>undefined;
        data["shortestTimeForEachDifficulty"] = this.shortestTimeForEachDifficulty ? this.shortestTimeForEachDifficulty.toJSON() : <any>undefined;
        data["averageErrorsForEachDifficulty"] = this.averageErrorsForEachDifficulty ? this.averageErrorsForEachDifficulty.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerPerformanceCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerPerformanceCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerPerformanceCommandResponse {
    totalGames?: number;
    averageTimeTaken?: number;
    totalGamesForEachDifficulty?: ITotalGamesPerDifficulty | undefined;
    averageTimeTakenForEachDifficulty?: IAverageTimeTakenPerDifficulty | undefined;
    longestTimeForEachDifficulty?: ILongestTimePerDifficulty | undefined;
    shortestTimeForEachDifficulty?: IShortestTimePerifficulty | undefined;
    averageErrorsForEachDifficulty?: IAverageErrorsPerifficulty | undefined;
}

export class GetPlayerBoardCountQueryResponse implements IGetPlayerBoardCountQueryResponse {
    message?: string | undefined;
    numberOfBoards?: number;

    constructor(data?: IGetPlayerBoardCountQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfBoards = _data["numberOfBoards"];
        }
    }

    static fromJS(data: any): GetPlayerBoardCountQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerBoardCountQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfBoards"] = this.numberOfBoards;
        return data;
    }

    clone(): GetPlayerBoardCountQueryResponse {
        const json = this.toJSON();
        let result = new GetPlayerBoardCountQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerBoardCountQueryResponse {
    message?: string | undefined;
    numberOfBoards?: number;
}

export class GetHintsCommandResponse implements IGetHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;

    constructor(data?: IGetHintsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfHints = _data["numberOfHints"];
        }
    }

    static fromJS(data: any): GetHintsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHintsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfHints"] = this.numberOfHints;
        return data;
    }

    clone(): GetHintsCommandResponse {
        const json = this.toJSON();
        let result = new GetHintsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
}

export class GetMoreTimeCommandResponse implements IGetMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;

    constructor(data?: IGetMoreTimeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfMoreTime = _data["numberOfMoreTime"];
        }
    }

    static fromJS(data: any): GetMoreTimeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoreTimeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfMoreTime"] = this.numberOfMoreTime;
        return data;
    }

    clone(): GetMoreTimeCommandResponse {
        const json = this.toJSON();
        let result = new GetMoreTimeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
}

export class FriendInviteCommandResponse implements IFriendInviteCommandResponse {
    invitationUrl?: string | undefined;

    constructor(data?: IFriendInviteCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationUrl = _data["invitationUrl"];
        }
    }

    static fromJS(data: any): FriendInviteCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FriendInviteCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationUrl"] = this.invitationUrl;
        return data;
    }

    clone(): FriendInviteCommandResponse {
        const json = this.toJSON();
        let result = new FriendInviteCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IFriendInviteCommandResponse {
    invitationUrl?: string | undefined;
}

export class SimpleFriendList implements ISimpleFriendList {
    userId?: string;
    inviterUserId?: string | undefined;
    readonly icon?: number | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
    username?: string | undefined;
    rankName?: string | undefined;
    rankScore?: number;
    isLoggedIn?: boolean;
    status?: FriendRequestStatus;
    requestId?: string | undefined;

    constructor(data?: ISimpleFriendList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.inviterUserId = _data["inviterUserId"];
            (<any>this).icon = _data["icon"];
            this.countryCode = _data["countryCode"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.rankName = _data["rankName"];
            this.rankScore = _data["rankScore"];
            this.isLoggedIn = _data["isLoggedIn"];
            this.status = _data["status"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): SimpleFriendList {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleFriendList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["inviterUserId"] = this.inviterUserId;
        data["icon"] = this.icon;
        data["countryCode"] = this.countryCode;
        data["name"] = this.name;
        data["username"] = this.username;
        data["rankName"] = this.rankName;
        data["rankScore"] = this.rankScore;
        data["isLoggedIn"] = this.isLoggedIn;
        data["status"] = this.status;
        data["requestId"] = this.requestId;
        return data;
    }

    clone(): SimpleFriendList {
        const json = this.toJSON();
        let result = new SimpleFriendList();
        result.init(json);
        return result;
    }
}

export interface ISimpleFriendList {
    userId?: string;
    inviterUserId?: string | undefined;
    icon?: number | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
    username?: string | undefined;
    rankName?: string | undefined;
    rankScore?: number;
    isLoggedIn?: boolean;
    status?: FriendRequestStatus;
    requestId?: string | undefined;
}

export class FriendModel implements IFriendModel {
    friendId?: string;
    name?: string | undefined;
    username?: string | undefined;
    rankName?: string | undefined;
    rankScore?: number;
    isLoggedIn?: boolean;
    status?: FriendRequestStatus;
    requestId?: string | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;

    constructor(data?: IFriendModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendId = _data["friendId"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.rankName = _data["rankName"];
            this.rankScore = _data["rankScore"];
            this.isLoggedIn = _data["isLoggedIn"];
            this.status = _data["status"];
            this.requestId = _data["requestId"];
            this.countryCode = _data["countryCode"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): FriendModel {
        data = typeof data === 'object' ? data : {};
        let result = new FriendModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendId"] = this.friendId;
        data["name"] = this.name;
        data["username"] = this.username;
        data["rankName"] = this.rankName;
        data["rankScore"] = this.rankScore;
        data["isLoggedIn"] = this.isLoggedIn;
        data["status"] = this.status;
        data["requestId"] = this.requestId;
        data["countryCode"] = this.countryCode;
        data["icon"] = this.icon;
        return data;
    }

    clone(): FriendModel {
        const json = this.toJSON();
        let result = new FriendModel();
        result.init(json);
        return result;
    }
}

export interface IFriendModel {
    friendId?: string;
    name?: string | undefined;
    username?: string | undefined;
    rankName?: string | undefined;
    rankScore?: number;
    isLoggedIn?: boolean;
    status?: FriendRequestStatus;
    requestId?: string | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
}

export class PlayerFriendsList implements IPlayerFriendsList {
    listofFriends?: SimpleFriendList[] | undefined;
    pendingFirends?: SimpleFriendList[] | undefined;
    friends?: FriendModel[] | undefined;
    sentRequests?: FriendModel[] | undefined;
    recievedRequests?: FriendModel[] | undefined;

    constructor(data?: IPlayerFriendsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.listofFriends) {
                this.listofFriends = [];
                for (let i = 0; i < data.listofFriends.length; i++) {
                    let item = data.listofFriends[i];
                    this.listofFriends[i] = item && !(<any>item).toJSON ? new SimpleFriendList(item) : <SimpleFriendList>item;
                }
            }
            if (data.pendingFirends) {
                this.pendingFirends = [];
                for (let i = 0; i < data.pendingFirends.length; i++) {
                    let item = data.pendingFirends[i];
                    this.pendingFirends[i] = item && !(<any>item).toJSON ? new SimpleFriendList(item) : <SimpleFriendList>item;
                }
            }
            if (data.friends) {
                this.friends = [];
                for (let i = 0; i < data.friends.length; i++) {
                    let item = data.friends[i];
                    this.friends[i] = item && !(<any>item).toJSON ? new FriendModel(item) : <FriendModel>item;
                }
            }
            if (data.sentRequests) {
                this.sentRequests = [];
                for (let i = 0; i < data.sentRequests.length; i++) {
                    let item = data.sentRequests[i];
                    this.sentRequests[i] = item && !(<any>item).toJSON ? new FriendModel(item) : <FriendModel>item;
                }
            }
            if (data.recievedRequests) {
                this.recievedRequests = [];
                for (let i = 0; i < data.recievedRequests.length; i++) {
                    let item = data.recievedRequests[i];
                    this.recievedRequests[i] = item && !(<any>item).toJSON ? new FriendModel(item) : <FriendModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listofFriends"])) {
                this.listofFriends = [] as any;
                for (let item of _data["listofFriends"])
                    this.listofFriends!.push(SimpleFriendList.fromJS(item));
            }
            if (Array.isArray(_data["pendingFirends"])) {
                this.pendingFirends = [] as any;
                for (let item of _data["pendingFirends"])
                    this.pendingFirends!.push(SimpleFriendList.fromJS(item));
            }
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendModel.fromJS(item));
            }
            if (Array.isArray(_data["sentRequests"])) {
                this.sentRequests = [] as any;
                for (let item of _data["sentRequests"])
                    this.sentRequests!.push(FriendModel.fromJS(item));
            }
            if (Array.isArray(_data["recievedRequests"])) {
                this.recievedRequests = [] as any;
                for (let item of _data["recievedRequests"])
                    this.recievedRequests!.push(FriendModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerFriendsList {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerFriendsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listofFriends)) {
            data["listofFriends"] = [];
            for (let item of this.listofFriends)
                data["listofFriends"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingFirends)) {
            data["pendingFirends"] = [];
            for (let item of this.pendingFirends)
                data["pendingFirends"].push(item.toJSON());
        }
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        if (Array.isArray(this.sentRequests)) {
            data["sentRequests"] = [];
            for (let item of this.sentRequests)
                data["sentRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.recievedRequests)) {
            data["recievedRequests"] = [];
            for (let item of this.recievedRequests)
                data["recievedRequests"].push(item.toJSON());
        }
        return data;
    }

    clone(): PlayerFriendsList {
        const json = this.toJSON();
        let result = new PlayerFriendsList();
        result.init(json);
        return result;
    }
}

export interface IPlayerFriendsList {
    listofFriends?: ISimpleFriendList[] | undefined;
    pendingFirends?: ISimpleFriendList[] | undefined;
    friends?: IFriendModel[] | undefined;
    sentRequests?: IFriendModel[] | undefined;
    recievedRequests?: IFriendModel[] | undefined;
}

export class GetPlayerFriendListQueryResponse implements IGetPlayerFriendListQueryResponse {
    playerFriendsList?: PlayerFriendsList | undefined;

    constructor(data?: IGetPlayerFriendListQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerFriendsList = data.playerFriendsList && !(<any>data.playerFriendsList).toJSON ? new PlayerFriendsList(data.playerFriendsList) : <PlayerFriendsList>this.playerFriendsList;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerFriendsList = _data["playerFriendsList"] ? PlayerFriendsList.fromJS(_data["playerFriendsList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerFriendListQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerFriendListQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerFriendsList"] = this.playerFriendsList ? this.playerFriendsList.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerFriendListQueryResponse {
        const json = this.toJSON();
        let result = new GetPlayerFriendListQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerFriendListQueryResponse {
    playerFriendsList?: IPlayerFriendsList | undefined;
}

export class SaveMovesCommandRequest implements ISaveMovesCommandRequest {
    playerId?: string;
    playerNotes?: string | undefined;
    playerMoves?: string | undefined;
    playerErrors?: string | undefined;
    gameId?: string;

    constructor(data?: ISaveMovesCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.playerNotes = _data["playerNotes"];
            this.playerMoves = _data["playerMoves"];
            this.playerErrors = _data["playerErrors"];
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): SaveMovesCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMovesCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["playerNotes"] = this.playerNotes;
        data["playerMoves"] = this.playerMoves;
        data["playerErrors"] = this.playerErrors;
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): SaveMovesCommandRequest {
        const json = this.toJSON();
        let result = new SaveMovesCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveMovesCommandRequest {
    playerId?: string;
    playerNotes?: string | undefined;
    playerMoves?: string | undefined;
    playerErrors?: string | undefined;
    gameId?: string;
}

export class SaveMovesCommandResponse implements ISaveMovesCommandResponse {
    gameId?: string | undefined;
    gameStatus?: GameStatus;
    success?: string | undefined;
    errors?: string | undefined;

    constructor(data?: ISaveMovesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.gameStatus = _data["gameStatus"];
            this.success = _data["success"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): SaveMovesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMovesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["gameStatus"] = this.gameStatus;
        data["success"] = this.success;
        data["errors"] = this.errors;
        return data;
    }

    clone(): SaveMovesCommandResponse {
        const json = this.toJSON();
        let result = new SaveMovesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveMovesCommandResponse {
    gameId?: string | undefined;
    gameStatus?: GameStatus;
    success?: string | undefined;
    errors?: string | undefined;
}

export class SavePlayerGameStatsCommandRequest implements ISavePlayerGameStatsCommandRequest {
    playerId?: string;
    score?: number | undefined;
    moves?: number | undefined;
    errors?: number | undefined;
    hintsUsed?: number | undefined;
    moreTimeUsed?: number | undefined;
    adsWatched?: number | undefined;
    timeTaken?: number | undefined;
    gameId?: string;

    constructor(data?: ISavePlayerGameStatsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.score = _data["score"];
            this.moves = _data["moves"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.adsWatched = _data["adsWatched"];
            this.timeTaken = _data["timeTaken"];
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): SavePlayerGameStatsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlayerGameStatsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["score"] = this.score;
        data["moves"] = this.moves;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["adsWatched"] = this.adsWatched;
        data["timeTaken"] = this.timeTaken;
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): SavePlayerGameStatsCommandRequest {
        const json = this.toJSON();
        let result = new SavePlayerGameStatsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISavePlayerGameStatsCommandRequest {
    playerId?: string;
    score?: number | undefined;
    moves?: number | undefined;
    errors?: number | undefined;
    hintsUsed?: number | undefined;
    moreTimeUsed?: number | undefined;
    adsWatched?: number | undefined;
    timeTaken?: number | undefined;
    gameId?: string;
}

export class SavePlayerGameStatsCommandResponse implements ISavePlayerGameStatsCommandResponse {
    gameId?: string | undefined;
    success?: boolean;
    errors?: string | undefined;
    gameSummary?: EndGameSummaryModel | undefined;

    constructor(data?: ISavePlayerGameStatsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.gameSummary = data.gameSummary && !(<any>data.gameSummary).toJSON ? new EndGameSummaryModel(data.gameSummary) : <EndGameSummaryModel>this.gameSummary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.success = _data["success"];
            this.errors = _data["errors"];
            this.gameSummary = _data["gameSummary"] ? EndGameSummaryModel.fromJS(_data["gameSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SavePlayerGameStatsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlayerGameStatsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["success"] = this.success;
        data["errors"] = this.errors;
        data["gameSummary"] = this.gameSummary ? this.gameSummary.toJSON() : <any>undefined;
        return data;
    }

    clone(): SavePlayerGameStatsCommandResponse {
        const json = this.toJSON();
        let result = new SavePlayerGameStatsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISavePlayerGameStatsCommandResponse {
    gameId?: string | undefined;
    success?: boolean;
    errors?: string | undefined;
    gameSummary?: IEndGameSummaryModel | undefined;
}

export class GetPlayerStatisticsByIdCommandRequest implements IGetPlayerStatisticsByIdCommandRequest {
    playerId?: string | undefined;
    gameId?: string | undefined;

    constructor(data?: IGetPlayerStatisticsByIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): GetPlayerStatisticsByIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerStatisticsByIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): GetPlayerStatisticsByIdCommandRequest {
        const json = this.toJSON();
        let result = new GetPlayerStatisticsByIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerStatisticsByIdCommandRequest {
    playerId?: string | undefined;
    gameId?: string | undefined;
}

export class PlayerStatisticsModel implements IPlayerStatisticsModel {
    gameId?: string | undefined;
    notes?: string | undefined;
    plays?: string | undefined;
    lastMoves?: string | undefined;
    previousMoves?: string | undefined;
    playerErrors?: string | undefined;
    score?: number;
    errors?: number;
    timeTaken?: string | undefined;
    userId?: string;

    constructor(data?: IPlayerStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.notes = _data["notes"];
            this.plays = _data["plays"];
            this.lastMoves = _data["lastMoves"];
            this.previousMoves = _data["previousMoves"];
            this.playerErrors = _data["playerErrors"];
            this.score = _data["score"];
            this.errors = _data["errors"];
            this.timeTaken = _data["timeTaken"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): PlayerStatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["notes"] = this.notes;
        data["plays"] = this.plays;
        data["lastMoves"] = this.lastMoves;
        data["previousMoves"] = this.previousMoves;
        data["playerErrors"] = this.playerErrors;
        data["score"] = this.score;
        data["errors"] = this.errors;
        data["timeTaken"] = this.timeTaken;
        data["userId"] = this.userId;
        return data;
    }

    clone(): PlayerStatisticsModel {
        const json = this.toJSON();
        let result = new PlayerStatisticsModel();
        result.init(json);
        return result;
    }
}

export interface IPlayerStatisticsModel {
    gameId?: string | undefined;
    notes?: string | undefined;
    plays?: string | undefined;
    lastMoves?: string | undefined;
    previousMoves?: string | undefined;
    playerErrors?: string | undefined;
    score?: number;
    errors?: number;
    timeTaken?: string | undefined;
    userId?: string;
}

export class GetPlayerStatisticsByIdCommandResponse implements IGetPlayerStatisticsByIdCommandResponse {
    playerStatistics?: PlayerStatisticsModel | undefined;

    constructor(data?: IGetPlayerStatisticsByIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerStatistics = data.playerStatistics && !(<any>data.playerStatistics).toJSON ? new PlayerStatisticsModel(data.playerStatistics) : <PlayerStatisticsModel>this.playerStatistics;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerStatistics = _data["playerStatistics"] ? PlayerStatisticsModel.fromJS(_data["playerStatistics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerStatisticsByIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerStatisticsByIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerStatistics"] = this.playerStatistics ? this.playerStatistics.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerStatisticsByIdCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerStatisticsByIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerStatisticsByIdCommandResponse {
    playerStatistics?: IPlayerStatisticsModel | undefined;
}

export class GetPlayerSearchQueryRequest implements IGetPlayerSearchQueryRequest {
    searchTerm?: string | undefined;

    constructor(data?: IGetPlayerSearchQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
        }
    }

    static fromJS(data: any): GetPlayerSearchQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerSearchQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        return data;
    }

    clone(): GetPlayerSearchQueryRequest {
        const json = this.toJSON();
        let result = new GetPlayerSearchQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerSearchQueryRequest {
    searchTerm?: string | undefined;
}

export class SimplePlayerSearchList implements ISimplePlayerSearchList {
    userId?: string;
    username?: string | undefined;
    fullName?: string | undefined;
    rankName?: string | undefined;

    constructor(data?: ISimplePlayerSearchList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.rankName = _data["rankName"];
        }
    }

    static fromJS(data: any): SimplePlayerSearchList {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePlayerSearchList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["rankName"] = this.rankName;
        return data;
    }

    clone(): SimplePlayerSearchList {
        const json = this.toJSON();
        let result = new SimplePlayerSearchList();
        result.init(json);
        return result;
    }
}

export interface ISimplePlayerSearchList {
    userId?: string;
    username?: string | undefined;
    fullName?: string | undefined;
    rankName?: string | undefined;
}

export class PlayerSearchList implements IPlayerSearchList {
    listofPlayerSearch?: SimplePlayerSearchList[] | undefined;

    constructor(data?: IPlayerSearchList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.listofPlayerSearch) {
                this.listofPlayerSearch = [];
                for (let i = 0; i < data.listofPlayerSearch.length; i++) {
                    let item = data.listofPlayerSearch[i];
                    this.listofPlayerSearch[i] = item && !(<any>item).toJSON ? new SimplePlayerSearchList(item) : <SimplePlayerSearchList>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listofPlayerSearch"])) {
                this.listofPlayerSearch = [] as any;
                for (let item of _data["listofPlayerSearch"])
                    this.listofPlayerSearch!.push(SimplePlayerSearchList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerSearchList {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerSearchList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listofPlayerSearch)) {
            data["listofPlayerSearch"] = [];
            for (let item of this.listofPlayerSearch)
                data["listofPlayerSearch"].push(item.toJSON());
        }
        return data;
    }

    clone(): PlayerSearchList {
        const json = this.toJSON();
        let result = new PlayerSearchList();
        result.init(json);
        return result;
    }
}

export interface IPlayerSearchList {
    listofPlayerSearch?: ISimplePlayerSearchList[] | undefined;
}

export class GetPlayerSearchQueryResponse implements IGetPlayerSearchQueryResponse {
    playerSearchList?: PlayerSearchList | undefined;

    constructor(data?: IGetPlayerSearchQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerSearchList = data.playerSearchList && !(<any>data.playerSearchList).toJSON ? new PlayerSearchList(data.playerSearchList) : <PlayerSearchList>this.playerSearchList;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerSearchList = _data["playerSearchList"] ? PlayerSearchList.fromJS(_data["playerSearchList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerSearchQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerSearchQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerSearchList"] = this.playerSearchList ? this.playerSearchList.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerSearchQueryResponse {
        const json = this.toJSON();
        let result = new GetPlayerSearchQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerSearchQueryResponse {
    playerSearchList?: IPlayerSearchList | undefined;
}

export enum RewardReasonType {
    UsedBoard = "UsedBoard",
    AdWatchBoards = "AdWatchBoards",
    PurchaseBoards = "PurchaseBoards",
    AchievementBoards = "AchievementBoards",
    LevelUpBoards = "LevelUpBoards",
    AdminGrantBoards = "AdminGrantBoards",
    UsedHint = "UsedHint",
    AdWatchHints = "AdWatchHints",
    PurchaseHints = "PurchaseHints",
    AchievementHints = "AchievementHints",
    LevelUpHints = "LevelUpHints",
    AdminGrantHints = "AdminGrantHints",
    UsedMoreTime = "UsedMoreTime",
    AdWatchMoreTime = "AdWatchMoreTime",
    PurchaseMoreTime = "PurchaseMoreTime",
    AchievementMoreTime = "AchievementMoreTime",
    LevelUpMoreTime = "LevelUpMoreTime",
    AdminGrantMoreTime = "AdminGrantMoreTime",
    PurchaseAdFree = "PurchaseAdFree",
    AchievementAdFree = "AchievementAdFree",
    LevelUpAdFree = "LevelUpAdFree",
    AdminGrantAdFree = "AdminGrantAdFree",
    PurchaseBundle = "PurchaseBundle",
    DailyReward = "DailyReward",
    WeeklyReward = "WeeklyReward",
    LoginStreak = "LoginStreak",
    FirstWin = "FirstWin",
    WinStreak = "WinStreak",
    PersonalBest = "PersonalBest",
    Referral = "Referral",
    ReferralAccepted = "ReferralAccepted",
    Correction = "Correction",
    Refund = "Refund",
    CompensationCredit = "CompensationCredit",
}

export class AddPlayerBoardCountCommandRequest implements IAddPlayerBoardCountCommandRequest {
    additonAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IAddPlayerBoardCountCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additonAmount = _data["additonAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): AddPlayerBoardCountCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPlayerBoardCountCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additonAmount"] = this.additonAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): AddPlayerBoardCountCommandRequest {
        const json = this.toJSON();
        let result = new AddPlayerBoardCountCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddPlayerBoardCountCommandRequest {
    additonAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class AddPlayerBoardCountCommandResponse implements IAddPlayerBoardCountCommandResponse {
    message?: string | undefined;
    numberOfBoards?: number;
    additonAmount?: number;

    constructor(data?: IAddPlayerBoardCountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfBoards = _data["numberOfBoards"];
            this.additonAmount = _data["additonAmount"];
        }
    }

    static fromJS(data: any): AddPlayerBoardCountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPlayerBoardCountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfBoards"] = this.numberOfBoards;
        data["additonAmount"] = this.additonAmount;
        return data;
    }

    clone(): AddPlayerBoardCountCommandResponse {
        const json = this.toJSON();
        let result = new AddPlayerBoardCountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddPlayerBoardCountCommandResponse {
    message?: string | undefined;
    numberOfBoards?: number;
    additonAmount?: number;
}

export class SubtractPlayerBoardCountCommandRequest implements ISubtractPlayerBoardCountCommandRequest {
    subtractionAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: ISubtractPlayerBoardCountCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtractionAmount = _data["subtractionAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): SubtractPlayerBoardCountCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubtractPlayerBoardCountCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subtractionAmount"] = this.subtractionAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): SubtractPlayerBoardCountCommandRequest {
        const json = this.toJSON();
        let result = new SubtractPlayerBoardCountCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISubtractPlayerBoardCountCommandRequest {
    subtractionAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class SubtractPlayerBoardCountCommandResponse implements ISubtractPlayerBoardCountCommandResponse {
    message?: string | undefined;
    numberOfBoards?: number;
    subtractionAmount?: number;

    constructor(data?: ISubtractPlayerBoardCountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfBoards = _data["numberOfBoards"];
            this.subtractionAmount = _data["subtractionAmount"];
        }
    }

    static fromJS(data: any): SubtractPlayerBoardCountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubtractPlayerBoardCountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfBoards"] = this.numberOfBoards;
        data["subtractionAmount"] = this.subtractionAmount;
        return data;
    }

    clone(): SubtractPlayerBoardCountCommandResponse {
        const json = this.toJSON();
        let result = new SubtractPlayerBoardCountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISubtractPlayerBoardCountCommandResponse {
    message?: string | undefined;
    numberOfBoards?: number;
    subtractionAmount?: number;
}

export class UpdatePlayerBoardCountCommandRequest implements IUpdatePlayerBoardCountCommandRequest {
    updateAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IUpdatePlayerBoardCountCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateAmount = _data["updateAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): UpdatePlayerBoardCountCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlayerBoardCountCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateAmount"] = this.updateAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): UpdatePlayerBoardCountCommandRequest {
        const json = this.toJSON();
        let result = new UpdatePlayerBoardCountCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlayerBoardCountCommandRequest {
    updateAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class UpdatePlayerBoardCountCommandResponse implements IUpdatePlayerBoardCountCommandResponse {
    message?: string | undefined;
    numberOfBoards?: number;
    previousBoards?: number;

    constructor(data?: IUpdatePlayerBoardCountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfBoards = _data["numberOfBoards"];
            this.previousBoards = _data["previousBoards"];
        }
    }

    static fromJS(data: any): UpdatePlayerBoardCountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlayerBoardCountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfBoards"] = this.numberOfBoards;
        data["previousBoards"] = this.previousBoards;
        return data;
    }

    clone(): UpdatePlayerBoardCountCommandResponse {
        const json = this.toJSON();
        let result = new UpdatePlayerBoardCountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlayerBoardCountCommandResponse {
    message?: string | undefined;
    numberOfBoards?: number;
    previousBoards?: number;
}

export class AddHintsCommandRequest implements IAddHintsCommandRequest {
    additonAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IAddHintsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additonAmount = _data["additonAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): AddHintsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddHintsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additonAmount"] = this.additonAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): AddHintsCommandRequest {
        const json = this.toJSON();
        let result = new AddHintsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddHintsCommandRequest {
    additonAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class AddHintsCommandResponse implements IAddHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
    additonAmount?: number;

    constructor(data?: IAddHintsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfHints = _data["numberOfHints"];
            this.additonAmount = _data["additonAmount"];
        }
    }

    static fromJS(data: any): AddHintsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddHintsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfHints"] = this.numberOfHints;
        data["additonAmount"] = this.additonAmount;
        return data;
    }

    clone(): AddHintsCommandResponse {
        const json = this.toJSON();
        let result = new AddHintsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
    additonAmount?: number;
}

export class RemoveHintsCommandRequest implements IRemoveHintsCommandRequest {
    subtractionnAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IRemoveHintsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtractionnAmount = _data["subtractionnAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): RemoveHintsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveHintsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subtractionnAmount"] = this.subtractionnAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): RemoveHintsCommandRequest {
        const json = this.toJSON();
        let result = new RemoveHintsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveHintsCommandRequest {
    subtractionnAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class RemoveHintsCommandResponse implements IRemoveHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
    subtractionnAmount?: number;

    constructor(data?: IRemoveHintsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfHints = _data["numberOfHints"];
            this.subtractionnAmount = _data["subtractionnAmount"];
        }
    }

    static fromJS(data: any): RemoveHintsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveHintsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfHints"] = this.numberOfHints;
        data["subtractionnAmount"] = this.subtractionnAmount;
        return data;
    }

    clone(): RemoveHintsCommandResponse {
        const json = this.toJSON();
        let result = new RemoveHintsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
    subtractionnAmount?: number;
}

export class UpdateHintsCommandRequest implements IUpdateHintsCommandRequest {
    updateAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IUpdateHintsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateAmount = _data["updateAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): UpdateHintsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHintsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateAmount"] = this.updateAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): UpdateHintsCommandRequest {
        const json = this.toJSON();
        let result = new UpdateHintsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateHintsCommandRequest {
    updateAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class UpdateHintsCommandResponse implements IUpdateHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
    previousHints?: number;

    constructor(data?: IUpdateHintsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfHints = _data["numberOfHints"];
            this.previousHints = _data["previousHints"];
        }
    }

    static fromJS(data: any): UpdateHintsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHintsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfHints"] = this.numberOfHints;
        data["previousHints"] = this.previousHints;
        return data;
    }

    clone(): UpdateHintsCommandResponse {
        const json = this.toJSON();
        let result = new UpdateHintsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateHintsCommandResponse {
    message?: string | undefined;
    numberOfHints?: number;
    previousHints?: number;
}

export class AddMoreTimeCommandRequest implements IAddMoreTimeCommandRequest {
    additonAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IAddMoreTimeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additonAmount = _data["additonAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): AddMoreTimeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMoreTimeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additonAmount"] = this.additonAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): AddMoreTimeCommandRequest {
        const json = this.toJSON();
        let result = new AddMoreTimeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddMoreTimeCommandRequest {
    additonAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class AddMoreTimeCommandResponse implements IAddMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
    additonAmount?: number;

    constructor(data?: IAddMoreTimeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfMoreTime = _data["numberOfMoreTime"];
            this.additonAmount = _data["additonAmount"];
        }
    }

    static fromJS(data: any): AddMoreTimeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMoreTimeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfMoreTime"] = this.numberOfMoreTime;
        data["additonAmount"] = this.additonAmount;
        return data;
    }

    clone(): AddMoreTimeCommandResponse {
        const json = this.toJSON();
        let result = new AddMoreTimeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
    additonAmount?: number;
}

export class RemoveMoreTimeCommandRequest implements IRemoveMoreTimeCommandRequest {
    subtractionnAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IRemoveMoreTimeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtractionnAmount = _data["subtractionnAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): RemoveMoreTimeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMoreTimeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subtractionnAmount"] = this.subtractionnAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): RemoveMoreTimeCommandRequest {
        const json = this.toJSON();
        let result = new RemoveMoreTimeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveMoreTimeCommandRequest {
    subtractionnAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class RemoveMoreTimeCommandResponse implements IRemoveMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
    subtractionnAmount?: number;

    constructor(data?: IRemoveMoreTimeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfMoreTime = _data["numberOfMoreTime"];
            this.subtractionnAmount = _data["subtractionnAmount"];
        }
    }

    static fromJS(data: any): RemoveMoreTimeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMoreTimeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfMoreTime"] = this.numberOfMoreTime;
        data["subtractionnAmount"] = this.subtractionnAmount;
        return data;
    }

    clone(): RemoveMoreTimeCommandResponse {
        const json = this.toJSON();
        let result = new RemoveMoreTimeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
    subtractionnAmount?: number;
}

export class UpdateMoreTimeCommandRequest implements IUpdateMoreTimeCommandRequest {
    updateAmount?: number;
    reasonType?: RewardReasonType | undefined;

    constructor(data?: IUpdateMoreTimeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateAmount = _data["updateAmount"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): UpdateMoreTimeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoreTimeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateAmount"] = this.updateAmount;
        data["reasonType"] = this.reasonType;
        return data;
    }

    clone(): UpdateMoreTimeCommandRequest {
        const json = this.toJSON();
        let result = new UpdateMoreTimeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateMoreTimeCommandRequest {
    updateAmount?: number;
    reasonType?: RewardReasonType | undefined;
}

export class UpdateMoreTimeCommandResponse implements IUpdateMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
    previousMoreTime?: number;

    constructor(data?: IUpdateMoreTimeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.numberOfMoreTime = _data["numberOfMoreTime"];
            this.previousMoreTime = _data["previousMoreTime"];
        }
    }

    static fromJS(data: any): UpdateMoreTimeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoreTimeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["numberOfMoreTime"] = this.numberOfMoreTime;
        data["previousMoreTime"] = this.previousMoreTime;
        return data;
    }

    clone(): UpdateMoreTimeCommandResponse {
        const json = this.toJSON();
        let result = new UpdateMoreTimeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateMoreTimeCommandResponse {
    message?: string | undefined;
    numberOfMoreTime?: number;
    previousMoreTime?: number;
}

export class GetHintForCellCommandRequest implements IGetHintForCellCommandRequest {
    gameId?: string;
    board?: string | undefined;

    constructor(data?: IGetHintForCellCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.board = _data["board"];
        }
    }

    static fromJS(data: any): GetHintForCellCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetHintForCellCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["board"] = this.board;
        return data;
    }

    clone(): GetHintForCellCommandRequest {
        const json = this.toJSON();
        let result = new GetHintForCellCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetHintForCellCommandRequest {
    gameId?: string;
    board?: string | undefined;
}

export class GetHintForCellCommandResponse implements IGetHintForCellCommandResponse {
    cellHint?: string[] | undefined;
    hintsRemaining?: number;

    constructor(data?: IGetHintForCellCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cellHint"])) {
                this.cellHint = [] as any;
                for (let item of _data["cellHint"])
                    this.cellHint!.push(item);
            }
            this.hintsRemaining = _data["hintsRemaining"];
        }
    }

    static fromJS(data: any): GetHintForCellCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHintForCellCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cellHint)) {
            data["cellHint"] = [];
            for (let item of this.cellHint)
                data["cellHint"].push(item);
        }
        data["hintsRemaining"] = this.hintsRemaining;
        return data;
    }

    clone(): GetHintForCellCommandResponse {
        const json = this.toJSON();
        let result = new GetHintForCellCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetHintForCellCommandResponse {
    cellHint?: string[] | undefined;
    hintsRemaining?: number;
}

export class SendFriendRequestCommandRequest implements ISendFriendRequestCommandRequest {
    inviteeUserId?: string | undefined;

    constructor(data?: ISendFriendRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteeUserId = _data["inviteeUserId"];
        }
    }

    static fromJS(data: any): SendFriendRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendFriendRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteeUserId"] = this.inviteeUserId;
        return data;
    }

    clone(): SendFriendRequestCommandRequest {
        const json = this.toJSON();
        let result = new SendFriendRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISendFriendRequestCommandRequest {
    inviteeUserId?: string | undefined;
}

export class SendFriendRequestCommandResponse implements ISendFriendRequestCommandResponse {
    requestId?: string | undefined;
    status?: FriendRequestStatus;

    constructor(data?: ISendFriendRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SendFriendRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendFriendRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["status"] = this.status;
        return data;
    }

    clone(): SendFriendRequestCommandResponse {
        const json = this.toJSON();
        let result = new SendFriendRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISendFriendRequestCommandResponse {
    requestId?: string | undefined;
    status?: FriendRequestStatus;
}

export class CancelFriendRequestCommandRequest implements ICancelFriendRequestCommandRequest {
    requestId?: string | undefined;

    constructor(data?: ICancelFriendRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): CancelFriendRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelFriendRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }

    clone(): CancelFriendRequestCommandRequest {
        const json = this.toJSON();
        let result = new CancelFriendRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICancelFriendRequestCommandRequest {
    requestId?: string | undefined;
}

export class CancelFriendRequestCommandResponse implements ICancelFriendRequestCommandResponse {
    status?: FriendRequestStatus;

    constructor(data?: ICancelFriendRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CancelFriendRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelFriendRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): CancelFriendRequestCommandResponse {
        const json = this.toJSON();
        let result = new CancelFriendRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICancelFriendRequestCommandResponse {
    status?: FriendRequestStatus;
}

export class AcceptFriendRequestCommandRequest implements IAcceptFriendRequestCommandRequest {
    inviterUserId?: string | undefined;

    constructor(data?: IAcceptFriendRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviterUserId = _data["inviterUserId"];
        }
    }

    static fromJS(data: any): AcceptFriendRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviterUserId"] = this.inviterUserId;
        return data;
    }

    clone(): AcceptFriendRequestCommandRequest {
        const json = this.toJSON();
        let result = new AcceptFriendRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAcceptFriendRequestCommandRequest {
    inviterUserId?: string | undefined;
}

export class AcceptFriendRequestCommandResponse implements IAcceptFriendRequestCommandResponse {
    status?: FriendRequestStatus;

    constructor(data?: IAcceptFriendRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AcceptFriendRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): AcceptFriendRequestCommandResponse {
        const json = this.toJSON();
        let result = new AcceptFriendRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAcceptFriendRequestCommandResponse {
    status?: FriendRequestStatus;
}

export class RejectFriendRequestCommandRequest implements IRejectFriendRequestCommandRequest {
    inviterUserId?: string | undefined;

    constructor(data?: IRejectFriendRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviterUserId = _data["inviterUserId"];
        }
    }

    static fromJS(data: any): RejectFriendRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectFriendRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviterUserId"] = this.inviterUserId;
        return data;
    }

    clone(): RejectFriendRequestCommandRequest {
        const json = this.toJSON();
        let result = new RejectFriendRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRejectFriendRequestCommandRequest {
    inviterUserId?: string | undefined;
}

export class RejectFriendRequestCommandResponse implements IRejectFriendRequestCommandResponse {
    status?: FriendRequestStatus;

    constructor(data?: IRejectFriendRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RejectFriendRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RejectFriendRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): RejectFriendRequestCommandResponse {
        const json = this.toJSON();
        let result = new RejectFriendRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRejectFriendRequestCommandResponse {
    status?: FriendRequestStatus;
}

export class RemoveFriendCommandRequest implements IRemoveFriendCommandRequest {
    friendUserId?: string | undefined;

    constructor(data?: IRemoveFriendCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
        }
    }

    static fromJS(data: any): RemoveFriendCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFriendCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        return data;
    }

    clone(): RemoveFriendCommandRequest {
        const json = this.toJSON();
        let result = new RemoveFriendCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveFriendCommandRequest {
    friendUserId?: string | undefined;
}

export class RemoveFriendCommandResponse implements IRemoveFriendCommandResponse {
    status?: FriendRequestStatus;

    constructor(data?: IRemoveFriendCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RemoveFriendCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFriendCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): RemoveFriendCommandResponse {
        const json = this.toJSON();
        let result = new RemoveFriendCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveFriendCommandResponse {
    status?: FriendRequestStatus;
}

export class GetGameSummaryCommandRequest implements IGetGameSummaryCommandRequest {
    gameId?: string;
    playerId?: string;

    constructor(data?: IGetGameSummaryCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.playerId = _data["playerId"];
        }
    }

    static fromJS(data: any): GetGameSummaryCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameSummaryCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["playerId"] = this.playerId;
        return data;
    }

    clone(): GetGameSummaryCommandRequest {
        const json = this.toJSON();
        let result = new GetGameSummaryCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetGameSummaryCommandRequest {
    gameId?: string;
    playerId?: string;
}

export class GetGameSummaryCommandResponse implements IGetGameSummaryCommandResponse {
    playerOneUserName?: string | undefined;
    playerTwoUserName?: string | undefined;
    difficulty?: Difficulty;
    timeTaken?: string | undefined;
    hintsUsed?: number;
    moreTimeUsed?: number;
    score?: number;
    errors?: number;
    isSinglePlayer?: boolean;
    gameCompleted?: boolean;

    constructor(data?: IGetGameSummaryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerOneUserName = _data["playerOneUserName"];
            this.playerTwoUserName = _data["playerTwoUserName"];
            this.difficulty = _data["difficulty"];
            this.timeTaken = _data["timeTaken"];
            this.hintsUsed = _data["hintsUsed"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.score = _data["score"];
            this.errors = _data["errors"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.gameCompleted = _data["gameCompleted"];
        }
    }

    static fromJS(data: any): GetGameSummaryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameSummaryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerOneUserName"] = this.playerOneUserName;
        data["playerTwoUserName"] = this.playerTwoUserName;
        data["difficulty"] = this.difficulty;
        data["timeTaken"] = this.timeTaken;
        data["hintsUsed"] = this.hintsUsed;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["score"] = this.score;
        data["errors"] = this.errors;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["gameCompleted"] = this.gameCompleted;
        return data;
    }

    clone(): GetGameSummaryCommandResponse {
        const json = this.toJSON();
        let result = new GetGameSummaryCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetGameSummaryCommandResponse {
    playerOneUserName?: string | undefined;
    playerTwoUserName?: string | undefined;
    difficulty?: Difficulty;
    timeTaken?: string | undefined;
    hintsUsed?: number;
    moreTimeUsed?: number;
    score?: number;
    errors?: number;
    isSinglePlayer?: boolean;
    gameCompleted?: boolean;
}

export class RequestRandomGameCommandResponse implements IRequestRandomGameCommandResponse {
    gameQueued?: boolean;
    numberInQueue?: number;

    constructor(data?: IRequestRandomGameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameQueued = _data["gameQueued"];
            this.numberInQueue = _data["numberInQueue"];
        }
    }

    static fromJS(data: any): RequestRandomGameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRandomGameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameQueued"] = this.gameQueued;
        data["numberInQueue"] = this.numberInQueue;
        return data;
    }

    clone(): RequestRandomGameCommandResponse {
        const json = this.toJSON();
        let result = new RequestRandomGameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRequestRandomGameCommandResponse {
    gameQueued?: boolean;
    numberInQueue?: number;
}

export class CancelPlayerQueueCommandResponse implements ICancelPlayerQueueCommandResponse {
    success?: boolean;

    constructor(data?: ICancelPlayerQueueCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): CancelPlayerQueueCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPlayerQueueCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): CancelPlayerQueueCommandResponse {
        const json = this.toJSON();
        let result = new CancelPlayerQueueCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICancelPlayerQueueCommandResponse {
    success?: boolean;
}

export class SimpleGameRequest implements ISimpleGameRequest {
    requestId?: string;
    requestorId?: string;
    requestorUserName?: string | undefined;
    requestorRankName?: string | undefined;
    requestorRankScore?: number | undefined;
    matchedPlayerId?: string | undefined;
    matchedPlayerUserName?: string | undefined;
    matchedPlayerRankName?: string | undefined;
    matchedPlayerRankScore?: number | undefined;
    rank?: number | undefined;
    difficulty?: Difficulty | undefined;
    dateRequested?: string | undefined;
    isLoggedIn?: boolean;
    isBotRequest?: boolean;

    constructor(data?: ISimpleGameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestorId = _data["requestorId"];
            this.requestorUserName = _data["requestorUserName"];
            this.requestorRankName = _data["requestorRankName"];
            this.requestorRankScore = _data["requestorRankScore"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.matchedPlayerUserName = _data["matchedPlayerUserName"];
            this.matchedPlayerRankName = _data["matchedPlayerRankName"];
            this.matchedPlayerRankScore = _data["matchedPlayerRankScore"];
            this.rank = _data["rank"];
            this.difficulty = _data["difficulty"];
            this.dateRequested = _data["dateRequested"];
            this.isLoggedIn = _data["isLoggedIn"];
            this.isBotRequest = _data["isBotRequest"];
        }
    }

    static fromJS(data: any): SimpleGameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleGameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestorId"] = this.requestorId;
        data["requestorUserName"] = this.requestorUserName;
        data["requestorRankName"] = this.requestorRankName;
        data["requestorRankScore"] = this.requestorRankScore;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["matchedPlayerUserName"] = this.matchedPlayerUserName;
        data["matchedPlayerRankName"] = this.matchedPlayerRankName;
        data["matchedPlayerRankScore"] = this.matchedPlayerRankScore;
        data["rank"] = this.rank;
        data["difficulty"] = this.difficulty;
        data["dateRequested"] = this.dateRequested;
        data["isLoggedIn"] = this.isLoggedIn;
        data["isBotRequest"] = this.isBotRequest;
        return data;
    }

    clone(): SimpleGameRequest {
        const json = this.toJSON();
        let result = new SimpleGameRequest();
        result.init(json);
        return result;
    }
}

export interface ISimpleGameRequest {
    requestId?: string;
    requestorId?: string;
    requestorUserName?: string | undefined;
    requestorRankName?: string | undefined;
    requestorRankScore?: number | undefined;
    matchedPlayerId?: string | undefined;
    matchedPlayerUserName?: string | undefined;
    matchedPlayerRankName?: string | undefined;
    matchedPlayerRankScore?: number | undefined;
    rank?: number | undefined;
    difficulty?: Difficulty | undefined;
    dateRequested?: string | undefined;
    isLoggedIn?: boolean;
    isBotRequest?: boolean;
}

export class GetPlayerQueueStatusCommandResponse implements IGetPlayerQueueStatusCommandResponse {
    status?: string | undefined;
    currentRequest?: SimpleGameRequest | undefined;

    constructor(data?: IGetPlayerQueueStatusCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.currentRequest = data.currentRequest && !(<any>data.currentRequest).toJSON ? new SimpleGameRequest(data.currentRequest) : <SimpleGameRequest>this.currentRequest;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.currentRequest = _data["currentRequest"] ? SimpleGameRequest.fromJS(_data["currentRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerQueueStatusCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerQueueStatusCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["currentRequest"] = this.currentRequest ? this.currentRequest.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerQueueStatusCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerQueueStatusCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerQueueStatusCommandResponse {
    status?: string | undefined;
    currentRequest?: ISimpleGameRequest | undefined;
}

export class GetCurrentMatchesCommandResponse implements IGetCurrentMatchesCommandResponse {
    gameQueue?: SimpleGameRequest[] | undefined;

    constructor(data?: IGetCurrentMatchesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.gameQueue) {
                this.gameQueue = [];
                for (let i = 0; i < data.gameQueue.length; i++) {
                    let item = data.gameQueue[i];
                    this.gameQueue[i] = item && !(<any>item).toJSON ? new SimpleGameRequest(item) : <SimpleGameRequest>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gameQueue"])) {
                this.gameQueue = [] as any;
                for (let item of _data["gameQueue"])
                    this.gameQueue!.push(SimpleGameRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrentMatchesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentMatchesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gameQueue)) {
            data["gameQueue"] = [];
            for (let item of this.gameQueue)
                data["gameQueue"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetCurrentMatchesCommandResponse {
        const json = this.toJSON();
        let result = new GetCurrentMatchesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentMatchesCommandResponse {
    gameQueue?: ISimpleGameRequest[] | undefined;
}

export class GetCurrentMatchesCommandResponseOld implements IGetCurrentMatchesCommandResponseOld {
    gameQueue?: SimpleGameRequest[] | undefined;

    constructor(data?: IGetCurrentMatchesCommandResponseOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.gameQueue) {
                this.gameQueue = [];
                for (let i = 0; i < data.gameQueue.length; i++) {
                    let item = data.gameQueue[i];
                    this.gameQueue[i] = item && !(<any>item).toJSON ? new SimpleGameRequest(item) : <SimpleGameRequest>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gameQueue"])) {
                this.gameQueue = [] as any;
                for (let item of _data["gameQueue"])
                    this.gameQueue!.push(SimpleGameRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrentMatchesCommandResponseOld {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentMatchesCommandResponseOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gameQueue)) {
            data["gameQueue"] = [];
            for (let item of this.gameQueue)
                data["gameQueue"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetCurrentMatchesCommandResponseOld {
        const json = this.toJSON();
        let result = new GetCurrentMatchesCommandResponseOld();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentMatchesCommandResponseOld {
    gameQueue?: ISimpleGameRequest[] | undefined;
}

export class RequestRandomGameCommandRequestOld implements IRequestRandomGameCommandRequestOld {
    difficulty?: Difficulty;

    constructor(data?: IRequestRandomGameCommandRequestOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.difficulty = _data["difficulty"];
        }
    }

    static fromJS(data: any): RequestRandomGameCommandRequestOld {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRandomGameCommandRequestOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["difficulty"] = this.difficulty;
        return data;
    }

    clone(): RequestRandomGameCommandRequestOld {
        const json = this.toJSON();
        let result = new RequestRandomGameCommandRequestOld();
        result.init(json);
        return result;
    }
}

export interface IRequestRandomGameCommandRequestOld {
    difficulty?: Difficulty;
}

export class RequestRandomGameCommandResponseOld implements IRequestRandomGameCommandResponseOld {
    difficulty?: Difficulty;
    gameQueued?: boolean;
    numberInQueue?: number;

    constructor(data?: IRequestRandomGameCommandResponseOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.difficulty = _data["difficulty"];
            this.gameQueued = _data["gameQueued"];
            this.numberInQueue = _data["numberInQueue"];
        }
    }

    static fromJS(data: any): RequestRandomGameCommandResponseOld {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRandomGameCommandResponseOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["difficulty"] = this.difficulty;
        data["gameQueued"] = this.gameQueued;
        data["numberInQueue"] = this.numberInQueue;
        return data;
    }

    clone(): RequestRandomGameCommandResponseOld {
        const json = this.toJSON();
        let result = new RequestRandomGameCommandResponseOld();
        result.init(json);
        return result;
    }
}

export interface IRequestRandomGameCommandResponseOld {
    difficulty?: Difficulty;
    gameQueued?: boolean;
    numberInQueue?: number;
}

export class AcceptRandomGameRequestCommandRequest implements IAcceptRandomGameRequestCommandRequest {
    requestId?: string;

    constructor(data?: IAcceptRandomGameRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): AcceptRandomGameRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptRandomGameRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }

    clone(): AcceptRandomGameRequestCommandRequest {
        const json = this.toJSON();
        let result = new AcceptRandomGameRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAcceptRandomGameRequestCommandRequest {
    requestId?: string;
}

export class AcceptRandomGameRequestCommandResponse implements IAcceptRandomGameRequestCommandResponse {
    success?: boolean;
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    gameRequestId?: string;

    constructor(data?: IAcceptRandomGameRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.requestorId = _data["requestorId"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.gameRequestStatus = _data["gameRequestStatus"];
            this.gameRequestId = _data["gameRequestId"];
        }
    }

    static fromJS(data: any): AcceptRandomGameRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptRandomGameRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["requestorId"] = this.requestorId;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["gameRequestStatus"] = this.gameRequestStatus;
        data["gameRequestId"] = this.gameRequestId;
        return data;
    }

    clone(): AcceptRandomGameRequestCommandResponse {
        const json = this.toJSON();
        let result = new AcceptRandomGameRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAcceptRandomGameRequestCommandResponse {
    success?: boolean;
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    gameRequestId?: string;
}

export class SimpleGameRequestResponse implements ISimpleGameRequestResponse {
    id?: string;
    requestorId?: string;
    requestorUsername?: string | undefined;
    requestorRankName?: string | undefined;
    requestorRankScore?: number | undefined;
    readonly requestorIcon?: number | undefined;
    requestorCountryCode?: string | undefined;
    matchedPlayerId?: string | undefined;
    matchedPlayerUsername?: string | undefined;
    matchedPlayerRankName?: string | undefined;
    matchedPlayerRankScore?: number | undefined;
    readonly matchedPlayerIcon?: number | undefined;
    matchedPlayerCountryCode?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    timeCreated?: string | undefined;
    isFriend?: boolean;
    isLoggedIn?: boolean;

    constructor(data?: ISimpleGameRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestorId = _data["requestorId"];
            this.requestorUsername = _data["requestorUsername"];
            this.requestorRankName = _data["requestorRankName"];
            this.requestorRankScore = _data["requestorRankScore"];
            (<any>this).requestorIcon = _data["requestorIcon"];
            this.requestorCountryCode = _data["requestorCountryCode"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.matchedPlayerUsername = _data["matchedPlayerUsername"];
            this.matchedPlayerRankName = _data["matchedPlayerRankName"];
            this.matchedPlayerRankScore = _data["matchedPlayerRankScore"];
            (<any>this).matchedPlayerIcon = _data["matchedPlayerIcon"];
            this.matchedPlayerCountryCode = _data["matchedPlayerCountryCode"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.gameRequestStatus = _data["gameRequestStatus"];
            this.timeCreated = _data["timeCreated"];
            this.isFriend = _data["isFriend"];
            this.isLoggedIn = _data["isLoggedIn"];
        }
    }

    static fromJS(data: any): SimpleGameRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleGameRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestorId"] = this.requestorId;
        data["requestorUsername"] = this.requestorUsername;
        data["requestorRankName"] = this.requestorRankName;
        data["requestorRankScore"] = this.requestorRankScore;
        data["requestorIcon"] = this.requestorIcon;
        data["requestorCountryCode"] = this.requestorCountryCode;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["matchedPlayerUsername"] = this.matchedPlayerUsername;
        data["matchedPlayerRankName"] = this.matchedPlayerRankName;
        data["matchedPlayerRankScore"] = this.matchedPlayerRankScore;
        data["matchedPlayerIcon"] = this.matchedPlayerIcon;
        data["matchedPlayerCountryCode"] = this.matchedPlayerCountryCode;
        data["gameDifficulty"] = this.gameDifficulty;
        data["gameRequestStatus"] = this.gameRequestStatus;
        data["timeCreated"] = this.timeCreated;
        data["isFriend"] = this.isFriend;
        data["isLoggedIn"] = this.isLoggedIn;
        return data;
    }

    clone(): SimpleGameRequestResponse {
        const json = this.toJSON();
        let result = new SimpleGameRequestResponse();
        result.init(json);
        return result;
    }
}

export interface ISimpleGameRequestResponse {
    id?: string;
    requestorId?: string;
    requestorUsername?: string | undefined;
    requestorRankName?: string | undefined;
    requestorRankScore?: number | undefined;
    requestorIcon?: number | undefined;
    requestorCountryCode?: string | undefined;
    matchedPlayerId?: string | undefined;
    matchedPlayerUsername?: string | undefined;
    matchedPlayerRankName?: string | undefined;
    matchedPlayerRankScore?: number | undefined;
    matchedPlayerIcon?: number | undefined;
    matchedPlayerCountryCode?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    timeCreated?: string | undefined;
    isFriend?: boolean;
    isLoggedIn?: boolean;
}

export class GetGameRequestsCommandResponse implements IGetGameRequestsCommandResponse {
    activeGameRequests?: SimpleGameRequestResponse[] | undefined;
    sentGameRequests?: SimpleGameRequestResponse[] | undefined;
    pendingGameRequests?: SimpleGameRequestResponse[] | undefined;

    constructor(data?: IGetGameRequestsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.activeGameRequests) {
                this.activeGameRequests = [];
                for (let i = 0; i < data.activeGameRequests.length; i++) {
                    let item = data.activeGameRequests[i];
                    this.activeGameRequests[i] = item && !(<any>item).toJSON ? new SimpleGameRequestResponse(item) : <SimpleGameRequestResponse>item;
                }
            }
            if (data.sentGameRequests) {
                this.sentGameRequests = [];
                for (let i = 0; i < data.sentGameRequests.length; i++) {
                    let item = data.sentGameRequests[i];
                    this.sentGameRequests[i] = item && !(<any>item).toJSON ? new SimpleGameRequestResponse(item) : <SimpleGameRequestResponse>item;
                }
            }
            if (data.pendingGameRequests) {
                this.pendingGameRequests = [];
                for (let i = 0; i < data.pendingGameRequests.length; i++) {
                    let item = data.pendingGameRequests[i];
                    this.pendingGameRequests[i] = item && !(<any>item).toJSON ? new SimpleGameRequestResponse(item) : <SimpleGameRequestResponse>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeGameRequests"])) {
                this.activeGameRequests = [] as any;
                for (let item of _data["activeGameRequests"])
                    this.activeGameRequests!.push(SimpleGameRequestResponse.fromJS(item));
            }
            if (Array.isArray(_data["sentGameRequests"])) {
                this.sentGameRequests = [] as any;
                for (let item of _data["sentGameRequests"])
                    this.sentGameRequests!.push(SimpleGameRequestResponse.fromJS(item));
            }
            if (Array.isArray(_data["pendingGameRequests"])) {
                this.pendingGameRequests = [] as any;
                for (let item of _data["pendingGameRequests"])
                    this.pendingGameRequests!.push(SimpleGameRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGameRequestsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameRequestsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeGameRequests)) {
            data["activeGameRequests"] = [];
            for (let item of this.activeGameRequests)
                data["activeGameRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.sentGameRequests)) {
            data["sentGameRequests"] = [];
            for (let item of this.sentGameRequests)
                data["sentGameRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingGameRequests)) {
            data["pendingGameRequests"] = [];
            for (let item of this.pendingGameRequests)
                data["pendingGameRequests"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetGameRequestsCommandResponse {
        const json = this.toJSON();
        let result = new GetGameRequestsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetGameRequestsCommandResponse {
    activeGameRequests?: ISimpleGameRequestResponse[] | undefined;
    sentGameRequests?: ISimpleGameRequestResponse[] | undefined;
    pendingGameRequests?: ISimpleGameRequestResponse[] | undefined;
}

export class AcceptGameRequestCommandRequest implements IAcceptGameRequestCommandRequest {
    requestId?: string;

    constructor(data?: IAcceptGameRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): AcceptGameRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptGameRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }

    clone(): AcceptGameRequestCommandRequest {
        const json = this.toJSON();
        let result = new AcceptGameRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAcceptGameRequestCommandRequest {
    requestId?: string;
}

export class AcceptGameRequestCommandResponse implements IAcceptGameRequestCommandResponse {
    success?: boolean;
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    gameRequestId?: string;

    constructor(data?: IAcceptGameRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.requestorId = _data["requestorId"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.gameRequestStatus = _data["gameRequestStatus"];
            this.gameRequestId = _data["gameRequestId"];
        }
    }

    static fromJS(data: any): AcceptGameRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptGameRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["requestorId"] = this.requestorId;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["gameRequestStatus"] = this.gameRequestStatus;
        data["gameRequestId"] = this.gameRequestId;
        return data;
    }

    clone(): AcceptGameRequestCommandResponse {
        const json = this.toJSON();
        let result = new AcceptGameRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAcceptGameRequestCommandResponse {
    success?: boolean;
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
    gameRequestId?: string;
}

export class RejectGameRequestCommandRequest implements IRejectGameRequestCommandRequest {
    requestId?: string;

    constructor(data?: IRejectGameRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): RejectGameRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectGameRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }

    clone(): RejectGameRequestCommandRequest {
        const json = this.toJSON();
        let result = new RejectGameRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRejectGameRequestCommandRequest {
    requestId?: string;
}

export class RejectGameRequestCommandResponse implements IRejectGameRequestCommandResponse {
    success?: boolean;

    constructor(data?: IRejectGameRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): RejectGameRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RejectGameRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): RejectGameRequestCommandResponse {
        const json = this.toJSON();
        let result = new RejectGameRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRejectGameRequestCommandResponse {
    success?: boolean;
}

export class CancelGameRequestCommandRequest implements ICancelGameRequestCommandRequest {
    requestId?: string;

    constructor(data?: ICancelGameRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): CancelGameRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelGameRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }

    clone(): CancelGameRequestCommandRequest {
        const json = this.toJSON();
        let result = new CancelGameRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICancelGameRequestCommandRequest {
    requestId?: string;
}

export class CancelGameRequestCommandResponse implements ICancelGameRequestCommandResponse {
    success?: boolean;

    constructor(data?: ICancelGameRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): CancelGameRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelGameRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): CancelGameRequestCommandResponse {
        const json = this.toJSON();
        let result = new CancelGameRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICancelGameRequestCommandResponse {
    success?: boolean;
}

export class SendGameRequestCommandRequest implements ISendGameRequestCommandRequest {
    requestedPlayerId?: string;
    difficulty?: Difficulty;

    constructor(data?: ISendGameRequestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedPlayerId = _data["requestedPlayerId"];
            this.difficulty = _data["difficulty"];
        }
    }

    static fromJS(data: any): SendGameRequestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendGameRequestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedPlayerId"] = this.requestedPlayerId;
        data["difficulty"] = this.difficulty;
        return data;
    }

    clone(): SendGameRequestCommandRequest {
        const json = this.toJSON();
        let result = new SendGameRequestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISendGameRequestCommandRequest {
    requestedPlayerId?: string;
    difficulty?: Difficulty;
}

export class SendGameRequestCommandResponse implements ISendGameRequestCommandResponse {
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;

    constructor(data?: ISendGameRequestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestorId = _data["requestorId"];
            this.matchedPlayerId = _data["matchedPlayerId"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.gameRequestStatus = _data["gameRequestStatus"];
        }
    }

    static fromJS(data: any): SendGameRequestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendGameRequestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorId"] = this.requestorId;
        data["matchedPlayerId"] = this.matchedPlayerId;
        data["gameDifficulty"] = this.gameDifficulty;
        data["gameRequestStatus"] = this.gameRequestStatus;
        return data;
    }

    clone(): SendGameRequestCommandResponse {
        const json = this.toJSON();
        let result = new SendGameRequestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISendGameRequestCommandResponse {
    requestorId?: string;
    matchedPlayerId?: string | undefined;
    gameDifficulty?: Difficulty;
    gameRequestStatus?: GameRequestStatus;
}

export class ResignFromGameCommandRequest implements IResignFromGameCommandRequest {
    gameId?: string;

    constructor(data?: IResignFromGameCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
        }
    }

    static fromJS(data: any): ResignFromGameCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResignFromGameCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        return data;
    }

    clone(): ResignFromGameCommandRequest {
        const json = this.toJSON();
        let result = new ResignFromGameCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResignFromGameCommandRequest {
    gameId?: string;
}

export class ResignFromGameCommandResponse implements IResignFromGameCommandResponse {
    summary?: EndGameSummaryModel | undefined;
    success?: boolean;

    constructor(data?: IResignFromGameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.summary = data.summary && !(<any>data.summary).toJSON ? new EndGameSummaryModel(data.summary) : <EndGameSummaryModel>this.summary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? EndGameSummaryModel.fromJS(_data["summary"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ResignFromGameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResignFromGameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }

    clone(): ResignFromGameCommandResponse {
        const json = this.toJSON();
        let result = new ResignFromGameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResignFromGameCommandResponse {
    summary?: IEndGameSummaryModel | undefined;
    success?: boolean;
}

export class CompareFriendStatsCommandRequest implements ICompareFriendStatsCommandRequest {
    friendUserId?: string;

    constructor(data?: ICompareFriendStatsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
        }
    }

    static fromJS(data: any): CompareFriendStatsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompareFriendStatsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        return data;
    }

    clone(): CompareFriendStatsCommandRequest {
        const json = this.toJSON();
        let result = new CompareFriendStatsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICompareFriendStatsCommandRequest {
    friendUserId?: string;
}

export class VsStatsSummaryModel implements IVsStatsSummaryModel {
    rank?: string | undefined;
    winPercentage?: string | undefined;
    averageNumbersPlaced?: string | undefined;
    averageErrors?: string | undefined;
    averageHintsUsed?: string | undefined;
    averageMoreTimeUsed?: string | undefined;
    highestScore?: string | undefined;
    lowestScore?: string | undefined;
    averageScore?: string | undefined;

    constructor(data?: IVsStatsSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.winPercentage = _data["winPercentage"];
            this.averageNumbersPlaced = _data["averageNumbersPlaced"];
            this.averageErrors = _data["averageErrors"];
            this.averageHintsUsed = _data["averageHintsUsed"];
            this.averageMoreTimeUsed = _data["averageMoreTimeUsed"];
            this.highestScore = _data["highestScore"];
            this.lowestScore = _data["lowestScore"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): VsStatsSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new VsStatsSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["winPercentage"] = this.winPercentage;
        data["averageNumbersPlaced"] = this.averageNumbersPlaced;
        data["averageErrors"] = this.averageErrors;
        data["averageHintsUsed"] = this.averageHintsUsed;
        data["averageMoreTimeUsed"] = this.averageMoreTimeUsed;
        data["highestScore"] = this.highestScore;
        data["lowestScore"] = this.lowestScore;
        data["averageScore"] = this.averageScore;
        return data;
    }

    clone(): VsStatsSummaryModel {
        const json = this.toJSON();
        let result = new VsStatsSummaryModel();
        result.init(json);
        return result;
    }
}

export interface IVsStatsSummaryModel {
    rank?: string | undefined;
    winPercentage?: string | undefined;
    averageNumbersPlaced?: string | undefined;
    averageErrors?: string | undefined;
    averageHintsUsed?: string | undefined;
    averageMoreTimeUsed?: string | undefined;
    highestScore?: string | undefined;
    lowestScore?: string | undefined;
    averageScore?: string | undefined;
}

export class VsFriendStats implements IVsFriendStats {
    playerStats?: VsStatsSummaryModel | undefined;
    friendStats?: VsStatsSummaryModel | undefined;

    constructor(data?: IVsFriendStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerStats = data.playerStats && !(<any>data.playerStats).toJSON ? new VsStatsSummaryModel(data.playerStats) : <VsStatsSummaryModel>this.playerStats;
            this.friendStats = data.friendStats && !(<any>data.friendStats).toJSON ? new VsStatsSummaryModel(data.friendStats) : <VsStatsSummaryModel>this.friendStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerStats = _data["playerStats"] ? VsStatsSummaryModel.fromJS(_data["playerStats"]) : <any>undefined;
            this.friendStats = _data["friendStats"] ? VsStatsSummaryModel.fromJS(_data["friendStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VsFriendStats {
        data = typeof data === 'object' ? data : {};
        let result = new VsFriendStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerStats"] = this.playerStats ? this.playerStats.toJSON() : <any>undefined;
        data["friendStats"] = this.friendStats ? this.friendStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): VsFriendStats {
        const json = this.toJSON();
        let result = new VsFriendStats();
        result.init(json);
        return result;
    }
}

export interface IVsFriendStats {
    playerStats?: IVsStatsSummaryModel | undefined;
    friendStats?: IVsStatsSummaryModel | undefined;
}

export class CompareFriendStatsCommandResponse implements ICompareFriendStatsCommandResponse {
    vsFriendStats?: VsFriendStats | undefined;

    constructor(data?: ICompareFriendStatsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vsFriendStats = data.vsFriendStats && !(<any>data.vsFriendStats).toJSON ? new VsFriendStats(data.vsFriendStats) : <VsFriendStats>this.vsFriendStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vsFriendStats = _data["vsFriendStats"] ? VsFriendStats.fromJS(_data["vsFriendStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompareFriendStatsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompareFriendStatsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vsFriendStats"] = this.vsFriendStats ? this.vsFriendStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): CompareFriendStatsCommandResponse {
        const json = this.toJSON();
        let result = new CompareFriendStatsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICompareFriendStatsCommandResponse {
    vsFriendStats?: IVsFriendStats | undefined;
}

export class PlayerVsStatsModel implements IPlayerVsStatsModel {
    rank?: string | undefined;
    rating?: string | undefined;
    played?: string | undefined;
    wins?: string | undefined;
    winPercentage?: string | undefined;
    avgNumbersPlaced?: string | undefined;
    avgErrors?: string | undefined;
    avgHintsUsed?: string | undefined;
    avgMoreTimeUsed?: string | undefined;
    highestScore?: string | undefined;
    lowestScore?: string | undefined;
    averageScore?: string | undefined;
    last10Games?: string | undefined;

    constructor(data?: IPlayerVsStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.rating = _data["rating"];
            this.played = _data["played"];
            this.wins = _data["wins"];
            this.winPercentage = _data["winPercentage"];
            this.avgNumbersPlaced = _data["avgNumbersPlaced"];
            this.avgErrors = _data["avgErrors"];
            this.avgHintsUsed = _data["avgHintsUsed"];
            this.avgMoreTimeUsed = _data["avgMoreTimeUsed"];
            this.highestScore = _data["highestScore"];
            this.lowestScore = _data["lowestScore"];
            this.averageScore = _data["averageScore"];
            this.last10Games = _data["last10Games"];
        }
    }

    static fromJS(data: any): PlayerVsStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerVsStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["rating"] = this.rating;
        data["played"] = this.played;
        data["wins"] = this.wins;
        data["winPercentage"] = this.winPercentage;
        data["avgNumbersPlaced"] = this.avgNumbersPlaced;
        data["avgErrors"] = this.avgErrors;
        data["avgHintsUsed"] = this.avgHintsUsed;
        data["avgMoreTimeUsed"] = this.avgMoreTimeUsed;
        data["highestScore"] = this.highestScore;
        data["lowestScore"] = this.lowestScore;
        data["averageScore"] = this.averageScore;
        data["last10Games"] = this.last10Games;
        return data;
    }

    clone(): PlayerVsStatsModel {
        const json = this.toJSON();
        let result = new PlayerVsStatsModel();
        result.init(json);
        return result;
    }
}

export interface IPlayerVsStatsModel {
    rank?: string | undefined;
    rating?: string | undefined;
    played?: string | undefined;
    wins?: string | undefined;
    winPercentage?: string | undefined;
    avgNumbersPlaced?: string | undefined;
    avgErrors?: string | undefined;
    avgHintsUsed?: string | undefined;
    avgMoreTimeUsed?: string | undefined;
    highestScore?: string | undefined;
    lowestScore?: string | undefined;
    averageScore?: string | undefined;
    last10Games?: string | undefined;
}

export class MiniStatsModel implements IMiniStatsModel {
    attempted?: string | undefined;
    completed?: string | undefined;
    succssRate?: string | undefined;
    bestTime?: string | undefined;
    slowestTime?: string | undefined;
    highestScore?: string | undefined;
    lowestScore?: string | undefined;
    averageScore?: string | undefined;
    averageTime?: string | undefined;
    averageErrors?: string | undefined;
    averageHints?: string | undefined;

    constructor(data?: IMiniStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attempted = _data["attempted"];
            this.completed = _data["completed"];
            this.succssRate = _data["succssRate"];
            this.bestTime = _data["bestTime"];
            this.slowestTime = _data["slowestTime"];
            this.highestScore = _data["highestScore"];
            this.lowestScore = _data["lowestScore"];
            this.averageScore = _data["averageScore"];
            this.averageTime = _data["averageTime"];
            this.averageErrors = _data["averageErrors"];
            this.averageHints = _data["averageHints"];
        }
    }

    static fromJS(data: any): MiniStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MiniStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attempted"] = this.attempted;
        data["completed"] = this.completed;
        data["succssRate"] = this.succssRate;
        data["bestTime"] = this.bestTime;
        data["slowestTime"] = this.slowestTime;
        data["highestScore"] = this.highestScore;
        data["lowestScore"] = this.lowestScore;
        data["averageScore"] = this.averageScore;
        data["averageTime"] = this.averageTime;
        data["averageErrors"] = this.averageErrors;
        data["averageHints"] = this.averageHints;
        return data;
    }

    clone(): MiniStatsModel {
        const json = this.toJSON();
        let result = new MiniStatsModel();
        result.init(json);
        return result;
    }
}

export interface IMiniStatsModel {
    attempted?: string | undefined;
    completed?: string | undefined;
    succssRate?: string | undefined;
    bestTime?: string | undefined;
    slowestTime?: string | undefined;
    highestScore?: string | undefined;
    lowestScore?: string | undefined;
    averageScore?: string | undefined;
    averageTime?: string | undefined;
    averageErrors?: string | undefined;
    averageHints?: string | undefined;
}

export class PlayerStatsModel implements IPlayerStatsModel {
    overallStats?: MiniStatsModel | undefined;
    easyStats?: MiniStatsModel | undefined;
    mediumStats?: MiniStatsModel | undefined;
    hardStats?: MiniStatsModel | undefined;
    expertStats?: MiniStatsModel | undefined;

    constructor(data?: IPlayerStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.overallStats = data.overallStats && !(<any>data.overallStats).toJSON ? new MiniStatsModel(data.overallStats) : <MiniStatsModel>this.overallStats;
            this.easyStats = data.easyStats && !(<any>data.easyStats).toJSON ? new MiniStatsModel(data.easyStats) : <MiniStatsModel>this.easyStats;
            this.mediumStats = data.mediumStats && !(<any>data.mediumStats).toJSON ? new MiniStatsModel(data.mediumStats) : <MiniStatsModel>this.mediumStats;
            this.hardStats = data.hardStats && !(<any>data.hardStats).toJSON ? new MiniStatsModel(data.hardStats) : <MiniStatsModel>this.hardStats;
            this.expertStats = data.expertStats && !(<any>data.expertStats).toJSON ? new MiniStatsModel(data.expertStats) : <MiniStatsModel>this.expertStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overallStats = _data["overallStats"] ? MiniStatsModel.fromJS(_data["overallStats"]) : <any>undefined;
            this.easyStats = _data["easyStats"] ? MiniStatsModel.fromJS(_data["easyStats"]) : <any>undefined;
            this.mediumStats = _data["mediumStats"] ? MiniStatsModel.fromJS(_data["mediumStats"]) : <any>undefined;
            this.hardStats = _data["hardStats"] ? MiniStatsModel.fromJS(_data["hardStats"]) : <any>undefined;
            this.expertStats = _data["expertStats"] ? MiniStatsModel.fromJS(_data["expertStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overallStats"] = this.overallStats ? this.overallStats.toJSON() : <any>undefined;
        data["easyStats"] = this.easyStats ? this.easyStats.toJSON() : <any>undefined;
        data["mediumStats"] = this.mediumStats ? this.mediumStats.toJSON() : <any>undefined;
        data["hardStats"] = this.hardStats ? this.hardStats.toJSON() : <any>undefined;
        data["expertStats"] = this.expertStats ? this.expertStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): PlayerStatsModel {
        const json = this.toJSON();
        let result = new PlayerStatsModel();
        result.init(json);
        return result;
    }
}

export interface IPlayerStatsModel {
    overallStats?: IMiniStatsModel | undefined;
    easyStats?: IMiniStatsModel | undefined;
    mediumStats?: IMiniStatsModel | undefined;
    hardStats?: IMiniStatsModel | undefined;
    expertStats?: IMiniStatsModel | undefined;
}

export class DailyChallengeStatsModel implements IDailyChallengeStatsModel {
    played?: string | undefined;
    wins?: string | undefined;
    winRate?: string | undefined;
    bestTime?: string | undefined;
    averageTime?: string | undefined;
    worstTime?: string | undefined;
    bestStreak?: string | undefined;
    currentStreak?: string | undefined;
    averageErrors?: string | undefined;

    constructor(data?: IDailyChallengeStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.played = _data["played"];
            this.wins = _data["wins"];
            this.winRate = _data["winRate"];
            this.bestTime = _data["bestTime"];
            this.averageTime = _data["averageTime"];
            this.worstTime = _data["worstTime"];
            this.bestStreak = _data["bestStreak"];
            this.currentStreak = _data["currentStreak"];
            this.averageErrors = _data["averageErrors"];
        }
    }

    static fromJS(data: any): DailyChallengeStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyChallengeStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["played"] = this.played;
        data["wins"] = this.wins;
        data["winRate"] = this.winRate;
        data["bestTime"] = this.bestTime;
        data["averageTime"] = this.averageTime;
        data["worstTime"] = this.worstTime;
        data["bestStreak"] = this.bestStreak;
        data["currentStreak"] = this.currentStreak;
        data["averageErrors"] = this.averageErrors;
        return data;
    }

    clone(): DailyChallengeStatsModel {
        const json = this.toJSON();
        let result = new DailyChallengeStatsModel();
        result.init(json);
        return result;
    }
}

export interface IDailyChallengeStatsModel {
    played?: string | undefined;
    wins?: string | undefined;
    winRate?: string | undefined;
    bestTime?: string | undefined;
    averageTime?: string | undefined;
    worstTime?: string | undefined;
    bestStreak?: string | undefined;
    currentStreak?: string | undefined;
    averageErrors?: string | undefined;
}

export class GetVsStatsCommandResponse implements IGetVsStatsCommandResponse {
    stats?: PlayerVsStatsModel | undefined;
    practiceModeStats?: PlayerStatsModel | undefined;
    dailyChallengeStats?: DailyChallengeStatsModel | undefined;

    constructor(data?: IGetVsStatsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.stats = data.stats && !(<any>data.stats).toJSON ? new PlayerVsStatsModel(data.stats) : <PlayerVsStatsModel>this.stats;
            this.practiceModeStats = data.practiceModeStats && !(<any>data.practiceModeStats).toJSON ? new PlayerStatsModel(data.practiceModeStats) : <PlayerStatsModel>this.practiceModeStats;
            this.dailyChallengeStats = data.dailyChallengeStats && !(<any>data.dailyChallengeStats).toJSON ? new DailyChallengeStatsModel(data.dailyChallengeStats) : <DailyChallengeStatsModel>this.dailyChallengeStats;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stats = _data["stats"] ? PlayerVsStatsModel.fromJS(_data["stats"]) : <any>undefined;
            this.practiceModeStats = _data["practiceModeStats"] ? PlayerStatsModel.fromJS(_data["practiceModeStats"]) : <any>undefined;
            this.dailyChallengeStats = _data["dailyChallengeStats"] ? DailyChallengeStatsModel.fromJS(_data["dailyChallengeStats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVsStatsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVsStatsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["practiceModeStats"] = this.practiceModeStats ? this.practiceModeStats.toJSON() : <any>undefined;
        data["dailyChallengeStats"] = this.dailyChallengeStats ? this.dailyChallengeStats.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetVsStatsCommandResponse {
        const json = this.toJSON();
        let result = new GetVsStatsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetVsStatsCommandResponse {
    stats?: IPlayerVsStatsModel | undefined;
    practiceModeStats?: IPlayerStatsModel | undefined;
    dailyChallengeStats?: IDailyChallengeStatsModel | undefined;
}

export class VersusLeaderboardView implements IVersusLeaderboardView {
    userName?: string | undefined;
    position?: number;
    userId?: string;
    rank?: PlayerRank | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rating?: number | undefined;
    wins?: number | undefined;
    losses?: number | undefined;
    recordWinsAndLosses?: string | undefined;

    constructor(data?: IVersusLeaderboardView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.position = _data["position"];
            this.userId = _data["userId"];
            this.rank = _data["rank"];
            this.countryCode = _data["countryCode"];
            this.icon = _data["icon"];
            this.rating = _data["rating"];
            this.wins = _data["wins"];
            this.losses = _data["losses"];
            this.recordWinsAndLosses = _data["recordWinsAndLosses"];
        }
    }

    static fromJS(data: any): VersusLeaderboardView {
        data = typeof data === 'object' ? data : {};
        let result = new VersusLeaderboardView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["position"] = this.position;
        data["userId"] = this.userId;
        data["rank"] = this.rank;
        data["countryCode"] = this.countryCode;
        data["icon"] = this.icon;
        data["rating"] = this.rating;
        data["wins"] = this.wins;
        data["losses"] = this.losses;
        data["recordWinsAndLosses"] = this.recordWinsAndLosses;
        return data;
    }

    clone(): VersusLeaderboardView {
        const json = this.toJSON();
        let result = new VersusLeaderboardView();
        result.init(json);
        return result;
    }
}

export interface IVersusLeaderboardView {
    userName?: string | undefined;
    position?: number;
    userId?: string;
    rank?: PlayerRank | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rating?: number | undefined;
    wins?: number | undefined;
    losses?: number | undefined;
    recordWinsAndLosses?: string | undefined;
}

export class PracticeLeaderboardView implements IPracticeLeaderboardView {
    position?: number;
    userId?: string;
    userName?: string | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rank?: PlayerRank;
    difficultyLevel?: Difficulty;
    bestTime?: string | undefined;

    constructor(data?: IPracticeLeaderboardView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.countryCode = _data["countryCode"];
            this.icon = _data["icon"];
            this.rank = _data["rank"];
            this.difficultyLevel = _data["difficultyLevel"];
            this.bestTime = _data["bestTime"];
        }
    }

    static fromJS(data: any): PracticeLeaderboardView {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeLeaderboardView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["countryCode"] = this.countryCode;
        data["icon"] = this.icon;
        data["rank"] = this.rank;
        data["difficultyLevel"] = this.difficultyLevel;
        data["bestTime"] = this.bestTime;
        return data;
    }

    clone(): PracticeLeaderboardView {
        const json = this.toJSON();
        let result = new PracticeLeaderboardView();
        result.init(json);
        return result;
    }
}

export interface IPracticeLeaderboardView {
    position?: number;
    userId?: string;
    userName?: string | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rank?: PlayerRank;
    difficultyLevel?: Difficulty;
    bestTime?: string | undefined;
}

export class GetLeaderboardsCommandResponse implements IGetLeaderboardsCommandResponse {
    versusLeaderboard?: VersusLeaderboardView[] | undefined;
    practiceEasyLeaderboard?: PracticeLeaderboardView[] | undefined;
    practiceMediumLeaderboard?: PracticeLeaderboardView[] | undefined;
    practiceHardLeaderboard?: PracticeLeaderboardView[] | undefined;
    practiceExpertLeaderboard?: PracticeLeaderboardView[] | undefined;

    constructor(data?: IGetLeaderboardsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.versusLeaderboard) {
                this.versusLeaderboard = [];
                for (let i = 0; i < data.versusLeaderboard.length; i++) {
                    let item = data.versusLeaderboard[i];
                    this.versusLeaderboard[i] = item && !(<any>item).toJSON ? new VersusLeaderboardView(item) : <VersusLeaderboardView>item;
                }
            }
            if (data.practiceEasyLeaderboard) {
                this.practiceEasyLeaderboard = [];
                for (let i = 0; i < data.practiceEasyLeaderboard.length; i++) {
                    let item = data.practiceEasyLeaderboard[i];
                    this.practiceEasyLeaderboard[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
            if (data.practiceMediumLeaderboard) {
                this.practiceMediumLeaderboard = [];
                for (let i = 0; i < data.practiceMediumLeaderboard.length; i++) {
                    let item = data.practiceMediumLeaderboard[i];
                    this.practiceMediumLeaderboard[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
            if (data.practiceHardLeaderboard) {
                this.practiceHardLeaderboard = [];
                for (let i = 0; i < data.practiceHardLeaderboard.length; i++) {
                    let item = data.practiceHardLeaderboard[i];
                    this.practiceHardLeaderboard[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
            if (data.practiceExpertLeaderboard) {
                this.practiceExpertLeaderboard = [];
                for (let i = 0; i < data.practiceExpertLeaderboard.length; i++) {
                    let item = data.practiceExpertLeaderboard[i];
                    this.practiceExpertLeaderboard[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["versusLeaderboard"])) {
                this.versusLeaderboard = [] as any;
                for (let item of _data["versusLeaderboard"])
                    this.versusLeaderboard!.push(VersusLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["practiceEasyLeaderboard"])) {
                this.practiceEasyLeaderboard = [] as any;
                for (let item of _data["practiceEasyLeaderboard"])
                    this.practiceEasyLeaderboard!.push(PracticeLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["practiceMediumLeaderboard"])) {
                this.practiceMediumLeaderboard = [] as any;
                for (let item of _data["practiceMediumLeaderboard"])
                    this.practiceMediumLeaderboard!.push(PracticeLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["practiceHardLeaderboard"])) {
                this.practiceHardLeaderboard = [] as any;
                for (let item of _data["practiceHardLeaderboard"])
                    this.practiceHardLeaderboard!.push(PracticeLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["practiceExpertLeaderboard"])) {
                this.practiceExpertLeaderboard = [] as any;
                for (let item of _data["practiceExpertLeaderboard"])
                    this.practiceExpertLeaderboard!.push(PracticeLeaderboardView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLeaderboardsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaderboardsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versusLeaderboard)) {
            data["versusLeaderboard"] = [];
            for (let item of this.versusLeaderboard)
                data["versusLeaderboard"].push(item.toJSON());
        }
        if (Array.isArray(this.practiceEasyLeaderboard)) {
            data["practiceEasyLeaderboard"] = [];
            for (let item of this.practiceEasyLeaderboard)
                data["practiceEasyLeaderboard"].push(item.toJSON());
        }
        if (Array.isArray(this.practiceMediumLeaderboard)) {
            data["practiceMediumLeaderboard"] = [];
            for (let item of this.practiceMediumLeaderboard)
                data["practiceMediumLeaderboard"].push(item.toJSON());
        }
        if (Array.isArray(this.practiceHardLeaderboard)) {
            data["practiceHardLeaderboard"] = [];
            for (let item of this.practiceHardLeaderboard)
                data["practiceHardLeaderboard"].push(item.toJSON());
        }
        if (Array.isArray(this.practiceExpertLeaderboard)) {
            data["practiceExpertLeaderboard"] = [];
            for (let item of this.practiceExpertLeaderboard)
                data["practiceExpertLeaderboard"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLeaderboardsCommandResponse {
        const json = this.toJSON();
        let result = new GetLeaderboardsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetLeaderboardsCommandResponse {
    versusLeaderboard?: IVersusLeaderboardView[] | undefined;
    practiceEasyLeaderboard?: IPracticeLeaderboardView[] | undefined;
    practiceMediumLeaderboard?: IPracticeLeaderboardView[] | undefined;
    practiceHardLeaderboard?: IPracticeLeaderboardView[] | undefined;
    practiceExpertLeaderboard?: IPracticeLeaderboardView[] | undefined;
}

export class SaveCountryCodeCommandRequest implements ISaveCountryCodeCommandRequest {
    countryCode?: string | undefined;

    constructor(data?: ISaveCountryCodeCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): SaveCountryCodeCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCountryCodeCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): SaveCountryCodeCommandRequest {
        const json = this.toJSON();
        let result = new SaveCountryCodeCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveCountryCodeCommandRequest {
    countryCode?: string | undefined;
}

export class SaveCountryCodeCommandResponse implements ISaveCountryCodeCommandResponse {
    success?: boolean;

    constructor(data?: ISaveCountryCodeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SaveCountryCodeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCountryCodeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): SaveCountryCodeCommandResponse {
        const json = this.toJSON();
        let result = new SaveCountryCodeCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveCountryCodeCommandResponse {
    success?: boolean;
}

export class GetAvailableUsernameSearchQueryRequest implements IGetAvailableUsernameSearchQueryRequest {
    searchTerm?: string | undefined;

    constructor(data?: IGetAvailableUsernameSearchQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
        }
    }

    static fromJS(data: any): GetAvailableUsernameSearchQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableUsernameSearchQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        return data;
    }

    clone(): GetAvailableUsernameSearchQueryRequest {
        const json = this.toJSON();
        let result = new GetAvailableUsernameSearchQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAvailableUsernameSearchQueryRequest {
    searchTerm?: string | undefined;
}

export class GetAvailableUsernameSearchQueryResponse implements IGetAvailableUsernameSearchQueryResponse {
    isUsernameAvailable?: boolean;

    constructor(data?: IGetAvailableUsernameSearchQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUsernameAvailable = _data["isUsernameAvailable"];
        }
    }

    static fromJS(data: any): GetAvailableUsernameSearchQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableUsernameSearchQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUsernameAvailable"] = this.isUsernameAvailable;
        return data;
    }

    clone(): GetAvailableUsernameSearchQueryResponse {
        const json = this.toJSON();
        let result = new GetAvailableUsernameSearchQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAvailableUsernameSearchQueryResponse {
    isUsernameAvailable?: boolean;
}

export class UpdateUsernameCommandRequest implements IUpdateUsernameCommandRequest {
    newUsername?: string | undefined;

    constructor(data?: IUpdateUsernameCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUsername = _data["newUsername"];
        }
    }

    static fromJS(data: any): UpdateUsernameCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUsernameCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUsername"] = this.newUsername;
        return data;
    }

    clone(): UpdateUsernameCommandRequest {
        const json = this.toJSON();
        let result = new UpdateUsernameCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUsernameCommandRequest {
    newUsername?: string | undefined;
}

export class UpdateUsernameCommandResponse implements IUpdateUsernameCommandResponse {
    success?: boolean;
    wasUsernameChanged?: boolean;

    constructor(data?: IUpdateUsernameCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.wasUsernameChanged = _data["wasUsernameChanged"];
        }
    }

    static fromJS(data: any): UpdateUsernameCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUsernameCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["wasUsernameChanged"] = this.wasUsernameChanged;
        return data;
    }

    clone(): UpdateUsernameCommandResponse {
        const json = this.toJSON();
        let result = new UpdateUsernameCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUsernameCommandResponse {
    success?: boolean;
    wasUsernameChanged?: boolean;
}

export class GetPlayerInfoByIdCommandRequest implements IGetPlayerInfoByIdCommandRequest {
    userId?: string | undefined;

    constructor(data?: IGetPlayerInfoByIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetPlayerInfoByIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerInfoByIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }

    clone(): GetPlayerInfoByIdCommandRequest {
        const json = this.toJSON();
        let result = new GetPlayerInfoByIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerInfoByIdCommandRequest {
    userId?: string | undefined;
}

export class GetPlayerInfoByIdCommandResponse implements IGetPlayerInfoByIdCommandResponse {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    readonly icon?: number | undefined;
    countryCode?: string | undefined;
    rank?: PlayerRank;
    rankScore?: number;
    totalGamesPlayed?: number;
    totalGamesWon?: number;
    winPercentage?: string | undefined;
    last10Games?: string | undefined;
    isPlayerFriendStatus?: boolean;

    constructor(data?: IGetPlayerInfoByIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            (<any>this).icon = _data["icon"];
            this.countryCode = _data["countryCode"];
            this.rank = _data["rank"];
            this.rankScore = _data["rankScore"];
            this.totalGamesPlayed = _data["totalGamesPlayed"];
            this.totalGamesWon = _data["totalGamesWon"];
            this.winPercentage = _data["winPercentage"];
            this.last10Games = _data["last10Games"];
            this.isPlayerFriendStatus = _data["isPlayerFriendStatus"];
        }
    }

    static fromJS(data: any): GetPlayerInfoByIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerInfoByIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["icon"] = this.icon;
        data["countryCode"] = this.countryCode;
        data["rank"] = this.rank;
        data["rankScore"] = this.rankScore;
        data["totalGamesPlayed"] = this.totalGamesPlayed;
        data["totalGamesWon"] = this.totalGamesWon;
        data["winPercentage"] = this.winPercentage;
        data["last10Games"] = this.last10Games;
        data["isPlayerFriendStatus"] = this.isPlayerFriendStatus;
        return data;
    }

    clone(): GetPlayerInfoByIdCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerInfoByIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerInfoByIdCommandResponse {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    icon?: number | undefined;
    countryCode?: string | undefined;
    rank?: PlayerRank;
    rankScore?: number;
    totalGamesPlayed?: number;
    totalGamesWon?: number;
    winPercentage?: string | undefined;
    last10Games?: string | undefined;
    isPlayerFriendStatus?: boolean;
}

export class UpdateUserIconCommandRequest implements IUpdateUserIconCommandRequest {
    iconNumber?: number | undefined;

    constructor(data?: IUpdateUserIconCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iconNumber = _data["iconNumber"];
        }
    }

    static fromJS(data: any): UpdateUserIconCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserIconCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconNumber"] = this.iconNumber;
        return data;
    }

    clone(): UpdateUserIconCommandRequest {
        const json = this.toJSON();
        let result = new UpdateUserIconCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserIconCommandRequest {
    iconNumber?: number | undefined;
}

export class UpdateUserIconCommandResponse implements IUpdateUserIconCommandResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IUpdateUserIconCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateUserIconCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserIconCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }

    clone(): UpdateUserIconCommandResponse {
        const json = this.toJSON();
        let result = new UpdateUserIconCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserIconCommandResponse {
    success?: boolean;
    message?: string | undefined;
}

export class PublicPromotionItem implements IPublicPromotionItem {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    requirements?: string | undefined;
    prizeImg?: string | undefined;

    constructor(data?: IPublicPromotionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.requirements = _data["requirements"];
            this.prizeImg = _data["prizeImg"];
        }
    }

    static fromJS(data: any): PublicPromotionItem {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPromotionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["requirements"] = this.requirements;
        data["prizeImg"] = this.prizeImg;
        return data;
    }

    clone(): PublicPromotionItem {
        const json = this.toJSON();
        let result = new PublicPromotionItem();
        result.init(json);
        return result;
    }
}

export interface IPublicPromotionItem {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    requirements?: string | undefined;
    prizeImg?: string | undefined;
}

export class GetPublicPromotionsCommandResponse implements IGetPublicPromotionsCommandResponse {
    promotions?: PublicPromotionItem[] | undefined;

    constructor(data?: IGetPublicPromotionsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.promotions) {
                this.promotions = [];
                for (let i = 0; i < data.promotions.length; i++) {
                    let item = data.promotions[i];
                    this.promotions[i] = item && !(<any>item).toJSON ? new PublicPromotionItem(item) : <PublicPromotionItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions!.push(PublicPromotionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicPromotionsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicPromotionsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPublicPromotionsCommandResponse {
        const json = this.toJSON();
        let result = new GetPublicPromotionsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPublicPromotionsCommandResponse {
    promotions?: IPublicPromotionItem[] | undefined;
}

export class LoginCommandRequest implements ILoginCommandRequest {
    username?: string | undefined;
    fcmToken?: string | undefined;
    password?: string | undefined;
    locale?: string | undefined;

    constructor(data?: ILoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.fcmToken = _data["fcmToken"];
            this.password = _data["password"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): LoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fcmToken"] = this.fcmToken;
        data["password"] = this.password;
        data["locale"] = this.locale;
        return data;
    }

    clone(): LoginCommandRequest {
        const json = this.toJSON();
        let result = new LoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandRequest {
    username?: string | undefined;
    fcmToken?: string | undefined;
    password?: string | undefined;
    locale?: string | undefined;
}

export class MiniSubscriptionModel implements IMiniSubscriptionModel {
    id?: string;
    productId?: string | undefined;
    productName?: string | undefined;
    productDescription?: string | undefined;
    expiryDate?: string;
    autoRenew?: boolean;

    constructor(data?: IMiniSubscriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productDescription = _data["productDescription"];
            this.expiryDate = _data["expiryDate"];
            this.autoRenew = _data["autoRenew"];
        }
    }

    static fromJS(data: any): MiniSubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MiniSubscriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productDescription"] = this.productDescription;
        data["expiryDate"] = this.expiryDate;
        data["autoRenew"] = this.autoRenew;
        return data;
    }

    clone(): MiniSubscriptionModel {
        const json = this.toJSON();
        let result = new MiniSubscriptionModel();
        result.init(json);
        return result;
    }
}

export interface IMiniSubscriptionModel {
    id?: string;
    productId?: string | undefined;
    productName?: string | undefined;
    productDescription?: string | undefined;
    expiryDate?: string;
    autoRenew?: boolean;
}

export class StreakInfo implements IStreakInfo {
    current?: number;
    best?: number;
    lastPlayed?: string | undefined;
    completedToday?: boolean;

    constructor(data?: IStreakInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"];
            this.best = _data["best"];
            this.lastPlayed = _data["lastPlayed"];
            this.completedToday = _data["completedToday"];
        }
    }

    static fromJS(data: any): StreakInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StreakInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["best"] = this.best;
        data["lastPlayed"] = this.lastPlayed;
        data["completedToday"] = this.completedToday;
        return data;
    }

    clone(): StreakInfo {
        const json = this.toJSON();
        let result = new StreakInfo();
        result.init(json);
        return result;
    }
}

export interface IStreakInfo {
    current?: number;
    best?: number;
    lastPlayed?: string | undefined;
    completedToday?: boolean;
}

export class GameModeStreak implements IGameModeStreak {
    winStreak?: StreakInfo | undefined;
    playStreak?: StreakInfo | undefined;

    constructor(data?: IGameModeStreak) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.winStreak = data.winStreak && !(<any>data.winStreak).toJSON ? new StreakInfo(data.winStreak) : <StreakInfo>this.winStreak;
            this.playStreak = data.playStreak && !(<any>data.playStreak).toJSON ? new StreakInfo(data.playStreak) : <StreakInfo>this.playStreak;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.winStreak = _data["winStreak"] ? StreakInfo.fromJS(_data["winStreak"]) : <any>undefined;
            this.playStreak = _data["playStreak"] ? StreakInfo.fromJS(_data["playStreak"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GameModeStreak {
        data = typeof data === 'object' ? data : {};
        let result = new GameModeStreak();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["winStreak"] = this.winStreak ? this.winStreak.toJSON() : <any>undefined;
        data["playStreak"] = this.playStreak ? this.playStreak.toJSON() : <any>undefined;
        return data;
    }

    clone(): GameModeStreak {
        const json = this.toJSON();
        let result = new GameModeStreak();
        result.init(json);
        return result;
    }
}

export interface IGameModeStreak {
    winStreak?: IStreakInfo | undefined;
    playStreak?: IStreakInfo | undefined;
}

export class PlayerStreakModel implements IPlayerStreakModel {
    dailyChallenge?: GameModeStreak | undefined;
    singlePlayer?: GameModeStreak | undefined;
    versus?: GameModeStreak | undefined;

    constructor(data?: IPlayerStreakModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dailyChallenge = data.dailyChallenge && !(<any>data.dailyChallenge).toJSON ? new GameModeStreak(data.dailyChallenge) : <GameModeStreak>this.dailyChallenge;
            this.singlePlayer = data.singlePlayer && !(<any>data.singlePlayer).toJSON ? new GameModeStreak(data.singlePlayer) : <GameModeStreak>this.singlePlayer;
            this.versus = data.versus && !(<any>data.versus).toJSON ? new GameModeStreak(data.versus) : <GameModeStreak>this.versus;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyChallenge = _data["dailyChallenge"] ? GameModeStreak.fromJS(_data["dailyChallenge"]) : <any>undefined;
            this.singlePlayer = _data["singlePlayer"] ? GameModeStreak.fromJS(_data["singlePlayer"]) : <any>undefined;
            this.versus = _data["versus"] ? GameModeStreak.fromJS(_data["versus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerStreakModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStreakModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyChallenge"] = this.dailyChallenge ? this.dailyChallenge.toJSON() : <any>undefined;
        data["singlePlayer"] = this.singlePlayer ? this.singlePlayer.toJSON() : <any>undefined;
        data["versus"] = this.versus ? this.versus.toJSON() : <any>undefined;
        return data;
    }

    clone(): PlayerStreakModel {
        const json = this.toJSON();
        let result = new PlayerStreakModel();
        result.init(json);
        return result;
    }
}

export interface IPlayerStreakModel {
    dailyChallenge?: IGameModeStreak | undefined;
    singlePlayer?: IGameModeStreak | undefined;
    versus?: IGameModeStreak | undefined;
}

export class LoginCommandResponse implements ILoginCommandResponse {
    readonly username?: string | undefined;
    readonly email?: string | undefined;
    readonly firstName?: string | undefined;
    readonly lastName?: string | undefined;
    readonly loggedIn?: boolean;
    readonly userId?: string | undefined;
    readonly accessTokenExpiresIn?: number;
    readonly accessToken?: string | undefined;
    readonly rankScore?: number;
    readonly rankName?: string | undefined;
    readonly pointsToNextRank?: number;
    readonly nextRankName?: string | undefined;
    readonly percentageToNextRank?: number;
    readonly hints?: number;
    readonly boards?: number;
    readonly moreTime?: number;
    readonly noAds?: boolean;
    readonly subscriptions?: MiniSubscriptionModel[] | undefined;
    readonly streaks?: PlayerStreakModel | undefined;
    readonly signUpMediumUsed?: SignUpMedium;
    readonly dailyGameCompleted?: boolean;

    constructor(data?: ILoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subscriptions) {
                this.subscriptions = [];
                for (let i = 0; i < data.subscriptions.length; i++) {
                    let item = data.subscriptions[i];
                    this.subscriptions[i] = item && !(<any>item).toJSON ? new MiniSubscriptionModel(item) : <MiniSubscriptionModel>item;
                }
            }
            this.streaks = data.streaks && !(<any>data.streaks).toJSON ? new PlayerStreakModel(data.streaks) : <PlayerStreakModel>this.streaks;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).username = _data["username"];
            (<any>this).email = _data["email"];
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
            (<any>this).loggedIn = _data["loggedIn"];
            (<any>this).userId = _data["userId"];
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).accessToken = _data["accessToken"];
            (<any>this).rankScore = _data["rankScore"];
            (<any>this).rankName = _data["rankName"];
            (<any>this).pointsToNextRank = _data["pointsToNextRank"];
            (<any>this).nextRankName = _data["nextRankName"];
            (<any>this).percentageToNextRank = _data["percentageToNextRank"];
            (<any>this).hints = _data["hints"];
            (<any>this).boards = _data["boards"];
            (<any>this).moreTime = _data["moreTime"];
            (<any>this).noAds = _data["noAds"];
            if (Array.isArray(_data["subscriptions"])) {
                (<any>this).subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    (<any>this).subscriptions!.push(MiniSubscriptionModel.fromJS(item));
            }
            (<any>this).streaks = _data["streaks"] ? PlayerStreakModel.fromJS(_data["streaks"]) : <any>undefined;
            (<any>this).signUpMediumUsed = _data["signUpMediumUsed"];
            (<any>this).dailyGameCompleted = _data["dailyGameCompleted"];
        }
    }

    static fromJS(data: any): LoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loggedIn"] = this.loggedIn;
        data["userId"] = this.userId;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["pointsToNextRank"] = this.pointsToNextRank;
        data["nextRankName"] = this.nextRankName;
        data["percentageToNextRank"] = this.percentageToNextRank;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["moreTime"] = this.moreTime;
        data["noAds"] = this.noAds;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        data["streaks"] = this.streaks ? this.streaks.toJSON() : <any>undefined;
        data["signUpMediumUsed"] = this.signUpMediumUsed;
        data["dailyGameCompleted"] = this.dailyGameCompleted;
        return data;
    }

    clone(): LoginCommandResponse {
        const json = this.toJSON();
        let result = new LoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandResponse {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    rankScore?: number;
    rankName?: string | undefined;
    pointsToNextRank?: number;
    nextRankName?: string | undefined;
    percentageToNextRank?: number;
    hints?: number;
    boards?: number;
    moreTime?: number;
    noAds?: boolean;
    subscriptions?: IMiniSubscriptionModel[] | undefined;
    streaks?: IPlayerStreakModel | undefined;
    signUpMediumUsed?: SignUpMedium;
    dailyGameCompleted?: boolean;
}

export class DeletePlayerDataCommandRequest implements IDeletePlayerDataCommandRequest {
    username?: string | undefined;

    constructor(data?: IDeletePlayerDataCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): DeletePlayerDataCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlayerDataCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }

    clone(): DeletePlayerDataCommandRequest {
        const json = this.toJSON();
        let result = new DeletePlayerDataCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IDeletePlayerDataCommandRequest {
    username?: string | undefined;
}

export class DeletePlayerDataCommandResponse implements IDeletePlayerDataCommandResponse {
    readonly playerId?: string;
    readonly message?: string | undefined;

    constructor(data?: IDeletePlayerDataCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).playerId = _data["playerId"];
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): DeletePlayerDataCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlayerDataCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["message"] = this.message;
        return data;
    }

    clone(): DeletePlayerDataCommandResponse {
        const json = this.toJSON();
        let result = new DeletePlayerDataCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IDeletePlayerDataCommandResponse {
    playerId?: string;
    message?: string | undefined;
}

export class RegisterCommandRequest implements IRegisterCommandRequest {
    fcmToken?: string | undefined;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    email?: string | undefined;
    mediumUsed?: SignUpMedium;
    ageBracket?: AgeBracket;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    referenceCode?: string | undefined;
    readonly rankScore?: number;
    readonly rankName?: string | undefined;
    readonly hints?: number;
    readonly boards?: number;
    locale?: string | undefined;

    constructor(data?: IRegisterCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmToken = _data["fcmToken"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.password = _data["password"];
            this.deviceName = _data["deviceName"];
            this.deviceId = _data["deviceId"];
            this.email = _data["email"];
            this.mediumUsed = _data["mediumUsed"];
            this.ageBracket = _data["ageBracket"];
            this.accessToken = _data["accessToken"];
            this.externalUserId = _data["externalUserId"];
            this.referenceCode = _data["referenceCode"];
            (<any>this).rankScore = _data["rankScore"];
            (<any>this).rankName = _data["rankName"];
            (<any>this).hints = _data["hints"];
            (<any>this).boards = _data["boards"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): RegisterCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmToken"] = this.fcmToken;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["password"] = this.password;
        data["deviceName"] = this.deviceName;
        data["deviceId"] = this.deviceId;
        data["email"] = this.email;
        data["mediumUsed"] = this.mediumUsed;
        data["ageBracket"] = this.ageBracket;
        data["accessToken"] = this.accessToken;
        data["externalUserId"] = this.externalUserId;
        data["referenceCode"] = this.referenceCode;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["locale"] = this.locale;
        return data;
    }

    clone(): RegisterCommandRequest {
        const json = this.toJSON();
        let result = new RegisterCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterCommandRequest {
    fcmToken?: string | undefined;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    email?: string | undefined;
    mediumUsed?: SignUpMedium;
    ageBracket?: AgeBracket;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    referenceCode?: string | undefined;
    rankScore?: number;
    rankName?: string | undefined;
    hints?: number;
    boards?: number;
    locale?: string | undefined;
}

export class RegisterResponseModel implements IRegisterResponseModel {
    readonly deviceID?: string | undefined;
    readonly deviceIdentifier?: string | undefined;
    readonly username?: string | undefined;
    readonly firstName?: string | undefined;
    readonly lastName?: string | undefined;
    readonly loggedIn?: boolean;
    readonly messages?: string | undefined;
    readonly userId?: string | undefined;
    readonly rankScore?: number;
    readonly rankName?: string | undefined;
    readonly hints?: number;
    readonly boards?: number;
    readonly moreTime?: number;
    readonly noAds?: boolean;
    readonly subscriptions?: MiniSubscriptionModel[] | undefined;
    readonly streaks?: PlayerStreakModel | undefined;
    readonly accessTokenExpiresIn?: number;
    readonly accessToken?: string | undefined;
    readonly dailyGameCompleted?: boolean;

    constructor(data?: IRegisterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subscriptions) {
                this.subscriptions = [];
                for (let i = 0; i < data.subscriptions.length; i++) {
                    let item = data.subscriptions[i];
                    this.subscriptions[i] = item && !(<any>item).toJSON ? new MiniSubscriptionModel(item) : <MiniSubscriptionModel>item;
                }
            }
            this.streaks = data.streaks && !(<any>data.streaks).toJSON ? new PlayerStreakModel(data.streaks) : <PlayerStreakModel>this.streaks;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).deviceID = _data["deviceID"];
            (<any>this).deviceIdentifier = _data["deviceIdentifier"];
            (<any>this).username = _data["username"];
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
            (<any>this).loggedIn = _data["loggedIn"];
            (<any>this).messages = _data["messages"];
            (<any>this).userId = _data["userId"];
            (<any>this).rankScore = _data["rankScore"];
            (<any>this).rankName = _data["rankName"];
            (<any>this).hints = _data["hints"];
            (<any>this).boards = _data["boards"];
            (<any>this).moreTime = _data["moreTime"];
            (<any>this).noAds = _data["noAds"];
            if (Array.isArray(_data["subscriptions"])) {
                (<any>this).subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    (<any>this).subscriptions!.push(MiniSubscriptionModel.fromJS(item));
            }
            (<any>this).streaks = _data["streaks"] ? PlayerStreakModel.fromJS(_data["streaks"]) : <any>undefined;
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).accessToken = _data["accessToken"];
            (<any>this).dailyGameCompleted = _data["dailyGameCompleted"];
        }
    }

    static fromJS(data: any): RegisterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceID"] = this.deviceID;
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loggedIn"] = this.loggedIn;
        data["messages"] = this.messages;
        data["userId"] = this.userId;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["moreTime"] = this.moreTime;
        data["noAds"] = this.noAds;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        data["streaks"] = this.streaks ? this.streaks.toJSON() : <any>undefined;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["dailyGameCompleted"] = this.dailyGameCompleted;
        return data;
    }

    clone(): RegisterResponseModel {
        const json = this.toJSON();
        let result = new RegisterResponseModel();
        result.init(json);
        return result;
    }
}

export interface IRegisterResponseModel {
    deviceID?: string | undefined;
    deviceIdentifier?: string | undefined;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    messages?: string | undefined;
    userId?: string | undefined;
    rankScore?: number;
    rankName?: string | undefined;
    hints?: number;
    boards?: number;
    moreTime?: number;
    noAds?: boolean;
    subscriptions?: IMiniSubscriptionModel[] | undefined;
    streaks?: IPlayerStreakModel | undefined;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    dailyGameCompleted?: boolean;
}

export class RegisterAppleCommandRequest implements IRegisterAppleCommandRequest {
    fcmToken?: string | undefined;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    email?: string | undefined;
    ageBracket?: AgeBracket;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    referenceCode?: string | undefined;
    locale?: string | undefined;

    constructor(data?: IRegisterAppleCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmToken = _data["fcmToken"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.password = _data["password"];
            this.deviceName = _data["deviceName"];
            this.deviceId = _data["deviceId"];
            this.email = _data["email"];
            this.ageBracket = _data["ageBracket"];
            this.accessToken = _data["accessToken"];
            this.externalUserId = _data["externalUserId"];
            this.referenceCode = _data["referenceCode"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): RegisterAppleCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAppleCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmToken"] = this.fcmToken;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["password"] = this.password;
        data["deviceName"] = this.deviceName;
        data["deviceId"] = this.deviceId;
        data["email"] = this.email;
        data["ageBracket"] = this.ageBracket;
        data["accessToken"] = this.accessToken;
        data["externalUserId"] = this.externalUserId;
        data["referenceCode"] = this.referenceCode;
        data["locale"] = this.locale;
        return data;
    }

    clone(): RegisterAppleCommandRequest {
        const json = this.toJSON();
        let result = new RegisterAppleCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterAppleCommandRequest {
    fcmToken?: string | undefined;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    password?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    email?: string | undefined;
    ageBracket?: AgeBracket;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    referenceCode?: string | undefined;
    locale?: string | undefined;
}

export class RegisterGuestCommandRequest implements IRegisterGuestCommandRequest {
    fcmToken?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    userId?: string | undefined;
    locale?: string | undefined;

    constructor(data?: IRegisterGuestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmToken = _data["fcmToken"];
            this.deviceName = _data["deviceName"];
            this.deviceId = _data["deviceId"];
            this.userId = _data["userId"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): RegisterGuestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterGuestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmToken"] = this.fcmToken;
        data["deviceName"] = this.deviceName;
        data["deviceId"] = this.deviceId;
        data["userId"] = this.userId;
        data["locale"] = this.locale;
        return data;
    }

    clone(): RegisterGuestCommandRequest {
        const json = this.toJSON();
        let result = new RegisterGuestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterGuestCommandRequest {
    fcmToken?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    userId?: string | undefined;
    locale?: string | undefined;
}

export class RegisterGuestResponseModel implements IRegisterGuestResponseModel {
    readonly deviceID?: string | undefined;
    readonly deviceIdentifier?: string | undefined;
    readonly username?: string | undefined;
    readonly loggedIn?: boolean;
    readonly messages?: string | undefined;
    readonly guestId?: string | undefined;
    readonly rankScore?: number;
    readonly rankName?: string | undefined;
    readonly hints?: number;
    readonly boards?: number;
    readonly moreTime?: number;
    readonly noAds?: boolean;
    readonly subscriptions?: MiniSubscriptionModel[] | undefined;
    readonly accessTokenExpiresIn?: number;
    readonly streaks?: PlayerStreakModel | undefined;
    readonly accessToken?: string | undefined;
    readonly dailyGameCompleted?: boolean;

    constructor(data?: IRegisterGuestResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subscriptions) {
                this.subscriptions = [];
                for (let i = 0; i < data.subscriptions.length; i++) {
                    let item = data.subscriptions[i];
                    this.subscriptions[i] = item && !(<any>item).toJSON ? new MiniSubscriptionModel(item) : <MiniSubscriptionModel>item;
                }
            }
            this.streaks = data.streaks && !(<any>data.streaks).toJSON ? new PlayerStreakModel(data.streaks) : <PlayerStreakModel>this.streaks;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).deviceID = _data["deviceID"];
            (<any>this).deviceIdentifier = _data["deviceIdentifier"];
            (<any>this).username = _data["username"];
            (<any>this).loggedIn = _data["loggedIn"];
            (<any>this).messages = _data["messages"];
            (<any>this).guestId = _data["guestId"];
            (<any>this).rankScore = _data["rankScore"];
            (<any>this).rankName = _data["rankName"];
            (<any>this).hints = _data["hints"];
            (<any>this).boards = _data["boards"];
            (<any>this).moreTime = _data["moreTime"];
            (<any>this).noAds = _data["noAds"];
            if (Array.isArray(_data["subscriptions"])) {
                (<any>this).subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    (<any>this).subscriptions!.push(MiniSubscriptionModel.fromJS(item));
            }
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).streaks = _data["streaks"] ? PlayerStreakModel.fromJS(_data["streaks"]) : <any>undefined;
            (<any>this).accessToken = _data["accessToken"];
            (<any>this).dailyGameCompleted = _data["dailyGameCompleted"];
        }
    }

    static fromJS(data: any): RegisterGuestResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterGuestResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceID"] = this.deviceID;
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["username"] = this.username;
        data["loggedIn"] = this.loggedIn;
        data["messages"] = this.messages;
        data["guestId"] = this.guestId;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["moreTime"] = this.moreTime;
        data["noAds"] = this.noAds;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["streaks"] = this.streaks ? this.streaks.toJSON() : <any>undefined;
        data["accessToken"] = this.accessToken;
        data["dailyGameCompleted"] = this.dailyGameCompleted;
        return data;
    }

    clone(): RegisterGuestResponseModel {
        const json = this.toJSON();
        let result = new RegisterGuestResponseModel();
        result.init(json);
        return result;
    }
}

export interface IRegisterGuestResponseModel {
    deviceID?: string | undefined;
    deviceIdentifier?: string | undefined;
    username?: string | undefined;
    loggedIn?: boolean;
    messages?: string | undefined;
    guestId?: string | undefined;
    rankScore?: number;
    rankName?: string | undefined;
    hints?: number;
    boards?: number;
    moreTime?: number;
    noAds?: boolean;
    subscriptions?: IMiniSubscriptionModel[] | undefined;
    accessTokenExpiresIn?: number;
    streaks?: IPlayerStreakModel | undefined;
    accessToken?: string | undefined;
    dailyGameCompleted?: boolean;
}

export class RequestDeletePlayerDataCommandRequest implements IRequestDeletePlayerDataCommandRequest {
    email?: string | undefined;

    constructor(data?: IRequestDeletePlayerDataCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestDeletePlayerDataCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDeletePlayerDataCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): RequestDeletePlayerDataCommandRequest {
        const json = this.toJSON();
        let result = new RequestDeletePlayerDataCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRequestDeletePlayerDataCommandRequest {
    email?: string | undefined;
}

export class RequestDeletePlayerDataCommandResponse implements IRequestDeletePlayerDataCommandResponse {
    readonly message?: string | undefined;

    constructor(data?: IRequestDeletePlayerDataCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): RequestDeletePlayerDataCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDeletePlayerDataCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }

    clone(): RequestDeletePlayerDataCommandResponse {
        const json = this.toJSON();
        let result = new RequestDeletePlayerDataCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRequestDeletePlayerDataCommandResponse {
    message?: string | undefined;
}

export class LinkGuestAccountCommandRequest implements ILinkGuestAccountCommandRequest {
    guestUserId?: string | undefined;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    mediumUsed?: SignUpMedium;
    fcmToken?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    locale?: string | undefined;

    constructor(data?: ILinkGuestAccountCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guestUserId = _data["guestUserId"];
            this.username = _data["username"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.accessToken = _data["accessToken"];
            this.externalUserId = _data["externalUserId"];
            this.mediumUsed = _data["mediumUsed"];
            this.fcmToken = _data["fcmToken"];
            this.deviceName = _data["deviceName"];
            this.deviceId = _data["deviceId"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): LinkGuestAccountCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkGuestAccountCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestUserId"] = this.guestUserId;
        data["username"] = this.username;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["password"] = this.password;
        data["accessToken"] = this.accessToken;
        data["externalUserId"] = this.externalUserId;
        data["mediumUsed"] = this.mediumUsed;
        data["fcmToken"] = this.fcmToken;
        data["deviceName"] = this.deviceName;
        data["deviceId"] = this.deviceId;
        data["locale"] = this.locale;
        return data;
    }

    clone(): LinkGuestAccountCommandRequest {
        const json = this.toJSON();
        let result = new LinkGuestAccountCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ILinkGuestAccountCommandRequest {
    guestUserId?: string | undefined;
    username?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    mediumUsed?: SignUpMedium;
    fcmToken?: string | undefined;
    deviceName?: string | undefined;
    deviceId?: string | undefined;
    locale?: string | undefined;
}

export class LinkGuestAccountCommandResponse implements ILinkGuestAccountCommandResponse {
    readonly deviceID?: string | undefined;
    readonly deviceIdentifier?: string | undefined;
    readonly username?: string | undefined;
    readonly firstName?: string | undefined;
    readonly lastName?: string | undefined;
    readonly email?: string | undefined;
    readonly loggedIn?: boolean;
    readonly messages?: string | undefined;
    readonly userId?: string | undefined;
    readonly accessTokenExpiresIn?: number;
    readonly accessToken?: string | undefined;
    readonly rankScore?: number;
    readonly rankName?: string | undefined;
    readonly pointsToNextRank?: number;
    readonly nextRankName?: string | undefined;
    readonly percentageToNextRank?: number;
    readonly hints?: number;
    readonly boards?: number;
    readonly moreTime?: number;
    readonly noAds?: boolean;
    readonly subscriptions?: MiniSubscriptionModel[] | undefined;
    readonly signUpMediumUsed?: SignUpMedium;
    readonly dailyGameCompleted?: boolean;

    constructor(data?: ILinkGuestAccountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subscriptions) {
                this.subscriptions = [];
                for (let i = 0; i < data.subscriptions.length; i++) {
                    let item = data.subscriptions[i];
                    this.subscriptions[i] = item && !(<any>item).toJSON ? new MiniSubscriptionModel(item) : <MiniSubscriptionModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).deviceID = _data["deviceID"];
            (<any>this).deviceIdentifier = _data["deviceIdentifier"];
            (<any>this).username = _data["username"];
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
            (<any>this).email = _data["email"];
            (<any>this).loggedIn = _data["loggedIn"];
            (<any>this).messages = _data["messages"];
            (<any>this).userId = _data["userId"];
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).accessToken = _data["accessToken"];
            (<any>this).rankScore = _data["rankScore"];
            (<any>this).rankName = _data["rankName"];
            (<any>this).pointsToNextRank = _data["pointsToNextRank"];
            (<any>this).nextRankName = _data["nextRankName"];
            (<any>this).percentageToNextRank = _data["percentageToNextRank"];
            (<any>this).hints = _data["hints"];
            (<any>this).boards = _data["boards"];
            (<any>this).moreTime = _data["moreTime"];
            (<any>this).noAds = _data["noAds"];
            if (Array.isArray(_data["subscriptions"])) {
                (<any>this).subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    (<any>this).subscriptions!.push(MiniSubscriptionModel.fromJS(item));
            }
            (<any>this).signUpMediumUsed = _data["signUpMediumUsed"];
            (<any>this).dailyGameCompleted = _data["dailyGameCompleted"];
        }
    }

    static fromJS(data: any): LinkGuestAccountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkGuestAccountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceID"] = this.deviceID;
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["loggedIn"] = this.loggedIn;
        data["messages"] = this.messages;
        data["userId"] = this.userId;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["pointsToNextRank"] = this.pointsToNextRank;
        data["nextRankName"] = this.nextRankName;
        data["percentageToNextRank"] = this.percentageToNextRank;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["moreTime"] = this.moreTime;
        data["noAds"] = this.noAds;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        data["signUpMediumUsed"] = this.signUpMediumUsed;
        data["dailyGameCompleted"] = this.dailyGameCompleted;
        return data;
    }

    clone(): LinkGuestAccountCommandResponse {
        const json = this.toJSON();
        let result = new LinkGuestAccountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ILinkGuestAccountCommandResponse {
    deviceID?: string | undefined;
    deviceIdentifier?: string | undefined;
    username?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    loggedIn?: boolean;
    messages?: string | undefined;
    userId?: string | undefined;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    rankScore?: number;
    rankName?: string | undefined;
    pointsToNextRank?: number;
    nextRankName?: string | undefined;
    percentageToNextRank?: number;
    hints?: number;
    boards?: number;
    moreTime?: number;
    noAds?: boolean;
    subscriptions?: IMiniSubscriptionModel[] | undefined;
    signUpMediumUsed?: SignUpMedium;
    dailyGameCompleted?: boolean;
}

export class LinkedAccountModel implements ILinkedAccountModel {
    provider?: string | undefined;
    externalId?: string | undefined;
    linkedDate?: string;

    constructor(data?: ILinkedAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.externalId = _data["externalId"];
            this.linkedDate = _data["linkedDate"];
        }
    }

    static fromJS(data: any): LinkedAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["externalId"] = this.externalId;
        data["linkedDate"] = this.linkedDate;
        return data;
    }

    clone(): LinkedAccountModel {
        const json = this.toJSON();
        let result = new LinkedAccountModel();
        result.init(json);
        return result;
    }
}

export interface ILinkedAccountModel {
    provider?: string | undefined;
    externalId?: string | undefined;
    linkedDate?: string;
}

export class GetLinkedAccountsQueryResponse implements IGetLinkedAccountsQueryResponse {
    readonly linkedAccounts?: LinkedAccountModel[] | undefined;

    constructor(data?: IGetLinkedAccountsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.linkedAccounts) {
                this.linkedAccounts = [];
                for (let i = 0; i < data.linkedAccounts.length; i++) {
                    let item = data.linkedAccounts[i];
                    this.linkedAccounts[i] = item && !(<any>item).toJSON ? new LinkedAccountModel(item) : <LinkedAccountModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["linkedAccounts"])) {
                (<any>this).linkedAccounts = [] as any;
                for (let item of _data["linkedAccounts"])
                    (<any>this).linkedAccounts!.push(LinkedAccountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLinkedAccountsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinkedAccountsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.linkedAccounts)) {
            data["linkedAccounts"] = [];
            for (let item of this.linkedAccounts)
                data["linkedAccounts"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLinkedAccountsQueryResponse {
        const json = this.toJSON();
        let result = new GetLinkedAccountsQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetLinkedAccountsQueryResponse {
    linkedAccounts?: ILinkedAccountModel[] | undefined;
}

export class AddLinkedAccountCommandRequest implements IAddLinkedAccountCommandRequest {
    provider?: SignUpMedium;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAddLinkedAccountCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.accessToken = _data["accessToken"];
            this.externalUserId = _data["externalUserId"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AddLinkedAccountCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddLinkedAccountCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["accessToken"] = this.accessToken;
        data["externalUserId"] = this.externalUserId;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }

    clone(): AddLinkedAccountCommandRequest {
        const json = this.toJSON();
        let result = new AddLinkedAccountCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddLinkedAccountCommandRequest {
    provider?: SignUpMedium;
    accessToken?: string | undefined;
    externalUserId?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export class AddLinkedAccountCommandResponse implements IAddLinkedAccountCommandResponse {
    readonly success?: boolean;
    readonly message?: string | undefined;
    readonly linkedAccounts?: LinkedAccountModel[] | undefined;

    constructor(data?: IAddLinkedAccountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.linkedAccounts) {
                this.linkedAccounts = [];
                for (let i = 0; i < data.linkedAccounts.length; i++) {
                    let item = data.linkedAccounts[i];
                    this.linkedAccounts[i] = item && !(<any>item).toJSON ? new LinkedAccountModel(item) : <LinkedAccountModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).success = _data["success"];
            (<any>this).message = _data["message"];
            if (Array.isArray(_data["linkedAccounts"])) {
                (<any>this).linkedAccounts = [] as any;
                for (let item of _data["linkedAccounts"])
                    (<any>this).linkedAccounts!.push(LinkedAccountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddLinkedAccountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddLinkedAccountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.linkedAccounts)) {
            data["linkedAccounts"] = [];
            for (let item of this.linkedAccounts)
                data["linkedAccounts"].push(item.toJSON());
        }
        return data;
    }

    clone(): AddLinkedAccountCommandResponse {
        const json = this.toJSON();
        let result = new AddLinkedAccountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddLinkedAccountCommandResponse {
    success?: boolean;
    message?: string | undefined;
    linkedAccounts?: ILinkedAccountModel[] | undefined;
}

export class ForgotPasswordCommandRequest implements IForgotPasswordCommandRequest {
    username?: string | undefined;

    constructor(data?: IForgotPasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ForgotPasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }

    clone(): ForgotPasswordCommandRequest {
        const json = this.toJSON();
        let result = new ForgotPasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordCommandRequest {
    username?: string | undefined;
}

export class EditUserProfileCommandRequest implements IEditUserProfileCommandRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    age?: number | undefined;

    constructor(data?: IEditUserProfileCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.age = _data["age"];
        }
    }

    static fromJS(data: any): EditUserProfileCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserProfileCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["age"] = this.age;
        return data;
    }

    clone(): EditUserProfileCommandRequest {
        const json = this.toJSON();
        let result = new EditUserProfileCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEditUserProfileCommandRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    age?: number | undefined;
}

export class ChangePasswordCommandRequest implements IChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordCommandRequest {
        const json = this.toJSON();
        let result = new ChangePasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class UpdateMarketingOptInCommandRequest implements IUpdateMarketingOptInCommandRequest {
    marketingEmailOptIn?: boolean;

    constructor(data?: IUpdateMarketingOptInCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketingEmailOptIn = _data["marketingEmailOptIn"];
        }
    }

    static fromJS(data: any): UpdateMarketingOptInCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarketingOptInCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingEmailOptIn"] = this.marketingEmailOptIn;
        return data;
    }

    clone(): UpdateMarketingOptInCommandRequest {
        const json = this.toJSON();
        let result = new UpdateMarketingOptInCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateMarketingOptInCommandRequest {
    marketingEmailOptIn?: boolean;
}

export enum ProductType {
    Subscription = "Subscription",
    OneTime = "OneTime",
    Free = "Free",
    AdBased = "AdBased",
}

export class StoreListItem implements IStoreListItem {
    id?: string;
    name?: string | undefined;
    productId?: string | undefined;
    description?: string | undefined;
    type?: ProductType;
    price?: number | undefined;
    validityPeriod?: string | undefined;
    hints?: number;
    boards?: number;
    maxDailyLimit?: number | undefined;

    constructor(data?: IStoreListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.price = _data["price"];
            this.validityPeriod = _data["validityPeriod"];
            this.hints = _data["hints"];
            this.boards = _data["boards"];
            this.maxDailyLimit = _data["maxDailyLimit"];
        }
    }

    static fromJS(data: any): StoreListItem {
        data = typeof data === 'object' ? data : {};
        let result = new StoreListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["description"] = this.description;
        data["type"] = this.type;
        data["price"] = this.price;
        data["validityPeriod"] = this.validityPeriod;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["maxDailyLimit"] = this.maxDailyLimit;
        return data;
    }

    clone(): StoreListItem {
        const json = this.toJSON();
        let result = new StoreListItem();
        result.init(json);
        return result;
    }
}

export interface IStoreListItem {
    id?: string;
    name?: string | undefined;
    productId?: string | undefined;
    description?: string | undefined;
    type?: ProductType;
    price?: number | undefined;
    validityPeriod?: string | undefined;
    hints?: number;
    boards?: number;
    maxDailyLimit?: number | undefined;
}

export class GetProductsCommandResponse implements IGetProductsCommandResponse {
    items?: StoreListItem[] | undefined;

    constructor(data?: IGetProductsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new StoreListItem(item) : <StoreListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StoreListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProductsCommandResponse {
        const json = this.toJSON();
        let result = new GetProductsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProductsCommandResponse {
    items?: IStoreListItem[] | undefined;
}

export class RestorePurchasesCommandResponse implements IRestorePurchasesCommandResponse {
    subscriptions?: string | undefined;
    purchases?: string | undefined;

    constructor(data?: IRestorePurchasesCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptions = _data["subscriptions"];
            this.purchases = _data["purchases"];
        }
    }

    static fromJS(data: any): RestorePurchasesCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestorePurchasesCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptions"] = this.subscriptions;
        data["purchases"] = this.purchases;
        return data;
    }

    clone(): RestorePurchasesCommandResponse {
        const json = this.toJSON();
        let result = new RestorePurchasesCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRestorePurchasesCommandResponse {
    subscriptions?: string | undefined;
    purchases?: string | undefined;
}

export class AddProductCommandRequest implements IAddProductCommandRequest {
    adminAuthCode?: string | undefined;
    name?: string | undefined;
    productId?: string | undefined;
    description?: string | undefined;
    type?: ProductType;
    price?: number | undefined;
    validityPeriodDays?: number | undefined;
    boards?: number;
    hints?: number;
    maxDailyLimit?: number | undefined;
    isActive?: boolean;

    constructor(data?: IAddProductCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminAuthCode = _data["adminAuthCode"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.price = _data["price"];
            this.validityPeriodDays = _data["validityPeriodDays"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.maxDailyLimit = _data["maxDailyLimit"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AddProductCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminAuthCode"] = this.adminAuthCode;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["description"] = this.description;
        data["type"] = this.type;
        data["price"] = this.price;
        data["validityPeriodDays"] = this.validityPeriodDays;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["maxDailyLimit"] = this.maxDailyLimit;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): AddProductCommandRequest {
        const json = this.toJSON();
        let result = new AddProductCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddProductCommandRequest {
    adminAuthCode?: string | undefined;
    name?: string | undefined;
    productId?: string | undefined;
    description?: string | undefined;
    type?: ProductType;
    price?: number | undefined;
    validityPeriodDays?: number | undefined;
    boards?: number;
    hints?: number;
    maxDailyLimit?: number | undefined;
    isActive?: boolean;
}

export class AddProductCommandResponse implements IAddProductCommandResponse {
    id?: string;
    name?: string | undefined;
    productId?: string | undefined;
    description?: string | undefined;
    type?: ProductType;
    price?: number | undefined;
    validityPeriodDays?: number | undefined;
    boards?: number;
    hints?: number;
    maxDailyLimit?: number | undefined;
    isActive?: boolean;

    constructor(data?: IAddProductCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.price = _data["price"];
            this.validityPeriodDays = _data["validityPeriodDays"];
            this.boards = _data["boards"];
            this.hints = _data["hints"];
            this.maxDailyLimit = _data["maxDailyLimit"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AddProductCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["description"] = this.description;
        data["type"] = this.type;
        data["price"] = this.price;
        data["validityPeriodDays"] = this.validityPeriodDays;
        data["boards"] = this.boards;
        data["hints"] = this.hints;
        data["maxDailyLimit"] = this.maxDailyLimit;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): AddProductCommandResponse {
        const json = this.toJSON();
        let result = new AddProductCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddProductCommandResponse {
    id?: string;
    name?: string | undefined;
    productId?: string | undefined;
    description?: string | undefined;
    type?: ProductType;
    price?: number | undefined;
    validityPeriodDays?: number | undefined;
    boards?: number;
    hints?: number;
    maxDailyLimit?: number | undefined;
    isActive?: boolean;
}

export class PurchaseProductCommandRequest implements IPurchaseProductCommandRequest {
    productId?: string | undefined;
    transactionDate?: string | undefined;
    transactionId?: string | undefined;
    receipt?: string | undefined;
    autoRenew?: boolean;

    constructor(data?: IPurchaseProductCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.transactionDate = _data["transactionDate"];
            this.transactionId = _data["transactionId"];
            this.receipt = _data["receipt"];
            this.autoRenew = _data["autoRenew"];
        }
    }

    static fromJS(data: any): PurchaseProductCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseProductCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["transactionDate"] = this.transactionDate;
        data["transactionId"] = this.transactionId;
        data["receipt"] = this.receipt;
        data["autoRenew"] = this.autoRenew;
        return data;
    }

    clone(): PurchaseProductCommandRequest {
        const json = this.toJSON();
        let result = new PurchaseProductCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IPurchaseProductCommandRequest {
    productId?: string | undefined;
    transactionDate?: string | undefined;
    transactionId?: string | undefined;
    receipt?: string | undefined;
    autoRenew?: boolean;
}

export enum TransactionStatus {
    Completed = "Completed",
    Refunded = "Refunded",
    Failed = "Failed",
}

export class PurchaseProductCommandResponse implements IPurchaseProductCommandResponse {
    id?: string;
    status?: TransactionStatus;
    message?: string | undefined;

    constructor(data?: IPurchaseProductCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PurchaseProductCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseProductCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }

    clone(): PurchaseProductCommandResponse {
        const json = this.toJSON();
        let result = new PurchaseProductCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IPurchaseProductCommandResponse {
    id?: string;
    status?: TransactionStatus;
    message?: string | undefined;
}

export class CancelSubscriptionCommandRequest implements ICancelSubscriptionCommandRequest {
    subscriptionId?: string;

    constructor(data?: ICancelSubscriptionCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): CancelSubscriptionCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscriptionCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }

    clone(): CancelSubscriptionCommandRequest {
        const json = this.toJSON();
        let result = new CancelSubscriptionCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICancelSubscriptionCommandRequest {
    subscriptionId?: string;
}

export class CancelSubscriptionCommandResponse implements ICancelSubscriptionCommandResponse {
    productId?: string | undefined;
    expiryDate?: string;
    message?: string | undefined;

    constructor(data?: ICancelSubscriptionCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.expiryDate = _data["expiryDate"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CancelSubscriptionCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscriptionCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["expiryDate"] = this.expiryDate;
        data["message"] = this.message;
        return data;
    }

    clone(): CancelSubscriptionCommandResponse {
        const json = this.toJSON();
        let result = new CancelSubscriptionCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICancelSubscriptionCommandResponse {
    productId?: string | undefined;
    expiryDate?: string;
    message?: string | undefined;
}

export class PublicTutorialItem implements IPublicTutorialItem {
    id?: string | undefined;
    title?: string | undefined;
    videoUrl?: string | undefined;
    category?: string | undefined;

    constructor(data?: IPublicTutorialItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.videoUrl = _data["videoUrl"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): PublicTutorialItem {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTutorialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["videoUrl"] = this.videoUrl;
        data["category"] = this.category;
        return data;
    }

    clone(): PublicTutorialItem {
        const json = this.toJSON();
        let result = new PublicTutorialItem();
        result.init(json);
        return result;
    }
}

export interface IPublicTutorialItem {
    id?: string | undefined;
    title?: string | undefined;
    videoUrl?: string | undefined;
    category?: string | undefined;
}

export class GetPublicTutorialsCommandResponse implements IGetPublicTutorialsCommandResponse {
    videos?: PublicTutorialItem[] | undefined;

    constructor(data?: IGetPublicTutorialsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new PublicTutorialItem(item) : <PublicTutorialItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(PublicTutorialItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublicTutorialsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicTutorialsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPublicTutorialsCommandResponse {
        const json = this.toJSON();
        let result = new GetPublicTutorialsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPublicTutorialsCommandResponse {
    videos?: IPublicTutorialItem[] | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}